/** Do not edit this file */
! function(t) {
    var e = {};

    function i(n) {
        if (e[n]) return e[n].exports;
        var r = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports
    }
    i.m = t, i.c = e, i.d = function(t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        })
    }, i.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, i.t = function(t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var r in t) i.d(n, r, function(e) {
                return t[e]
            }.bind(null, r));
        return n
    }, i.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return i.d(e, "a", e), e
    }, i.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, i.p = "/", i(i.s = 727)
}({
    39: function(t, e, i) {
        "use strict";
        e.parse = function(t, e) {
            if ("string" != typeof t) throw new TypeError("argument str must be a string");
            for (var i = {}, r = e || {}, o = t.split(s), l = r.decode || n, u = 0; u < o.length; u++) {
                var c = o[u],
                    d = c.indexOf("=");
                if (!(d < 0)) {
                    var h = c.substr(0, d).trim(),
                        p = c.substr(++d, c.length).trim();
                    '"' == p[0] && (p = p.slice(1, -1)), null == i[h] && (i[h] = a(p, l))
                }
            }
            return i
        }, e.serialize = function(t, e, i) {
            var n = i || {},
                s = n.encode || r;
            if ("function" != typeof s) throw new TypeError("option encode is invalid");
            if (!o.test(t)) throw new TypeError("argument name is invalid");
            var a = s(e);
            if (a && !o.test(a)) throw new TypeError("argument val is invalid");
            var l = t + "=" + a;
            if (null != n.maxAge) {
                var u = n.maxAge - 0;
                if (isNaN(u) || !isFinite(u)) throw new TypeError("option maxAge is invalid");
                l += "; Max-Age=" + Math.floor(u)
            }
            if (n.domain) {
                if (!o.test(n.domain)) throw new TypeError("option domain is invalid");
                l += "; Domain=" + n.domain
            }
            if (n.path) {
                if (!o.test(n.path)) throw new TypeError("option path is invalid");
                l += "; Path=" + n.path
            }
            if (n.expires) {
                if ("function" != typeof n.expires.toUTCString) throw new TypeError("option expires is invalid");
                l += "; Expires=" + n.expires.toUTCString()
            }
            n.httpOnly && (l += "; HttpOnly");
            n.secure && (l += "; Secure");
            if (n.sameSite) {
                var c = "string" == typeof n.sameSite ? n.sameSite.toLowerCase() : n.sameSite;
                switch (c) {
                    case !0:
                        l += "; SameSite=Strict";
                        break;
                    case "lax":
                        l += "; SameSite=Lax";
                        break;
                    case "strict":
                        l += "; SameSite=Strict";
                        break;
                    case "none":
                        l += "; SameSite=None";
                        break;
                    default:
                        throw new TypeError("option sameSite is invalid")
                }
            }
            return l
        };
        var n = decodeURIComponent,
            r = encodeURIComponent,
            s = /; */,
            o = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

        function a(t, e) {
            try {
                return e(t)
            } catch (e) {
                return t
            }
        }
    },
    44: function(t, e, i) {
        "use strict";
        var n = i(39);

        function r(t, e) {
            void 0 === e && (e = {});
            var i = function(t) {
                if (t && "j" === t[0] && ":" === t[1]) return t.substr(2);
                return t
            }(t);
            if (function(t, e) {
                    return void 0 === e && (e = !t || "{" !== t[0] && "[" !== t[0] && '"' !== t[0]), !e
                }(i, e.doNotParse)) try {
                return JSON.parse(i)
            } catch (t) {}
            return t
        }
        var s = function() {
                return (s = Object.assign || function(t) {
                    for (var e, i = 1, n = arguments.length; i < n; i++)
                        for (var r in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                    return t
                }).apply(this, arguments)
            },
            o = function() {
                function t(t, e) {
                    var i = this;
                    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = function(t, e) {
                        return "string" == typeof t ? n.parse(t, e) : "object" == typeof t && null !== t ? t : {}
                    }(t, e), new Promise(function() {
                        i.HAS_DOCUMENT_COOKIE = "object" == typeof document && "string" == typeof document.cookie
                    }).catch(function() {})
                }
                return t.prototype._updateBrowserValues = function(t) {
                    this.HAS_DOCUMENT_COOKIE && (this.cookies = n.parse(document.cookie, t))
                }, t.prototype._emitChange = function(t) {
                    for (var e = 0; e < this.changeListeners.length; ++e) this.changeListeners[e](t)
                }, t.prototype.get = function(t, e, i) {
                    return void 0 === e && (e = {}), this._updateBrowserValues(i), r(this.cookies[t], e)
                }, t.prototype.getAll = function(t, e) {
                    void 0 === t && (t = {}), this._updateBrowserValues(e);
                    var i = {};
                    for (var n in this.cookies) i[n] = r(this.cookies[n], t);
                    return i
                }, t.prototype.set = function(t, e, i) {
                    var r;
                    "object" == typeof e && (e = JSON.stringify(e)), this.cookies = s(s({}, this.cookies), ((r = {})[t] = e, r)), this.HAS_DOCUMENT_COOKIE && (document.cookie = n.serialize(t, e, i)), this._emitChange({
                        name: t,
                        value: e,
                        options: i
                    })
                }, t.prototype.remove = function(t, e) {
                    var i = e = s(s({}, e), {
                        expires: new Date(1970, 1, 1, 0, 0, 1),
                        maxAge: 0
                    });
                    this.cookies = s({}, this.cookies), delete this.cookies[t], this.HAS_DOCUMENT_COOKIE && (document.cookie = n.serialize(t, "", i)), this._emitChange({
                        name: t,
                        value: void 0,
                        options: e
                    })
                }, t.prototype.addChangeListener = function(t) {
                    this.changeListeners.push(t)
                }, t.prototype.removeChangeListener = function(t) {
                    var e = this.changeListeners.indexOf(t);
                    e >= 0 && this.changeListeners.splice(e, 1)
                }, t
            }();
        e.a = o
    },
    7: function(t, e, i) {
        var n, r, s;
        r = "undefined" != typeof window ? window : this, s = function(i, r) {
            var s = [],
                o = i.document,
                a = s.slice,
                l = s.concat,
                u = s.push,
                c = s.indexOf,
                d = {},
                h = d.toString,
                p = d.hasOwnProperty,
                f = {},
                g = function(t, e) {
                    return new g.fn.init(t, e)
                },
                m = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
                _ = /^-ms-/,
                y = /-([\da-z])/gi,
                v = function(t, e) {
                    return e.toUpperCase()
                };

            function w(t) {
                var e = !!t && "length" in t && t.length,
                    i = g.type(t);
                return "function" !== i && !g.isWindow(t) && ("array" === i || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
            }
            g.fn = g.prototype = {
                jquery: "2.2.4",
                constructor: g,
                selector: "",
                length: 0,
                toArray: function() {
                    return a.call(this)
                },
                get: function(t) {
                    return null != t ? t < 0 ? this[t + this.length] : this[t] : a.call(this)
                },
                pushStack: function(t) {
                    var e = g.merge(this.constructor(), t);
                    return e.prevObject = this, e.context = this.context, e
                },
                each: function(t) {
                    return g.each(this, t)
                },
                map: function(t) {
                    return this.pushStack(g.map(this, function(e, i) {
                        return t.call(e, i, e)
                    }))
                },
                slice: function() {
                    return this.pushStack(a.apply(this, arguments))
                },
                first: function() {
                    return this.eq(0)
                },
                last: function() {
                    return this.eq(-1)
                },
                eq: function(t) {
                    var e = this.length,
                        i = +t + (t < 0 ? e : 0);
                    return this.pushStack(i >= 0 && i < e ? [this[i]] : [])
                },
                end: function() {
                    return this.prevObject || this.constructor()
                },
                push: u,
                sort: s.sort,
                splice: s.splice
            }, g.extend = g.fn.extend = function() {
                var t, e, i, n, r, s, o = arguments[0] || {},
                    a = 1,
                    l = arguments.length,
                    u = !1;
                for ("boolean" == typeof o && (u = o, o = arguments[a] || {}, a++), "object" == typeof o || g.isFunction(o) || (o = {}), a === l && (o = this, a--); a < l; a++)
                    if (null != (t = arguments[a]))
                        for (e in t) i = o[e], o !== (n = t[e]) && (u && n && (g.isPlainObject(n) || (r = g.isArray(n))) ? (r ? (r = !1, s = i && g.isArray(i) ? i : []) : s = i && g.isPlainObject(i) ? i : {}, o[e] = g.extend(u, s, n)) : void 0 !== n && (o[e] = n));
                return o
            }, g.extend({
                expando: "jQuery" + ("2.2.4" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function(t) {
                    throw new Error(t)
                },
                noop: function() {},
                isFunction: function(t) {
                    return "function" === g.type(t)
                },
                isArray: Array.isArray,
                isWindow: function(t) {
                    return null != t && t === t.window
                },
                isNumeric: function(t) {
                    var e = t && t.toString();
                    return !g.isArray(t) && e - parseFloat(e) + 1 >= 0
                },
                isPlainObject: function(t) {
                    var e;
                    if ("object" !== g.type(t) || t.nodeType || g.isWindow(t)) return !1;
                    if (t.constructor && !p.call(t, "constructor") && !p.call(t.constructor.prototype || {}, "isPrototypeOf")) return !1;
                    for (e in t);
                    return void 0 === e || p.call(t, e)
                },
                isEmptyObject: function(t) {
                    var e;
                    for (e in t) return !1;
                    return !0
                },
                type: function(t) {
                    return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? d[h.call(t)] || "object" : typeof t
                },
                globalEval: function(t) {
                    var e, i = eval;
                    (t = g.trim(t)) && (1 === t.indexOf("use strict") ? ((e = o.createElement("script")).text = t, o.head.appendChild(e).parentNode.removeChild(e)) : i(t))
                },
                camelCase: function(t) {
                    return t.replace(_, "ms-").replace(y, v)
                },
                nodeName: function(t, e) {
                    return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
                },
                each: function(t, e) {
                    var i, n = 0;
                    if (w(t))
                        for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
                    else
                        for (n in t)
                            if (!1 === e.call(t[n], n, t[n])) break;
                    return t
                },
                trim: function(t) {
                    return null == t ? "" : (t + "").replace(m, "")
                },
                makeArray: function(t, e) {
                    var i = e || [];
                    return null != t && (w(Object(t)) ? g.merge(i, "string" == typeof t ? [t] : t) : u.call(i, t)), i
                },
                inArray: function(t, e, i) {
                    return null == e ? -1 : c.call(e, t, i)
                },
                merge: function(t, e) {
                    for (var i = +e.length, n = 0, r = t.length; n < i; n++) t[r++] = e[n];
                    return t.length = r, t
                },
                grep: function(t, e, i) {
                    for (var n = [], r = 0, s = t.length, o = !i; r < s; r++) !e(t[r], r) !== o && n.push(t[r]);
                    return n
                },
                map: function(t, e, i) {
                    var n, r, s = 0,
                        o = [];
                    if (w(t))
                        for (n = t.length; s < n; s++) null != (r = e(t[s], s, i)) && o.push(r);
                    else
                        for (s in t) null != (r = e(t[s], s, i)) && o.push(r);
                    return l.apply([], o)
                },
                guid: 1,
                proxy: function(t, e) {
                    var i, n, r;
                    if ("string" == typeof e && (i = t[e], e = t, t = i), g.isFunction(t)) return n = a.call(arguments, 2), (r = function() {
                        return t.apply(e || this, n.concat(a.call(arguments)))
                    }).guid = t.guid = t.guid || g.guid++, r
                },
                now: Date.now,
                support: f
            }), "function" == typeof Symbol && (g.fn[Symbol.iterator] = s[Symbol.iterator]), g.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
                d["[object " + e + "]"] = e.toLowerCase()
            });
            var b = function(t) {
                var e, i, n, r, s, o, a, l, u, c, d, h, p, f, g, m, _, y, v, w = "sizzle" + 1 * new Date,
                    b = t.document,
                    x = 0,
                    T = 0,
                    E = st(),
                    O = st(),
                    C = st(),
                    P = function(t, e) {
                        return t === e && (d = !0), 0
                    },
                    D = 1 << 31,
                    M = {}.hasOwnProperty,
                    R = [],
                    k = R.pop,
                    S = R.push,
                    L = R.push,
                    j = R.slice,
                    A = function(t, e) {
                        for (var i = 0, n = t.length; i < n; i++)
                            if (t[i] === e) return i;
                        return -1
                    },
                    q = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                    I = "[\\x20\\t\\r\\n\\f]",
                    B = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
                    N = "\\[" + I + "*(" + B + ")(?:" + I + "*([*^$|!~]?=)" + I + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + B + "))|)" + I + "*\\]",
                    W = ":(" + B + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + N + ")*)|.*)\\)|)",
                    $ = new RegExp(I + "+", "g"),
                    F = new RegExp("^" + I + "+|((?:^|[^\\\\])(?:\\\\.)*)" + I + "+$", "g"),
                    U = new RegExp("^" + I + "*," + I + "*"),
                    H = new RegExp("^" + I + "*([>+~]|" + I + ")" + I + "*"),
                    z = new RegExp("=" + I + "*([^\\]'\"]*?)" + I + "*\\]", "g"),
                    K = new RegExp(W),
                    V = new RegExp("^" + B + "$"),
                    G = {
                        ID: new RegExp("^#(" + B + ")"),
                        CLASS: new RegExp("^\\.(" + B + ")"),
                        TAG: new RegExp("^(" + B + "|[*])"),
                        ATTR: new RegExp("^" + N),
                        PSEUDO: new RegExp("^" + W),
                        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + I + "*(even|odd|(([+-]|)(\\d*)n|)" + I + "*(?:([+-]|)" + I + "*(\\d+)|))" + I + "*\\)|)", "i"),
                        bool: new RegExp("^(?:" + q + ")$", "i"),
                        needsContext: new RegExp("^" + I + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + I + "*((?:-\\d)?\\d*)" + I + "*\\)|)(?=[^-]|$)", "i")
                    },
                    X = /^(?:input|select|textarea|button)$/i,
                    J = /^h\d$/i,
                    Y = /^[^{]+\{\s*\[native \w/,
                    Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                    Q = /[+~]/,
                    tt = /'|\\/g,
                    et = new RegExp("\\\\([\\da-f]{1,6}" + I + "?|(" + I + ")|.)", "ig"),
                    it = function(t, e, i) {
                        var n = "0x" + e - 65536;
                        return n != n || i ? e : n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)
                    },
                    nt = function() {
                        h()
                    };
                try {
                    L.apply(R = j.call(b.childNodes), b.childNodes), R[b.childNodes.length].nodeType
                } catch (t) {
                    L = {
                        apply: R.length ? function(t, e) {
                            S.apply(t, j.call(e))
                        } : function(t, e) {
                            for (var i = t.length, n = 0; t[i++] = e[n++];);
                            t.length = i - 1
                        }
                    }
                }

                function rt(t, e, n, r) {
                    var s, a, u, c, d, f, _, y, x = e && e.ownerDocument,
                        T = e ? e.nodeType : 9;
                    if (n = n || [], "string" != typeof t || !t || 1 !== T && 9 !== T && 11 !== T) return n;
                    if (!r && ((e ? e.ownerDocument || e : b) !== p && h(e), e = e || p, g)) {
                        if (11 !== T && (f = Z.exec(t)))
                            if (s = f[1]) {
                                if (9 === T) {
                                    if (!(u = e.getElementById(s))) return n;
                                    if (u.id === s) return n.push(u), n
                                } else if (x && (u = x.getElementById(s)) && v(e, u) && u.id === s) return n.push(u), n
                            } else {
                                if (f[2]) return L.apply(n, e.getElementsByTagName(t)), n;
                                if ((s = f[3]) && i.getElementsByClassName && e.getElementsByClassName) return L.apply(n, e.getElementsByClassName(s)), n
                            } if (i.qsa && !C[t + " "] && (!m || !m.test(t))) {
                            if (1 !== T) x = e, y = t;
                            else if ("object" !== e.nodeName.toLowerCase()) {
                                for ((c = e.getAttribute("id")) ? c = c.replace(tt, "\\$&") : e.setAttribute("id", c = w), a = (_ = o(t)).length, d = V.test(c) ? "#" + c : "[id='" + c + "']"; a--;) _[a] = d + " " + gt(_[a]);
                                y = _.join(","), x = Q.test(t) && pt(e.parentNode) || e
                            }
                            if (y) try {
                                return L.apply(n, x.querySelectorAll(y)), n
                            } catch (t) {} finally {
                                c === w && e.removeAttribute("id")
                            }
                        }
                    }
                    return l(t.replace(F, "$1"), e, n, r)
                }

                function st() {
                    var t = [];
                    return function e(i, r) {
                        return t.push(i + " ") > n.cacheLength && delete e[t.shift()], e[i + " "] = r
                    }
                }

                function ot(t) {
                    return t[w] = !0, t
                }

                function at(t) {
                    var e = p.createElement("div");
                    try {
                        return !!t(e)
                    } catch (t) {
                        return !1
                    } finally {
                        e.parentNode && e.parentNode.removeChild(e), e = null
                    }
                }

                function lt(t, e) {
                    for (var i = t.split("|"), r = i.length; r--;) n.attrHandle[i[r]] = e
                }

                function ut(t, e) {
                    var i = e && t,
                        n = i && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || D) - (~t.sourceIndex || D);
                    if (n) return n;
                    if (i)
                        for (; i = i.nextSibling;)
                            if (i === e) return -1;
                    return t ? 1 : -1
                }

                function ct(t) {
                    return function(e) {
                        return "input" === e.nodeName.toLowerCase() && e.type === t
                    }
                }

                function dt(t) {
                    return function(e) {
                        var i = e.nodeName.toLowerCase();
                        return ("input" === i || "button" === i) && e.type === t
                    }
                }

                function ht(t) {
                    return ot(function(e) {
                        return e = +e, ot(function(i, n) {
                            for (var r, s = t([], i.length, e), o = s.length; o--;) i[r = s[o]] && (i[r] = !(n[r] = i[r]))
                        })
                    })
                }

                function pt(t) {
                    return t && void 0 !== t.getElementsByTagName && t
                }
                for (e in i = rt.support = {}, s = rt.isXML = function(t) {
                        var e = t && (t.ownerDocument || t).documentElement;
                        return !!e && "HTML" !== e.nodeName
                    }, h = rt.setDocument = function(t) {
                        var e, r, o = t ? t.ownerDocument || t : b;
                        return o !== p && 9 === o.nodeType && o.documentElement ? (f = (p = o).documentElement, g = !s(p), (r = p.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", nt, !1) : r.attachEvent && r.attachEvent("onunload", nt)), i.attributes = at(function(t) {
                            return t.className = "i", !t.getAttribute("className")
                        }), i.getElementsByTagName = at(function(t) {
                            return t.appendChild(p.createComment("")), !t.getElementsByTagName("*").length
                        }), i.getElementsByClassName = Y.test(p.getElementsByClassName), i.getById = at(function(t) {
                            return f.appendChild(t).id = w, !p.getElementsByName || !p.getElementsByName(w).length
                        }), i.getById ? (n.find.ID = function(t, e) {
                            if (void 0 !== e.getElementById && g) {
                                var i = e.getElementById(t);
                                return i ? [i] : []
                            }
                        }, n.filter.ID = function(t) {
                            var e = t.replace(et, it);
                            return function(t) {
                                return t.getAttribute("id") === e
                            }
                        }) : (delete n.find.ID, n.filter.ID = function(t) {
                            var e = t.replace(et, it);
                            return function(t) {
                                var i = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                                return i && i.value === e
                            }
                        }), n.find.TAG = i.getElementsByTagName ? function(t, e) {
                            return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : i.qsa ? e.querySelectorAll(t) : void 0
                        } : function(t, e) {
                            var i, n = [],
                                r = 0,
                                s = e.getElementsByTagName(t);
                            if ("*" === t) {
                                for (; i = s[r++];) 1 === i.nodeType && n.push(i);
                                return n
                            }
                            return s
                        }, n.find.CLASS = i.getElementsByClassName && function(t, e) {
                            if (void 0 !== e.getElementsByClassName && g) return e.getElementsByClassName(t)
                        }, _ = [], m = [], (i.qsa = Y.test(p.querySelectorAll)) && (at(function(t) {
                            f.appendChild(t).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && m.push("[*^$]=" + I + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || m.push("\\[" + I + "*(?:value|" + q + ")"), t.querySelectorAll("[id~=" + w + "-]").length || m.push("~="), t.querySelectorAll(":checked").length || m.push(":checked"), t.querySelectorAll("a#" + w + "+*").length || m.push(".#.+[+~]")
                        }), at(function(t) {
                            var e = p.createElement("input");
                            e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && m.push("name" + I + "*[*^$|!~]?="), t.querySelectorAll(":enabled").length || m.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), m.push(",.*:")
                        })), (i.matchesSelector = Y.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && at(function(t) {
                            i.disconnectedMatch = y.call(t, "div"), y.call(t, "[s!='']:x"), _.push("!=", W)
                        }), m = m.length && new RegExp(m.join("|")), _ = _.length && new RegExp(_.join("|")), e = Y.test(f.compareDocumentPosition), v = e || Y.test(f.contains) ? function(t, e) {
                            var i = 9 === t.nodeType ? t.documentElement : t,
                                n = e && e.parentNode;
                            return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)))
                        } : function(t, e) {
                            if (e)
                                for (; e = e.parentNode;)
                                    if (e === t) return !0;
                            return !1
                        }, P = e ? function(t, e) {
                            if (t === e) return d = !0, 0;
                            var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                            return n || (1 & (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !i.sortDetached && e.compareDocumentPosition(t) === n ? t === p || t.ownerDocument === b && v(b, t) ? -1 : e === p || e.ownerDocument === b && v(b, e) ? 1 : c ? A(c, t) - A(c, e) : 0 : 4 & n ? -1 : 1)
                        } : function(t, e) {
                            if (t === e) return d = !0, 0;
                            var i, n = 0,
                                r = t.parentNode,
                                s = e.parentNode,
                                o = [t],
                                a = [e];
                            if (!r || !s) return t === p ? -1 : e === p ? 1 : r ? -1 : s ? 1 : c ? A(c, t) - A(c, e) : 0;
                            if (r === s) return ut(t, e);
                            for (i = t; i = i.parentNode;) o.unshift(i);
                            for (i = e; i = i.parentNode;) a.unshift(i);
                            for (; o[n] === a[n];) n++;
                            return n ? ut(o[n], a[n]) : o[n] === b ? -1 : a[n] === b ? 1 : 0
                        }, p) : p
                    }, rt.matches = function(t, e) {
                        return rt(t, null, null, e)
                    }, rt.matchesSelector = function(t, e) {
                        if ((t.ownerDocument || t) !== p && h(t), e = e.replace(z, "='$1']"), i.matchesSelector && g && !C[e + " "] && (!_ || !_.test(e)) && (!m || !m.test(e))) try {
                            var n = y.call(t, e);
                            if (n || i.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
                        } catch (t) {}
                        return rt(e, p, null, [t]).length > 0
                    }, rt.contains = function(t, e) {
                        return (t.ownerDocument || t) !== p && h(t), v(t, e)
                    }, rt.attr = function(t, e) {
                        (t.ownerDocument || t) !== p && h(t);
                        var r = n.attrHandle[e.toLowerCase()],
                            s = r && M.call(n.attrHandle, e.toLowerCase()) ? r(t, e, !g) : void 0;
                        return void 0 !== s ? s : i.attributes || !g ? t.getAttribute(e) : (s = t.getAttributeNode(e)) && s.specified ? s.value : null
                    }, rt.error = function(t) {
                        throw new Error("Syntax error, unrecognized expression: " + t)
                    }, rt.uniqueSort = function(t) {
                        var e, n = [],
                            r = 0,
                            s = 0;
                        if (d = !i.detectDuplicates, c = !i.sortStable && t.slice(0), t.sort(P), d) {
                            for (; e = t[s++];) e === t[s] && (r = n.push(s));
                            for (; r--;) t.splice(n[r], 1)
                        }
                        return c = null, t
                    }, r = rt.getText = function(t) {
                        var e, i = "",
                            n = 0,
                            s = t.nodeType;
                        if (s) {
                            if (1 === s || 9 === s || 11 === s) {
                                if ("string" == typeof t.textContent) return t.textContent;
                                for (t = t.firstChild; t; t = t.nextSibling) i += r(t)
                            } else if (3 === s || 4 === s) return t.nodeValue
                        } else
                            for (; e = t[n++];) i += r(e);
                        return i
                    }, (n = rt.selectors = {
                        cacheLength: 50,
                        createPseudo: ot,
                        match: G,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": {
                                dir: "parentNode",
                                first: !0
                            },
                            " ": {
                                dir: "parentNode"
                            },
                            "+": {
                                dir: "previousSibling",
                                first: !0
                            },
                            "~": {
                                dir: "previousSibling"
                            }
                        },
                        preFilter: {
                            ATTR: function(t) {
                                return t[1] = t[1].replace(et, it), t[3] = (t[3] || t[4] || t[5] || "").replace(et, it), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                            },
                            CHILD: function(t) {
                                return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || rt.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && rt.error(t[0]), t
                            },
                            PSEUDO: function(t) {
                                var e, i = !t[6] && t[2];
                                return G.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : i && K.test(i) && (e = o(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && (t[0] = t[0].slice(0, e), t[2] = i.slice(0, e)), t.slice(0, 3))
                            }
                        },
                        filter: {
                            TAG: function(t) {
                                var e = t.replace(et, it).toLowerCase();
                                return "*" === t ? function() {
                                    return !0
                                } : function(t) {
                                    return t.nodeName && t.nodeName.toLowerCase() === e
                                }
                            },
                            CLASS: function(t) {
                                var e = E[t + " "];
                                return e || (e = new RegExp("(^|" + I + ")" + t + "(" + I + "|$)")) && E(t, function(t) {
                                    return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                                })
                            },
                            ATTR: function(t, e, i) {
                                return function(n) {
                                    var r = rt.attr(n, t);
                                    return null == r ? "!=" === e : !e || (r += "", "=" === e ? r === i : "!=" === e ? r !== i : "^=" === e ? i && 0 === r.indexOf(i) : "*=" === e ? i && r.indexOf(i) > -1 : "$=" === e ? i && r.slice(-i.length) === i : "~=" === e ? (" " + r.replace($, " ") + " ").indexOf(i) > -1 : "|=" === e && (r === i || r.slice(0, i.length + 1) === i + "-"))
                                }
                            },
                            CHILD: function(t, e, i, n, r) {
                                var s = "nth" !== t.slice(0, 3),
                                    o = "last" !== t.slice(-4),
                                    a = "of-type" === e;
                                return 1 === n && 0 === r ? function(t) {
                                    return !!t.parentNode
                                } : function(e, i, l) {
                                    var u, c, d, h, p, f, g = s !== o ? "nextSibling" : "previousSibling",
                                        m = e.parentNode,
                                        _ = a && e.nodeName.toLowerCase(),
                                        y = !l && !a,
                                        v = !1;
                                    if (m) {
                                        if (s) {
                                            for (; g;) {
                                                for (h = e; h = h[g];)
                                                    if (a ? h.nodeName.toLowerCase() === _ : 1 === h.nodeType) return !1;
                                                f = g = "only" === t && !f && "nextSibling"
                                            }
                                            return !0
                                        }
                                        if (f = [o ? m.firstChild : m.lastChild], o && y) {
                                            for (v = (p = (u = (c = (d = (h = m)[w] || (h[w] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] || [])[0] === x && u[1]) && u[2], h = p && m.childNodes[p]; h = ++p && h && h[g] || (v = p = 0) || f.pop();)
                                                if (1 === h.nodeType && ++v && h === e) {
                                                    c[t] = [x, p, v];
                                                    break
                                                }
                                        } else if (y && (v = p = (u = (c = (d = (h = e)[w] || (h[w] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] || [])[0] === x && u[1]), !1 === v)
                                            for (;
                                                (h = ++p && h && h[g] || (v = p = 0) || f.pop()) && ((a ? h.nodeName.toLowerCase() !== _ : 1 !== h.nodeType) || !++v || (y && ((c = (d = h[w] || (h[w] = {}))[h.uniqueID] || (d[h.uniqueID] = {}))[t] = [x, v]), h !== e)););
                                        return (v -= r) === n || v % n == 0 && v / n >= 0
                                    }
                                }
                            },
                            PSEUDO: function(t, e) {
                                var i, r = n.pseudos[t] || n.setFilters[t.toLowerCase()] || rt.error("unsupported pseudo: " + t);
                                return r[w] ? r(e) : r.length > 1 ? (i = [t, t, "", e], n.setFilters.hasOwnProperty(t.toLowerCase()) ? ot(function(t, i) {
                                    for (var n, s = r(t, e), o = s.length; o--;) t[n = A(t, s[o])] = !(i[n] = s[o])
                                }) : function(t) {
                                    return r(t, 0, i)
                                }) : r
                            }
                        },
                        pseudos: {
                            not: ot(function(t) {
                                var e = [],
                                    i = [],
                                    n = a(t.replace(F, "$1"));
                                return n[w] ? ot(function(t, e, i, r) {
                                    for (var s, o = n(t, null, r, []), a = t.length; a--;)(s = o[a]) && (t[a] = !(e[a] = s))
                                }) : function(t, r, s) {
                                    return e[0] = t, n(e, null, s, i), e[0] = null, !i.pop()
                                }
                            }),
                            has: ot(function(t) {
                                return function(e) {
                                    return rt(t, e).length > 0
                                }
                            }),
                            contains: ot(function(t) {
                                return t = t.replace(et, it),
                                    function(e) {
                                        return (e.textContent || e.innerText || r(e)).indexOf(t) > -1
                                    }
                            }),
                            lang: ot(function(t) {
                                return V.test(t || "") || rt.error("unsupported lang: " + t), t = t.replace(et, it).toLowerCase(),
                                    function(e) {
                                        var i;
                                        do {
                                            if (i = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-")
                                        } while ((e = e.parentNode) && 1 === e.nodeType);
                                        return !1
                                    }
                            }),
                            target: function(e) {
                                var i = t.location && t.location.hash;
                                return i && i.slice(1) === e.id
                            },
                            root: function(t) {
                                return t === f
                            },
                            focus: function(t) {
                                return t === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                            },
                            enabled: function(t) {
                                return !1 === t.disabled
                            },
                            disabled: function(t) {
                                return !0 === t.disabled
                            },
                            checked: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && !!t.checked || "option" === e && !!t.selected
                            },
                            selected: function(t) {
                                return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                            },
                            empty: function(t) {
                                for (t = t.firstChild; t; t = t.nextSibling)
                                    if (t.nodeType < 6) return !1;
                                return !0
                            },
                            parent: function(t) {
                                return !n.pseudos.empty(t)
                            },
                            header: function(t) {
                                return J.test(t.nodeName)
                            },
                            input: function(t) {
                                return X.test(t.nodeName)
                            },
                            button: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && "button" === t.type || "button" === e
                            },
                            text: function(t) {
                                var e;
                                return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                            },
                            first: ht(function() {
                                return [0]
                            }),
                            last: ht(function(t, e) {
                                return [e - 1]
                            }),
                            eq: ht(function(t, e, i) {
                                return [i < 0 ? i + e : i]
                            }),
                            even: ht(function(t, e) {
                                for (var i = 0; i < e; i += 2) t.push(i);
                                return t
                            }),
                            odd: ht(function(t, e) {
                                for (var i = 1; i < e; i += 2) t.push(i);
                                return t
                            }),
                            lt: ht(function(t, e, i) {
                                for (var n = i < 0 ? i + e : i; --n >= 0;) t.push(n);
                                return t
                            }),
                            gt: ht(function(t, e, i) {
                                for (var n = i < 0 ? i + e : i; ++n < e;) t.push(n);
                                return t
                            })
                        }
                    }).pseudos.nth = n.pseudos.eq, {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    }) n.pseudos[e] = ct(e);
                for (e in {
                        submit: !0,
                        reset: !0
                    }) n.pseudos[e] = dt(e);

                function ft() {}

                function gt(t) {
                    for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
                    return n
                }

                function mt(t, e, i) {
                    var n = e.dir,
                        r = i && "parentNode" === n,
                        s = T++;
                    return e.first ? function(e, i, s) {
                        for (; e = e[n];)
                            if (1 === e.nodeType || r) return t(e, i, s)
                    } : function(e, i, o) {
                        var a, l, u, c = [x, s];
                        if (o) {
                            for (; e = e[n];)
                                if ((1 === e.nodeType || r) && t(e, i, o)) return !0
                        } else
                            for (; e = e[n];)
                                if (1 === e.nodeType || r) {
                                    if ((a = (l = (u = e[w] || (e[w] = {}))[e.uniqueID] || (u[e.uniqueID] = {}))[n]) && a[0] === x && a[1] === s) return c[2] = a[2];
                                    if (l[n] = c, c[2] = t(e, i, o)) return !0
                                }
                    }
                }

                function _t(t) {
                    return t.length > 1 ? function(e, i, n) {
                        for (var r = t.length; r--;)
                            if (!t[r](e, i, n)) return !1;
                        return !0
                    } : t[0]
                }

                function yt(t, e, i, n, r) {
                    for (var s, o = [], a = 0, l = t.length, u = null != e; a < l; a++)(s = t[a]) && (i && !i(s, n, r) || (o.push(s), u && e.push(a)));
                    return o
                }

                function vt(t, e, i, n, r, s) {
                    return n && !n[w] && (n = vt(n)), r && !r[w] && (r = vt(r, s)), ot(function(s, o, a, l) {
                        var u, c, d, h = [],
                            p = [],
                            f = o.length,
                            g = s || function(t, e, i) {
                                for (var n = 0, r = e.length; n < r; n++) rt(t, e[n], i);
                                return i
                            }(e || "*", a.nodeType ? [a] : a, []),
                            m = !t || !s && e ? g : yt(g, h, t, a, l),
                            _ = i ? r || (s ? t : f || n) ? [] : o : m;
                        if (i && i(m, _, a, l), n)
                            for (u = yt(_, p), n(u, [], a, l), c = u.length; c--;)(d = u[c]) && (_[p[c]] = !(m[p[c]] = d));
                        if (s) {
                            if (r || t) {
                                if (r) {
                                    for (u = [], c = _.length; c--;)(d = _[c]) && u.push(m[c] = d);
                                    r(null, _ = [], u, l)
                                }
                                for (c = _.length; c--;)(d = _[c]) && (u = r ? A(s, d) : h[c]) > -1 && (s[u] = !(o[u] = d))
                            }
                        } else _ = yt(_ === o ? _.splice(f, _.length) : _), r ? r(null, o, _, l) : L.apply(o, _)
                    })
                }

                function wt(t) {
                    for (var e, i, r, s = t.length, o = n.relative[t[0].type], a = o || n.relative[" "], l = o ? 1 : 0, c = mt(function(t) {
                            return t === e
                        }, a, !0), d = mt(function(t) {
                            return A(e, t) > -1
                        }, a, !0), h = [function(t, i, n) {
                            var r = !o && (n || i !== u) || ((e = i).nodeType ? c(t, i, n) : d(t, i, n));
                            return e = null, r
                        }]; l < s; l++)
                        if (i = n.relative[t[l].type]) h = [mt(_t(h), i)];
                        else {
                            if ((i = n.filter[t[l].type].apply(null, t[l].matches))[w]) {
                                for (r = ++l; r < s && !n.relative[t[r].type]; r++);
                                return vt(l > 1 && _t(h), l > 1 && gt(t.slice(0, l - 1).concat({
                                    value: " " === t[l - 2].type ? "*" : ""
                                })).replace(F, "$1"), i, l < r && wt(t.slice(l, r)), r < s && wt(t = t.slice(r)), r < s && gt(t))
                            }
                            h.push(i)
                        } return _t(h)
                }
                return ft.prototype = n.filters = n.pseudos, n.setFilters = new ft, o = rt.tokenize = function(t, e) {
                    var i, r, s, o, a, l, u, c = O[t + " "];
                    if (c) return e ? 0 : c.slice(0);
                    for (a = t, l = [], u = n.preFilter; a;) {
                        for (o in i && !(r = U.exec(a)) || (r && (a = a.slice(r[0].length) || a), l.push(s = [])), i = !1, (r = H.exec(a)) && (i = r.shift(), s.push({
                                value: i,
                                type: r[0].replace(F, " ")
                            }), a = a.slice(i.length)), n.filter) !(r = G[o].exec(a)) || u[o] && !(r = u[o](r)) || (i = r.shift(), s.push({
                            value: i,
                            type: o,
                            matches: r
                        }), a = a.slice(i.length));
                        if (!i) break
                    }
                    return e ? a.length : a ? rt.error(t) : O(t, l).slice(0)
                }, a = rt.compile = function(t, e) {
                    var i, r = [],
                        s = [],
                        a = C[t + " "];
                    if (!a) {
                        for (e || (e = o(t)), i = e.length; i--;)(a = wt(e[i]))[w] ? r.push(a) : s.push(a);
                        (a = C(t, function(t, e) {
                            var i = e.length > 0,
                                r = t.length > 0,
                                s = function(s, o, a, l, c) {
                                    var d, f, m, _ = 0,
                                        y = "0",
                                        v = s && [],
                                        w = [],
                                        b = u,
                                        T = s || r && n.find.TAG("*", c),
                                        E = x += null == b ? 1 : Math.random() || .1,
                                        O = T.length;
                                    for (c && (u = o === p || o || c); y !== O && null != (d = T[y]); y++) {
                                        if (r && d) {
                                            for (f = 0, o || d.ownerDocument === p || (h(d), a = !g); m = t[f++];)
                                                if (m(d, o || p, a)) {
                                                    l.push(d);
                                                    break
                                                } c && (x = E)
                                        }
                                        i && ((d = !m && d) && _--, s && v.push(d))
                                    }
                                    if (_ += y, i && y !== _) {
                                        for (f = 0; m = e[f++];) m(v, w, o, a);
                                        if (s) {
                                            if (_ > 0)
                                                for (; y--;) v[y] || w[y] || (w[y] = k.call(l));
                                            w = yt(w)
                                        }
                                        L.apply(l, w), c && !s && w.length > 0 && _ + e.length > 1 && rt.uniqueSort(l)
                                    }
                                    return c && (x = E, u = b), v
                                };
                            return i ? ot(s) : s
                        }(s, r))).selector = t
                    }
                    return a
                }, l = rt.select = function(t, e, r, s) {
                    var l, u, c, d, h, p = "function" == typeof t && t,
                        f = !s && o(t = p.selector || t);
                    if (r = r || [], 1 === f.length) {
                        if ((u = f[0] = f[0].slice(0)).length > 2 && "ID" === (c = u[0]).type && i.getById && 9 === e.nodeType && g && n.relative[u[1].type]) {
                            if (!(e = (n.find.ID(c.matches[0].replace(et, it), e) || [])[0])) return r;
                            p && (e = e.parentNode), t = t.slice(u.shift().value.length)
                        }
                        for (l = G.needsContext.test(t) ? 0 : u.length; l-- && (c = u[l], !n.relative[d = c.type]);)
                            if ((h = n.find[d]) && (s = h(c.matches[0].replace(et, it), Q.test(u[0].type) && pt(e.parentNode) || e))) {
                                if (u.splice(l, 1), !(t = s.length && gt(u))) return L.apply(r, s), r;
                                break
                            }
                    }
                    return (p || a(t, f))(s, e, !g, r, !e || Q.test(t) && pt(e.parentNode) || e), r
                }, i.sortStable = w.split("").sort(P).join("") === w, i.detectDuplicates = !!d, h(), i.sortDetached = at(function(t) {
                    return 1 & t.compareDocumentPosition(p.createElement("div"))
                }), at(function(t) {
                    return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
                }) || lt("type|href|height|width", function(t, e, i) {
                    if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
                }), i.attributes && at(function(t) {
                    return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
                }) || lt("value", function(t, e, i) {
                    if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue
                }), at(function(t) {
                    return null == t.getAttribute("disabled")
                }) || lt(q, function(t, e, i) {
                    var n;
                    if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
                }), rt
            }(i);
            g.find = b, g.expr = b.selectors, g.expr[":"] = g.expr.pseudos, g.uniqueSort = g.unique = b.uniqueSort, g.text = b.getText, g.isXMLDoc = b.isXML, g.contains = b.contains;
            var x = function(t, e, i) {
                    for (var n = [], r = void 0 !== i;
                        (t = t[e]) && 9 !== t.nodeType;)
                        if (1 === t.nodeType) {
                            if (r && g(t).is(i)) break;
                            n.push(t)
                        } return n
                },
                T = function(t, e) {
                    for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
                    return i
                },
                E = g.expr.match.needsContext,
                O = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
                C = /^.[^:#\[\.,]*$/;

            function P(t, e, i) {
                if (g.isFunction(e)) return g.grep(t, function(t, n) {
                    return !!e.call(t, n, t) !== i
                });
                if (e.nodeType) return g.grep(t, function(t) {
                    return t === e !== i
                });
                if ("string" == typeof e) {
                    if (C.test(e)) return g.filter(e, t, i);
                    e = g.filter(e, t)
                }
                return g.grep(t, function(t) {
                    return c.call(e, t) > -1 !== i
                })
            }
            g.filter = function(t, e, i) {
                var n = e[0];
                return i && (t = ":not(" + t + ")"), 1 === e.length && 1 === n.nodeType ? g.find.matchesSelector(n, t) ? [n] : [] : g.find.matches(t, g.grep(e, function(t) {
                    return 1 === t.nodeType
                }))
            }, g.fn.extend({
                find: function(t) {
                    var e, i = this.length,
                        n = [],
                        r = this;
                    if ("string" != typeof t) return this.pushStack(g(t).filter(function() {
                        for (e = 0; e < i; e++)
                            if (g.contains(r[e], this)) return !0
                    }));
                    for (e = 0; e < i; e++) g.find(t, r[e], n);
                    return (n = this.pushStack(i > 1 ? g.unique(n) : n)).selector = this.selector ? this.selector + " " + t : t, n
                },
                filter: function(t) {
                    return this.pushStack(P(this, t || [], !1))
                },
                not: function(t) {
                    return this.pushStack(P(this, t || [], !0))
                },
                is: function(t) {
                    return !!P(this, "string" == typeof t && E.test(t) ? g(t) : t || [], !1).length
                }
            });
            var D, M = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
            (g.fn.init = function(t, e, i) {
                var n, r;
                if (!t) return this;
                if (i = i || D, "string" == typeof t) {
                    if (!(n = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : M.exec(t)) || !n[1] && e) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
                    if (n[1]) {
                        if (e = e instanceof g ? e[0] : e, g.merge(this, g.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : o, !0)), O.test(n[1]) && g.isPlainObject(e))
                            for (n in e) g.isFunction(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                        return this
                    }
                    return (r = o.getElementById(n[2])) && r.parentNode && (this.length = 1, this[0] = r), this.context = o, this.selector = t, this
                }
                return t.nodeType ? (this.context = this[0] = t, this.length = 1, this) : g.isFunction(t) ? void 0 !== i.ready ? i.ready(t) : t(g) : (void 0 !== t.selector && (this.selector = t.selector, this.context = t.context), g.makeArray(t, this))
            }).prototype = g.fn, D = g(o);
            var R = /^(?:parents|prev(?:Until|All))/,
                k = {
                    children: !0,
                    contents: !0,
                    next: !0,
                    prev: !0
                };

            function S(t, e) {
                for (;
                    (t = t[e]) && 1 !== t.nodeType;);
                return t
            }
            g.fn.extend({
                has: function(t) {
                    var e = g(t, this),
                        i = e.length;
                    return this.filter(function() {
                        for (var t = 0; t < i; t++)
                            if (g.contains(this, e[t])) return !0
                    })
                },
                closest: function(t, e) {
                    for (var i, n = 0, r = this.length, s = [], o = E.test(t) || "string" != typeof t ? g(t, e || this.context) : 0; n < r; n++)
                        for (i = this[n]; i && i !== e; i = i.parentNode)
                            if (i.nodeType < 11 && (o ? o.index(i) > -1 : 1 === i.nodeType && g.find.matchesSelector(i, t))) {
                                s.push(i);
                                break
                            } return this.pushStack(s.length > 1 ? g.uniqueSort(s) : s)
                },
                index: function(t) {
                    return t ? "string" == typeof t ? c.call(g(t), this[0]) : c.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                },
                add: function(t, e) {
                    return this.pushStack(g.uniqueSort(g.merge(this.get(), g(t, e))))
                },
                addBack: function(t) {
                    return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
                }
            }), g.each({
                parent: function(t) {
                    var e = t.parentNode;
                    return e && 11 !== e.nodeType ? e : null
                },
                parents: function(t) {
                    return x(t, "parentNode")
                },
                parentsUntil: function(t, e, i) {
                    return x(t, "parentNode", i)
                },
                next: function(t) {
                    return S(t, "nextSibling")
                },
                prev: function(t) {
                    return S(t, "previousSibling")
                },
                nextAll: function(t) {
                    return x(t, "nextSibling")
                },
                prevAll: function(t) {
                    return x(t, "previousSibling")
                },
                nextUntil: function(t, e, i) {
                    return x(t, "nextSibling", i)
                },
                prevUntil: function(t, e, i) {
                    return x(t, "previousSibling", i)
                },
                siblings: function(t) {
                    return T((t.parentNode || {}).firstChild, t)
                },
                children: function(t) {
                    return T(t.firstChild)
                },
                contents: function(t) {
                    return t.contentDocument || g.merge([], t.childNodes)
                }
            }, function(t, e) {
                g.fn[t] = function(i, n) {
                    var r = g.map(this, e, i);
                    return "Until" !== t.slice(-5) && (n = i), n && "string" == typeof n && (r = g.filter(n, r)), this.length > 1 && (k[t] || g.uniqueSort(r), R.test(t) && r.reverse()), this.pushStack(r)
                }
            });
            var L, j = /\S+/g;

            function A() {
                o.removeEventListener("DOMContentLoaded", A), i.removeEventListener("load", A), g.ready()
            }
            g.Callbacks = function(t) {
                t = "string" == typeof t ? function(t) {
                    var e = {};
                    return g.each(t.match(j) || [], function(t, i) {
                        e[i] = !0
                    }), e
                }(t) : g.extend({}, t);
                var e, i, n, r, s = [],
                    o = [],
                    a = -1,
                    l = function() {
                        for (r = t.once, n = e = !0; o.length; a = -1)
                            for (i = o.shift(); ++a < s.length;) !1 === s[a].apply(i[0], i[1]) && t.stopOnFalse && (a = s.length, i = !1);
                        t.memory || (i = !1), e = !1, r && (s = i ? [] : "")
                    },
                    u = {
                        add: function() {
                            return s && (i && !e && (a = s.length - 1, o.push(i)), function e(i) {
                                g.each(i, function(i, n) {
                                    g.isFunction(n) ? t.unique && u.has(n) || s.push(n) : n && n.length && "string" !== g.type(n) && e(n)
                                })
                            }(arguments), i && !e && l()), this
                        },
                        remove: function() {
                            return g.each(arguments, function(t, e) {
                                for (var i;
                                    (i = g.inArray(e, s, i)) > -1;) s.splice(i, 1), i <= a && a--
                            }), this
                        },
                        has: function(t) {
                            return t ? g.inArray(t, s) > -1 : s.length > 0
                        },
                        empty: function() {
                            return s && (s = []), this
                        },
                        disable: function() {
                            return r = o = [], s = i = "", this
                        },
                        disabled: function() {
                            return !s
                        },
                        lock: function() {
                            return r = o = [], i || (s = i = ""), this
                        },
                        locked: function() {
                            return !!r
                        },
                        fireWith: function(t, i) {
                            return r || (i = [t, (i = i || []).slice ? i.slice() : i], o.push(i), e || l()), this
                        },
                        fire: function() {
                            return u.fireWith(this, arguments), this
                        },
                        fired: function() {
                            return !!n
                        }
                    };
                return u
            }, g.extend({
                Deferred: function(t) {
                    var e = [
                            ["resolve", "done", g.Callbacks("once memory"), "resolved"],
                            ["reject", "fail", g.Callbacks("once memory"), "rejected"],
                            ["notify", "progress", g.Callbacks("memory")]
                        ],
                        i = "pending",
                        n = {
                            state: function() {
                                return i
                            },
                            always: function() {
                                return r.done(arguments).fail(arguments), this
                            },
                            then: function() {
                                var t = arguments;
                                return g.Deferred(function(i) {
                                    g.each(e, function(e, s) {
                                        var o = g.isFunction(t[e]) && t[e];
                                        r[s[1]](function() {
                                            var t = o && o.apply(this, arguments);
                                            t && g.isFunction(t.promise) ? t.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[s[0] + "With"](this === n ? i.promise() : this, o ? [t] : arguments)
                                        })
                                    }), t = null
                                }).promise()
                            },
                            promise: function(t) {
                                return null != t ? g.extend(t, n) : n
                            }
                        },
                        r = {};
                    return n.pipe = n.then, g.each(e, function(t, s) {
                        var o = s[2],
                            a = s[3];
                        n[s[1]] = o.add, a && o.add(function() {
                            i = a
                        }, e[1 ^ t][2].disable, e[2][2].lock), r[s[0]] = function() {
                            return r[s[0] + "With"](this === r ? n : this, arguments), this
                        }, r[s[0] + "With"] = o.fireWith
                    }), n.promise(r), t && t.call(r, r), r
                },
                when: function(t) {
                    var e, i, n, r = 0,
                        s = a.call(arguments),
                        o = s.length,
                        l = 1 !== o || t && g.isFunction(t.promise) ? o : 0,
                        u = 1 === l ? t : g.Deferred(),
                        c = function(t, i, n) {
                            return function(r) {
                                i[t] = this, n[t] = arguments.length > 1 ? a.call(arguments) : r, n === e ? u.notifyWith(i, n) : --l || u.resolveWith(i, n)
                            }
                        };
                    if (o > 1)
                        for (e = new Array(o), i = new Array(o), n = new Array(o); r < o; r++) s[r] && g.isFunction(s[r].promise) ? s[r].promise().progress(c(r, i, e)).done(c(r, n, s)).fail(u.reject) : --l;
                    return l || u.resolveWith(n, s), u.promise()
                }
            }), g.fn.ready = function(t) {
                return g.ready.promise().done(t), this
            }, g.extend({
                isReady: !1,
                readyWait: 1,
                holdReady: function(t) {
                    t ? g.readyWait++ : g.ready(!0)
                },
                ready: function(t) {
                    (!0 === t ? --g.readyWait : g.isReady) || (g.isReady = !0, !0 !== t && --g.readyWait > 0 || (L.resolveWith(o, [g]), g.fn.triggerHandler && (g(o).triggerHandler("ready"), g(o).off("ready"))))
                }
            }), g.ready.promise = function(t) {
                return L || (L = g.Deferred(), "complete" === o.readyState || "loading" !== o.readyState && !o.documentElement.doScroll ? i.setTimeout(g.ready) : (o.addEventListener("DOMContentLoaded", A), i.addEventListener("load", A))), L.promise(t)
            }, g.ready.promise();
            var q = function(t, e, i, n, r, s, o) {
                    var a = 0,
                        l = t.length,
                        u = null == i;
                    if ("object" === g.type(i))
                        for (a in r = !0, i) q(t, e, a, i[a], !0, s, o);
                    else if (void 0 !== n && (r = !0, g.isFunction(n) || (o = !0), u && (o ? (e.call(t, n), e = null) : (u = e, e = function(t, e, i) {
                            return u.call(g(t), i)
                        })), e))
                        for (; a < l; a++) e(t[a], i, o ? n : n.call(t[a], a, e(t[a], i)));
                    return r ? t : u ? e.call(t) : l ? e(t[0], i) : s
                },
                I = function(t) {
                    return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
                };

            function B() {
                this.expando = g.expando + B.uid++
            }
            B.uid = 1, B.prototype = {
                register: function(t, e) {
                    var i = e || {};
                    return t.nodeType ? t[this.expando] = i : Object.defineProperty(t, this.expando, {
                        value: i,
                        writable: !0,
                        configurable: !0
                    }), t[this.expando]
                },
                cache: function(t) {
                    if (!I(t)) return {};
                    var e = t[this.expando];
                    return e || (e = {}, I(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                        value: e,
                        configurable: !0
                    }))), e
                },
                set: function(t, e, i) {
                    var n, r = this.cache(t);
                    if ("string" == typeof e) r[e] = i;
                    else
                        for (n in e) r[n] = e[n];
                    return r
                },
                get: function(t, e) {
                    return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][e]
                },
                access: function(t, e, i) {
                    var n;
                    return void 0 === e || e && "string" == typeof e && void 0 === i ? void 0 !== (n = this.get(t, e)) ? n : this.get(t, g.camelCase(e)) : (this.set(t, e, i), void 0 !== i ? i : e)
                },
                remove: function(t, e) {
                    var i, n, r, s = t[this.expando];
                    if (void 0 !== s) {
                        if (void 0 === e) this.register(t);
                        else {
                            g.isArray(e) ? n = e.concat(e.map(g.camelCase)) : (r = g.camelCase(e), n = e in s ? [e, r] : (n = r) in s ? [n] : n.match(j) || []), i = n.length;
                            for (; i--;) delete s[n[i]]
                        }(void 0 === e || g.isEmptyObject(s)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
                    }
                },
                hasData: function(t) {
                    var e = t[this.expando];
                    return void 0 !== e && !g.isEmptyObject(e)
                }
            };
            var N = new B,
                W = new B,
                $ = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                F = /[A-Z]/g;

            function U(t, e, i) {
                var n;
                if (void 0 === i && 1 === t.nodeType)
                    if (n = "data-" + e.replace(F, "-$&").toLowerCase(), "string" == typeof(i = t.getAttribute(n))) {
                        try {
                            i = "true" === i || "false" !== i && ("null" === i ? null : +i + "" === i ? +i : $.test(i) ? g.parseJSON(i) : i)
                        } catch (t) {}
                        W.set(t, e, i)
                    } else i = void 0;
                return i
            }
            g.extend({
                hasData: function(t) {
                    return W.hasData(t) || N.hasData(t)
                },
                data: function(t, e, i) {
                    return W.access(t, e, i)
                },
                removeData: function(t, e) {
                    W.remove(t, e)
                },
                _data: function(t, e, i) {
                    return N.access(t, e, i)
                },
                _removeData: function(t, e) {
                    N.remove(t, e)
                }
            }), g.fn.extend({
                data: function(t, e) {
                    var i, n, r, s = this[0],
                        o = s && s.attributes;
                    if (void 0 === t) {
                        if (this.length && (r = W.get(s), 1 === s.nodeType && !N.get(s, "hasDataAttrs"))) {
                            for (i = o.length; i--;) o[i] && 0 === (n = o[i].name).indexOf("data-") && (n = g.camelCase(n.slice(5)), U(s, n, r[n]));
                            N.set(s, "hasDataAttrs", !0)
                        }
                        return r
                    }
                    return "object" == typeof t ? this.each(function() {
                        W.set(this, t)
                    }) : q(this, function(e) {
                        var i, n;
                        if (s && void 0 === e) return void 0 !== (i = W.get(s, t) || W.get(s, t.replace(F, "-$&").toLowerCase())) ? i : (n = g.camelCase(t), void 0 !== (i = W.get(s, n)) ? i : void 0 !== (i = U(s, n, void 0)) ? i : void 0);
                        n = g.camelCase(t), this.each(function() {
                            var i = W.get(this, n);
                            W.set(this, n, e), t.indexOf("-") > -1 && void 0 !== i && W.set(this, t, e)
                        })
                    }, null, e, arguments.length > 1, null, !0)
                },
                removeData: function(t) {
                    return this.each(function() {
                        W.remove(this, t)
                    })
                }
            }), g.extend({
                queue: function(t, e, i) {
                    var n;
                    if (t) return e = (e || "fx") + "queue", n = N.get(t, e), i && (!n || g.isArray(i) ? n = N.access(t, e, g.makeArray(i)) : n.push(i)), n || []
                },
                dequeue: function(t, e) {
                    e = e || "fx";
                    var i = g.queue(t, e),
                        n = i.length,
                        r = i.shift(),
                        s = g._queueHooks(t, e);
                    "inprogress" === r && (r = i.shift(), n--), r && ("fx" === e && i.unshift("inprogress"), delete s.stop, r.call(t, function() {
                        g.dequeue(t, e)
                    }, s)), !n && s && s.empty.fire()
                },
                _queueHooks: function(t, e) {
                    var i = e + "queueHooks";
                    return N.get(t, i) || N.access(t, i, {
                        empty: g.Callbacks("once memory").add(function() {
                            N.remove(t, [e + "queue", i])
                        })
                    })
                }
            }), g.fn.extend({
                queue: function(t, e) {
                    var i = 2;
                    return "string" != typeof t && (e = t, t = "fx", i--), arguments.length < i ? g.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                        var i = g.queue(this, t, e);
                        g._queueHooks(this, t), "fx" === t && "inprogress" !== i[0] && g.dequeue(this, t)
                    })
                },
                dequeue: function(t) {
                    return this.each(function() {
                        g.dequeue(this, t)
                    })
                },
                clearQueue: function(t) {
                    return this.queue(t || "fx", [])
                },
                promise: function(t, e) {
                    var i, n = 1,
                        r = g.Deferred(),
                        s = this,
                        o = this.length,
                        a = function() {
                            --n || r.resolveWith(s, [s])
                        };
                    for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; o--;)(i = N.get(s[o], t + "queueHooks")) && i.empty && (n++, i.empty.add(a));
                    return a(), r.promise(e)
                }
            });
            var H = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                z = new RegExp("^(?:([+-])=|)(" + H + ")([a-z%]*)$", "i"),
                K = ["Top", "Right", "Bottom", "Left"],
                V = function(t, e) {
                    return t = e || t, "none" === g.css(t, "display") || !g.contains(t.ownerDocument, t)
                };

            function G(t, e, i, n) {
                var r, s = 1,
                    o = 20,
                    a = n ? function() {
                        return n.cur()
                    } : function() {
                        return g.css(t, e, "")
                    },
                    l = a(),
                    u = i && i[3] || (g.cssNumber[e] ? "" : "px"),
                    c = (g.cssNumber[e] || "px" !== u && +l) && z.exec(g.css(t, e));
                if (c && c[3] !== u) {
                    u = u || c[3], i = i || [], c = +l || 1;
                    do {
                        c /= s = s || ".5", g.style(t, e, c + u)
                    } while (s !== (s = a() / l) && 1 !== s && --o)
                }
                return i && (c = +c || +l || 0, r = i[1] ? c + (i[1] + 1) * i[2] : +i[2], n && (n.unit = u, n.start = c, n.end = r)), r
            }
            var X = /^(?:checkbox|radio)$/i,
                J = /<([\w:-]+)/,
                Y = /^$|\/(?:java|ecma)script/i,
                Z = {
                    option: [1, "<select multiple='multiple'>", "</select>"],
                    thead: [1, "<table>", "</table>"],
                    col: [2, "<table><colgroup>", "</colgroup></table>"],
                    tr: [2, "<table><tbody>", "</tbody></table>"],
                    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                    _default: [0, "", ""]
                };

            function Q(t, e) {
                var i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
                return void 0 === e || e && g.nodeName(t, e) ? g.merge([t], i) : i
            }

            function tt(t, e) {
                for (var i = 0, n = t.length; i < n; i++) N.set(t[i], "globalEval", !e || N.get(e[i], "globalEval"))
            }
            Z.optgroup = Z.option, Z.tbody = Z.tfoot = Z.colgroup = Z.caption = Z.thead, Z.th = Z.td;
            var et, it, nt = /<|&#?\w+;/;

            function rt(t, e, i, n, r) {
                for (var s, o, a, l, u, c, d = e.createDocumentFragment(), h = [], p = 0, f = t.length; p < f; p++)
                    if ((s = t[p]) || 0 === s)
                        if ("object" === g.type(s)) g.merge(h, s.nodeType ? [s] : s);
                        else if (nt.test(s)) {
                    for (o = o || d.appendChild(e.createElement("div")), a = (J.exec(s) || ["", ""])[1].toLowerCase(), l = Z[a] || Z._default, o.innerHTML = l[1] + g.htmlPrefilter(s) + l[2], c = l[0]; c--;) o = o.lastChild;
                    g.merge(h, o.childNodes), (o = d.firstChild).textContent = ""
                } else h.push(e.createTextNode(s));
                for (d.textContent = "", p = 0; s = h[p++];)
                    if (n && g.inArray(s, n) > -1) r && r.push(s);
                    else if (u = g.contains(s.ownerDocument, s), o = Q(d.appendChild(s), "script"), u && tt(o), i)
                    for (c = 0; s = o[c++];) Y.test(s.type || "") && i.push(s);
                return d
            }
            et = o.createDocumentFragment().appendChild(o.createElement("div")), (it = o.createElement("input")).setAttribute("type", "radio"), it.setAttribute("checked", "checked"), it.setAttribute("name", "t"), et.appendChild(it), f.checkClone = et.cloneNode(!0).cloneNode(!0).lastChild.checked, et.innerHTML = "<textarea>x</textarea>", f.noCloneChecked = !!et.cloneNode(!0).lastChild.defaultValue;
            var st = /^key/,
                ot = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                at = /^([^.]*)(?:\.(.+)|)/;

            function lt() {
                return !0
            }

            function ut() {
                return !1
            }

            function ct() {
                try {
                    return o.activeElement
                } catch (t) {}
            }

            function dt(t, e, i, n, r, s) {
                var o, a;
                if ("object" == typeof e) {
                    for (a in "string" != typeof i && (n = n || i, i = void 0), e) dt(t, a, i, n, e[a], s);
                    return t
                }
                if (null == n && null == r ? (r = i, n = i = void 0) : null == r && ("string" == typeof i ? (r = n, n = void 0) : (r = n, n = i, i = void 0)), !1 === r) r = ut;
                else if (!r) return t;
                return 1 === s && (o = r, (r = function(t) {
                    return g().off(t), o.apply(this, arguments)
                }).guid = o.guid || (o.guid = g.guid++)), t.each(function() {
                    g.event.add(this, e, r, n, i)
                })
            }
            g.event = {
                global: {},
                add: function(t, e, i, n, r) {
                    var s, o, a, l, u, c, d, h, p, f, m, _ = N.get(t);
                    if (_)
                        for (i.handler && (i = (s = i).handler, r = s.selector), i.guid || (i.guid = g.guid++), (l = _.events) || (l = _.events = {}), (o = _.handle) || (o = _.handle = function(e) {
                                return void 0 !== g && g.event.triggered !== e.type ? g.event.dispatch.apply(t, arguments) : void 0
                            }), u = (e = (e || "").match(j) || [""]).length; u--;) p = m = (a = at.exec(e[u]) || [])[1], f = (a[2] || "").split(".").sort(), p && (d = g.event.special[p] || {}, p = (r ? d.delegateType : d.bindType) || p, d = g.event.special[p] || {}, c = g.extend({
                            type: p,
                            origType: m,
                            data: n,
                            handler: i,
                            guid: i.guid,
                            selector: r,
                            needsContext: r && g.expr.match.needsContext.test(r),
                            namespace: f.join(".")
                        }, s), (h = l[p]) || ((h = l[p] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, n, f, o) || t.addEventListener && t.addEventListener(p, o)), d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = i.guid)), r ? h.splice(h.delegateCount++, 0, c) : h.push(c), g.event.global[p] = !0)
                },
                remove: function(t, e, i, n, r) {
                    var s, o, a, l, u, c, d, h, p, f, m, _ = N.hasData(t) && N.get(t);
                    if (_ && (l = _.events)) {
                        for (u = (e = (e || "").match(j) || [""]).length; u--;)
                            if (p = m = (a = at.exec(e[u]) || [])[1], f = (a[2] || "").split(".").sort(), p) {
                                for (d = g.event.special[p] || {}, h = l[p = (n ? d.delegateType : d.bindType) || p] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), o = s = h.length; s--;) c = h[s], !r && m !== c.origType || i && i.guid !== c.guid || a && !a.test(c.namespace) || n && n !== c.selector && ("**" !== n || !c.selector) || (h.splice(s, 1), c.selector && h.delegateCount--, d.remove && d.remove.call(t, c));
                                o && !h.length && (d.teardown && !1 !== d.teardown.call(t, f, _.handle) || g.removeEvent(t, p, _.handle), delete l[p])
                            } else
                                for (p in l) g.event.remove(t, p + e[u], i, n, !0);
                        g.isEmptyObject(l) && N.remove(t, "handle events")
                    }
                },
                dispatch: function(t) {
                    t = g.event.fix(t);
                    var e, i, n, r, s, o = [],
                        l = a.call(arguments),
                        u = (N.get(this, "events") || {})[t.type] || [],
                        c = g.event.special[t.type] || {};
                    if (l[0] = t, t.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
                        for (o = g.event.handlers.call(this, t, u), e = 0;
                            (r = o[e++]) && !t.isPropagationStopped();)
                            for (t.currentTarget = r.elem, i = 0;
                                (s = r.handlers[i++]) && !t.isImmediatePropagationStopped();) t.rnamespace && !t.rnamespace.test(s.namespace) || (t.handleObj = s, t.data = s.data, void 0 !== (n = ((g.event.special[s.origType] || {}).handle || s.handler).apply(r.elem, l)) && !1 === (t.result = n) && (t.preventDefault(), t.stopPropagation()));
                        return c.postDispatch && c.postDispatch.call(this, t), t.result
                    }
                },
                handlers: function(t, e) {
                    var i, n, r, s, o = [],
                        a = e.delegateCount,
                        l = t.target;
                    if (a && l.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                        for (; l !== this; l = l.parentNode || this)
                            if (1 === l.nodeType && (!0 !== l.disabled || "click" !== t.type)) {
                                for (n = [], i = 0; i < a; i++) void 0 === n[r = (s = e[i]).selector + " "] && (n[r] = s.needsContext ? g(r, this).index(l) > -1 : g.find(r, this, null, [l]).length), n[r] && n.push(s);
                                n.length && o.push({
                                    elem: l,
                                    handlers: n
                                })
                            } return a < e.length && o.push({
                        elem: this,
                        handlers: e.slice(a)
                    }), o
                },
                props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
                fixHooks: {},
                keyHooks: {
                    props: "char charCode key keyCode".split(" "),
                    filter: function(t, e) {
                        return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode), t
                    }
                },
                mouseHooks: {
                    props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
                    filter: function(t, e) {
                        var i, n, r, s = e.button;
                        return null == t.pageX && null != e.clientX && (n = (i = t.target.ownerDocument || o).documentElement, r = i.body, t.pageX = e.clientX + (n && n.scrollLeft || r && r.scrollLeft || 0) - (n && n.clientLeft || r && r.clientLeft || 0), t.pageY = e.clientY + (n && n.scrollTop || r && r.scrollTop || 0) - (n && n.clientTop || r && r.clientTop || 0)), t.which || void 0 === s || (t.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0), t
                    }
                },
                fix: function(t) {
                    if (t[g.expando]) return t;
                    var e, i, n, r = t.type,
                        s = t,
                        a = this.fixHooks[r];
                    for (a || (this.fixHooks[r] = a = ot.test(r) ? this.mouseHooks : st.test(r) ? this.keyHooks : {}), n = a.props ? this.props.concat(a.props) : this.props, t = new g.Event(s), e = n.length; e--;) t[i = n[e]] = s[i];
                    return t.target || (t.target = o), 3 === t.target.nodeType && (t.target = t.target.parentNode), a.filter ? a.filter(t, s) : t
                },
                special: {
                    load: {
                        noBubble: !0
                    },
                    focus: {
                        trigger: function() {
                            if (this !== ct() && this.focus) return this.focus(), !1
                        },
                        delegateType: "focusin"
                    },
                    blur: {
                        trigger: function() {
                            if (this === ct() && this.blur) return this.blur(), !1
                        },
                        delegateType: "focusout"
                    },
                    click: {
                        trigger: function() {
                            if ("checkbox" === this.type && this.click && g.nodeName(this, "input")) return this.click(), !1
                        },
                        _default: function(t) {
                            return g.nodeName(t.target, "a")
                        }
                    },
                    beforeunload: {
                        postDispatch: function(t) {
                            void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                        }
                    }
                }
            }, g.removeEvent = function(t, e, i) {
                t.removeEventListener && t.removeEventListener(e, i)
            }, g.Event = function(t, e) {
                if (!(this instanceof g.Event)) return new g.Event(t, e);
                t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? lt : ut) : this.type = t, e && g.extend(this, e), this.timeStamp = t && t.timeStamp || g.now(), this[g.expando] = !0
            }, g.Event.prototype = {
                constructor: g.Event,
                isDefaultPrevented: ut,
                isPropagationStopped: ut,
                isImmediatePropagationStopped: ut,
                isSimulated: !1,
                preventDefault: function() {
                    var t = this.originalEvent;
                    this.isDefaultPrevented = lt, t && !this.isSimulated && t.preventDefault()
                },
                stopPropagation: function() {
                    var t = this.originalEvent;
                    this.isPropagationStopped = lt, t && !this.isSimulated && t.stopPropagation()
                },
                stopImmediatePropagation: function() {
                    var t = this.originalEvent;
                    this.isImmediatePropagationStopped = lt, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
                }
            }, g.each({
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout"
            }, function(t, e) {
                g.event.special[t] = {
                    delegateType: e,
                    bindType: e,
                    handle: function(t) {
                        var i, n = this,
                            r = t.relatedTarget,
                            s = t.handleObj;
                        return r && (r === n || g.contains(n, r)) || (t.type = s.origType, i = s.handler.apply(this, arguments), t.type = e), i
                    }
                }
            }), g.fn.extend({
                on: function(t, e, i, n) {
                    return dt(this, t, e, i, n)
                },
                one: function(t, e, i, n) {
                    return dt(this, t, e, i, n, 1)
                },
                off: function(t, e, i) {
                    var n, r;
                    if (t && t.preventDefault && t.handleObj) return n = t.handleObj, g(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                    if ("object" == typeof t) {
                        for (r in t) this.off(r, e, t[r]);
                        return this
                    }
                    return !1 !== e && "function" != typeof e || (i = e, e = void 0), !1 === i && (i = ut), this.each(function() {
                        g.event.remove(this, t, i, e)
                    })
                }
            });
            var ht = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
                pt = /<script|<style|<link/i,
                ft = /checked\s*(?:[^=]|=\s*.checked.)/i,
                gt = /^true\/(.*)/,
                mt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

            function _t(t, e) {
                return g.nodeName(t, "table") && g.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
            }

            function yt(t) {
                return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
            }

            function vt(t) {
                var e = gt.exec(t.type);
                return e ? t.type = e[1] : t.removeAttribute("type"), t
            }

            function wt(t, e) {
                var i, n, r, s, o, a, l, u;
                if (1 === e.nodeType) {
                    if (N.hasData(t) && (s = N.access(t), o = N.set(e, s), u = s.events))
                        for (r in delete o.handle, o.events = {}, u)
                            for (i = 0, n = u[r].length; i < n; i++) g.event.add(e, r, u[r][i]);
                    W.hasData(t) && (a = W.access(t), l = g.extend({}, a), W.set(e, l))
                }
            }

            function bt(t, e, i, n) {
                e = l.apply([], e);
                var r, s, o, a, u, c, d = 0,
                    h = t.length,
                    p = h - 1,
                    m = e[0],
                    _ = g.isFunction(m);
                if (_ || h > 1 && "string" == typeof m && !f.checkClone && ft.test(m)) return t.each(function(r) {
                    var s = t.eq(r);
                    _ && (e[0] = m.call(this, r, s.html())), bt(s, e, i, n)
                });
                if (h && (s = (r = rt(e, t[0].ownerDocument, !1, t, n)).firstChild, 1 === r.childNodes.length && (r = s), s || n)) {
                    for (a = (o = g.map(Q(r, "script"), yt)).length; d < h; d++) u = r, d !== p && (u = g.clone(u, !0, !0), a && g.merge(o, Q(u, "script"))), i.call(t[d], u, d);
                    if (a)
                        for (c = o[o.length - 1].ownerDocument, g.map(o, vt), d = 0; d < a; d++) u = o[d], Y.test(u.type || "") && !N.access(u, "globalEval") && g.contains(c, u) && (u.src ? g._evalUrl && g._evalUrl(u.src) : g.globalEval(u.textContent.replace(mt, "")))
                }
                return t
            }

            function xt(t, e, i) {
                for (var n, r = e ? g.filter(e, t) : t, s = 0; null != (n = r[s]); s++) i || 1 !== n.nodeType || g.cleanData(Q(n)), n.parentNode && (i && g.contains(n.ownerDocument, n) && tt(Q(n, "script")), n.parentNode.removeChild(n));
                return t
            }
            g.extend({
                htmlPrefilter: function(t) {
                    return t.replace(ht, "<$1></$2>")
                },
                clone: function(t, e, i) {
                    var n, r, s, o, a, l, u, c = t.cloneNode(!0),
                        d = g.contains(t.ownerDocument, t);
                    if (!(f.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || g.isXMLDoc(t)))
                        for (o = Q(c), n = 0, r = (s = Q(t)).length; n < r; n++) a = s[n], l = o[n], u = void 0, "input" === (u = l.nodeName.toLowerCase()) && X.test(a.type) ? l.checked = a.checked : "input" !== u && "textarea" !== u || (l.defaultValue = a.defaultValue);
                    if (e)
                        if (i)
                            for (s = s || Q(t), o = o || Q(c), n = 0, r = s.length; n < r; n++) wt(s[n], o[n]);
                        else wt(t, c);
                    return (o = Q(c, "script")).length > 0 && tt(o, !d && Q(t, "script")), c
                },
                cleanData: function(t) {
                    for (var e, i, n, r = g.event.special, s = 0; void 0 !== (i = t[s]); s++)
                        if (I(i)) {
                            if (e = i[N.expando]) {
                                if (e.events)
                                    for (n in e.events) r[n] ? g.event.remove(i, n) : g.removeEvent(i, n, e.handle);
                                i[N.expando] = void 0
                            }
                            i[W.expando] && (i[W.expando] = void 0)
                        }
                }
            }), g.fn.extend({
                domManip: bt,
                detach: function(t) {
                    return xt(this, t, !0)
                },
                remove: function(t) {
                    return xt(this, t)
                },
                text: function(t) {
                    return q(this, function(t) {
                        return void 0 === t ? g.text(this) : this.empty().each(function() {
                            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                        })
                    }, null, t, arguments.length)
                },
                append: function() {
                    return bt(this, arguments, function(t) {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || _t(this, t).appendChild(t)
                    })
                },
                prepend: function() {
                    return bt(this, arguments, function(t) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var e = _t(this, t);
                            e.insertBefore(t, e.firstChild)
                        }
                    })
                },
                before: function() {
                    return bt(this, arguments, function(t) {
                        this.parentNode && this.parentNode.insertBefore(t, this)
                    })
                },
                after: function() {
                    return bt(this, arguments, function(t) {
                        this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
                    })
                },
                empty: function() {
                    for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (g.cleanData(Q(t, !1)), t.textContent = "");
                    return this
                },
                clone: function(t, e) {
                    return t = null != t && t, e = null == e ? t : e, this.map(function() {
                        return g.clone(this, t, e)
                    })
                },
                html: function(t) {
                    return q(this, function(t) {
                        var e = this[0] || {},
                            i = 0,
                            n = this.length;
                        if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                        if ("string" == typeof t && !pt.test(t) && !Z[(J.exec(t) || ["", ""])[1].toLowerCase()]) {
                            t = g.htmlPrefilter(t);
                            try {
                                for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (g.cleanData(Q(e, !1)), e.innerHTML = t);
                                e = 0
                            } catch (t) {}
                        }
                        e && this.empty().append(t)
                    }, null, t, arguments.length)
                },
                replaceWith: function() {
                    var t = [];
                    return bt(this, arguments, function(e) {
                        var i = this.parentNode;
                        g.inArray(this, t) < 0 && (g.cleanData(Q(this)), i && i.replaceChild(e, this))
                    }, t)
                }
            }), g.each({
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith"
            }, function(t, e) {
                g.fn[t] = function(t) {
                    for (var i, n = [], r = g(t), s = r.length - 1, o = 0; o <= s; o++) i = o === s ? this : this.clone(!0), g(r[o])[e](i), u.apply(n, i.get());
                    return this.pushStack(n)
                }
            });
            var Tt, Et = {
                HTML: "block",
                BODY: "block"
            };

            function Ot(t, e) {
                var i = g(e.createElement(t)).appendTo(e.body),
                    n = g.css(i[0], "display");
                return i.detach(), n
            }

            function Ct(t) {
                var e = o,
                    i = Et[t];
                return i || ("none" !== (i = Ot(t, e)) && i || ((e = (Tt = (Tt || g("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement))[0].contentDocument).write(), e.close(), i = Ot(t, e), Tt.detach()), Et[t] = i), i
            }
            var Pt = /^margin/,
                Dt = new RegExp("^(" + H + ")(?!px)[a-z%]+$", "i"),
                Mt = function(t) {
                    var e = t.ownerDocument.defaultView;
                    return e && e.opener || (e = i), e.getComputedStyle(t)
                },
                Rt = function(t, e, i, n) {
                    var r, s, o = {};
                    for (s in e) o[s] = t.style[s], t.style[s] = e[s];
                    for (s in r = i.apply(t, n || []), e) t.style[s] = o[s];
                    return r
                },
                kt = o.documentElement;

            function St(t, e, i) {
                var n, r, s, o, a = t.style;
                return "" !== (o = (i = i || Mt(t)) ? i.getPropertyValue(e) || i[e] : void 0) && void 0 !== o || g.contains(t.ownerDocument, t) || (o = g.style(t, e)), i && !f.pixelMarginRight() && Dt.test(o) && Pt.test(e) && (n = a.width, r = a.minWidth, s = a.maxWidth, a.minWidth = a.maxWidth = a.width = o, o = i.width, a.width = n, a.minWidth = r, a.maxWidth = s), void 0 !== o ? o + "" : o
            }

            function Lt(t, e) {
                return {
                    get: function() {
                        if (!t()) return (this.get = e).apply(this, arguments);
                        delete this.get
                    }
                }
            }! function() {
                var t, e, n, r, s = o.createElement("div"),
                    a = o.createElement("div");

                function l() {
                    a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", kt.appendChild(s);
                    var o = i.getComputedStyle(a);
                    t = "1%" !== o.top, r = "2px" === o.marginLeft, e = "4px" === o.width, a.style.marginRight = "50%", n = "4px" === o.marginRight, kt.removeChild(s)
                }
                a.style && (a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", f.clearCloneStyle = "content-box" === a.style.backgroundClip, s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", s.appendChild(a), g.extend(f, {
                    pixelPosition: function() {
                        return l(), t
                    },
                    boxSizingReliable: function() {
                        return null == e && l(), e
                    },
                    pixelMarginRight: function() {
                        return null == e && l(), n
                    },
                    reliableMarginLeft: function() {
                        return null == e && l(), r
                    },
                    reliableMarginRight: function() {
                        var t, e = a.appendChild(o.createElement("div"));
                        return e.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", e.style.marginRight = e.style.width = "0", a.style.width = "1px", kt.appendChild(s), t = !parseFloat(i.getComputedStyle(e).marginRight), kt.removeChild(s), a.removeChild(e), t
                    }
                }))
            }();
            var jt = /^(none|table(?!-c[ea]).+)/,
                At = {
                    position: "absolute",
                    visibility: "hidden",
                    display: "block"
                },
                qt = {
                    letterSpacing: "0",
                    fontWeight: "400"
                },
                It = ["Webkit", "O", "Moz", "ms"],
                Bt = o.createElement("div").style;

            function Nt(t) {
                if (t in Bt) return t;
                for (var e = t[0].toUpperCase() + t.slice(1), i = It.length; i--;)
                    if ((t = It[i] + e) in Bt) return t
            }

            function Wt(t, e, i) {
                var n = z.exec(e);
                return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e
            }

            function $t(t, e, i, n, r) {
                for (var s = i === (n ? "border" : "content") ? 4 : "width" === e ? 1 : 0, o = 0; s < 4; s += 2) "margin" === i && (o += g.css(t, i + K[s], !0, r)), n ? ("content" === i && (o -= g.css(t, "padding" + K[s], !0, r)), "margin" !== i && (o -= g.css(t, "border" + K[s] + "Width", !0, r))) : (o += g.css(t, "padding" + K[s], !0, r), "padding" !== i && (o += g.css(t, "border" + K[s] + "Width", !0, r)));
                return o
            }

            function Ft(t, e, i) {
                var n = !0,
                    r = "width" === e ? t.offsetWidth : t.offsetHeight,
                    s = Mt(t),
                    o = "border-box" === g.css(t, "boxSizing", !1, s);
                if (r <= 0 || null == r) {
                    if (((r = St(t, e, s)) < 0 || null == r) && (r = t.style[e]), Dt.test(r)) return r;
                    n = o && (f.boxSizingReliable() || r === t.style[e]), r = parseFloat(r) || 0
                }
                return r + $t(t, e, i || (o ? "border" : "content"), n, s) + "px"
            }

            function Ut(t, e) {
                for (var i, n, r, s = [], o = 0, a = t.length; o < a; o++)(n = t[o]).style && (s[o] = N.get(n, "olddisplay"), i = n.style.display, e ? (s[o] || "none" !== i || (n.style.display = ""), "" === n.style.display && V(n) && (s[o] = N.access(n, "olddisplay", Ct(n.nodeName)))) : (r = V(n), "none" === i && r || N.set(n, "olddisplay", r ? i : g.css(n, "display"))));
                for (o = 0; o < a; o++)(n = t[o]).style && (e && "none" !== n.style.display && "" !== n.style.display || (n.style.display = e ? s[o] || "" : "none"));
                return t
            }

            function Ht(t, e, i, n, r) {
                return new Ht.prototype.init(t, e, i, n, r)
            }
            g.extend({
                cssHooks: {
                    opacity: {
                        get: function(t, e) {
                            if (e) {
                                var i = St(t, "opacity");
                                return "" === i ? "1" : i
                            }
                        }
                    }
                },
                cssNumber: {
                    animationIterationCount: !0,
                    columnCount: !0,
                    fillOpacity: !0,
                    flexGrow: !0,
                    flexShrink: !0,
                    fontWeight: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0
                },
                cssProps: {
                    float: "cssFloat"
                },
                style: function(t, e, i, n) {
                    if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                        var r, s, o, a = g.camelCase(e),
                            l = t.style;
                        if (e = g.cssProps[a] || (g.cssProps[a] = Nt(a) || a), o = g.cssHooks[e] || g.cssHooks[a], void 0 === i) return o && "get" in o && void 0 !== (r = o.get(t, !1, n)) ? r : l[e];
                        "string" === (s = typeof i) && (r = z.exec(i)) && r[1] && (i = G(t, e, r), s = "number"), null != i && i == i && ("number" === s && (i += r && r[3] || (g.cssNumber[a] ? "" : "px")), f.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (l[e] = "inherit"), o && "set" in o && void 0 === (i = o.set(t, i, n)) || (l[e] = i))
                    }
                },
                css: function(t, e, i, n) {
                    var r, s, o, a = g.camelCase(e);
                    return e = g.cssProps[a] || (g.cssProps[a] = Nt(a) || a), (o = g.cssHooks[e] || g.cssHooks[a]) && "get" in o && (r = o.get(t, !0, i)), void 0 === r && (r = St(t, e, n)), "normal" === r && e in qt && (r = qt[e]), "" === i || i ? (s = parseFloat(r), !0 === i || isFinite(s) ? s || 0 : r) : r
                }
            }), g.each(["height", "width"], function(t, e) {
                g.cssHooks[e] = {
                    get: function(t, i, n) {
                        if (i) return jt.test(g.css(t, "display")) && 0 === t.offsetWidth ? Rt(t, At, function() {
                            return Ft(t, e, n)
                        }) : Ft(t, e, n)
                    },
                    set: function(t, i, n) {
                        var r, s = n && Mt(t),
                            o = n && $t(t, e, n, "border-box" === g.css(t, "boxSizing", !1, s), s);
                        return o && (r = z.exec(i)) && "px" !== (r[3] || "px") && (t.style[e] = i, i = g.css(t, e)), Wt(0, i, o)
                    }
                }
            }), g.cssHooks.marginLeft = Lt(f.reliableMarginLeft, function(t, e) {
                if (e) return (parseFloat(St(t, "marginLeft")) || t.getBoundingClientRect().left - Rt(t, {
                    marginLeft: 0
                }, function() {
                    return t.getBoundingClientRect().left
                })) + "px"
            }), g.cssHooks.marginRight = Lt(f.reliableMarginRight, function(t, e) {
                if (e) return Rt(t, {
                    display: "inline-block"
                }, St, [t, "marginRight"])
            }), g.each({
                margin: "",
                padding: "",
                border: "Width"
            }, function(t, e) {
                g.cssHooks[t + e] = {
                    expand: function(i) {
                        for (var n = 0, r = {}, s = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) r[t + K[n] + e] = s[n] || s[n - 2] || s[0];
                        return r
                    }
                }, Pt.test(t) || (g.cssHooks[t + e].set = Wt)
            }), g.fn.extend({
                css: function(t, e) {
                    return q(this, function(t, e, i) {
                        var n, r, s = {},
                            o = 0;
                        if (g.isArray(e)) {
                            for (n = Mt(t), r = e.length; o < r; o++) s[e[o]] = g.css(t, e[o], !1, n);
                            return s
                        }
                        return void 0 !== i ? g.style(t, e, i) : g.css(t, e)
                    }, t, e, arguments.length > 1)
                },
                show: function() {
                    return Ut(this, !0)
                },
                hide: function() {
                    return Ut(this)
                },
                toggle: function(t) {
                    return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                        V(this) ? g(this).show() : g(this).hide()
                    })
                }
            }), g.Tween = Ht, Ht.prototype = {
                constructor: Ht,
                init: function(t, e, i, n, r, s) {
                    this.elem = t, this.prop = i, this.easing = r || g.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = n, this.unit = s || (g.cssNumber[i] ? "" : "px")
                },
                cur: function() {
                    var t = Ht.propHooks[this.prop];
                    return t && t.get ? t.get(this) : Ht.propHooks._default.get(this)
                },
                run: function(t) {
                    var e, i = Ht.propHooks[this.prop];
                    return this.options.duration ? this.pos = e = g.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), i && i.set ? i.set(this) : Ht.propHooks._default.set(this), this
                }
            }, Ht.prototype.init.prototype = Ht.prototype, Ht.propHooks = {
                _default: {
                    get: function(t) {
                        var e;
                        return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = g.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
                    },
                    set: function(t) {
                        g.fx.step[t.prop] ? g.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[g.cssProps[t.prop]] && !g.cssHooks[t.prop] ? t.elem[t.prop] = t.now : g.style(t.elem, t.prop, t.now + t.unit)
                    }
                }
            }, Ht.propHooks.scrollTop = Ht.propHooks.scrollLeft = {
                set: function(t) {
                    t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
                }
            }, g.easing = {
                linear: function(t) {
                    return t
                },
                swing: function(t) {
                    return .5 - Math.cos(t * Math.PI) / 2
                },
                _default: "swing"
            }, g.fx = Ht.prototype.init, g.fx.step = {};
            var zt, Kt, Vt = /^(?:toggle|show|hide)$/,
                Gt = /queueHooks$/;

            function Xt() {
                return i.setTimeout(function() {
                    zt = void 0
                }), zt = g.now()
            }

            function Jt(t, e) {
                var i, n = 0,
                    r = {
                        height: t
                    };
                for (e = e ? 1 : 0; n < 4; n += 2 - e) r["margin" + (i = K[n])] = r["padding" + i] = t;
                return e && (r.opacity = r.width = t), r
            }

            function Yt(t, e, i) {
                for (var n, r = (Zt.tweeners[e] || []).concat(Zt.tweeners["*"]), s = 0, o = r.length; s < o; s++)
                    if (n = r[s].call(i, e, t)) return n
            }

            function Zt(t, e, i) {
                var n, r, s = 0,
                    o = Zt.prefilters.length,
                    a = g.Deferred().always(function() {
                        delete l.elem
                    }),
                    l = function() {
                        if (r) return !1;
                        for (var e = zt || Xt(), i = Math.max(0, u.startTime + u.duration - e), n = 1 - (i / u.duration || 0), s = 0, o = u.tweens.length; s < o; s++) u.tweens[s].run(n);
                        return a.notifyWith(t, [u, n, i]), n < 1 && o ? i : (a.resolveWith(t, [u]), !1)
                    },
                    u = a.promise({
                        elem: t,
                        props: g.extend({}, e),
                        opts: g.extend(!0, {
                            specialEasing: {},
                            easing: g.easing._default
                        }, i),
                        originalProperties: e,
                        originalOptions: i,
                        startTime: zt || Xt(),
                        duration: i.duration,
                        tweens: [],
                        createTween: function(e, i) {
                            var n = g.Tween(t, u.opts, e, i, u.opts.specialEasing[e] || u.opts.easing);
                            return u.tweens.push(n), n
                        },
                        stop: function(e) {
                            var i = 0,
                                n = e ? u.tweens.length : 0;
                            if (r) return this;
                            for (r = !0; i < n; i++) u.tweens[i].run(1);
                            return e ? (a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u, e])) : a.rejectWith(t, [u, e]), this
                        }
                    }),
                    c = u.props;
                for (! function(t, e) {
                        var i, n, r, s, o;
                        for (i in t)
                            if (r = e[n = g.camelCase(i)], s = t[i], g.isArray(s) && (r = s[1], s = t[i] = s[0]), i !== n && (t[n] = s, delete t[i]), (o = g.cssHooks[n]) && "expand" in o)
                                for (i in s = o.expand(s), delete t[n], s) i in t || (t[i] = s[i], e[i] = r);
                            else e[n] = r
                    }(c, u.opts.specialEasing); s < o; s++)
                    if (n = Zt.prefilters[s].call(u, t, c, u.opts)) return g.isFunction(n.stop) && (g._queueHooks(u.elem, u.opts.queue).stop = g.proxy(n.stop, n)), n;
                return g.map(c, Yt, u), g.isFunction(u.opts.start) && u.opts.start.call(t, u), g.fx.timer(g.extend(l, {
                    elem: t,
                    anim: u,
                    queue: u.opts.queue
                })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
            }
            g.Animation = g.extend(Zt, {
                    tweeners: {
                        "*": [function(t, e) {
                            var i = this.createTween(t, e);
                            return G(i.elem, t, z.exec(e), i), i
                        }]
                    },
                    tweener: function(t, e) {
                        g.isFunction(t) ? (e = t, t = ["*"]) : t = t.match(j);
                        for (var i, n = 0, r = t.length; n < r; n++) i = t[n], Zt.tweeners[i] = Zt.tweeners[i] || [], Zt.tweeners[i].unshift(e)
                    },
                    prefilters: [function(t, e, i) {
                        var n, r, s, o, a, l, u, c = this,
                            d = {},
                            h = t.style,
                            p = t.nodeType && V(t),
                            f = N.get(t, "fxshow");
                        for (n in i.queue || (null == (a = g._queueHooks(t, "fx")).unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function() {
                                a.unqueued || l()
                            }), a.unqueued++, c.always(function() {
                                c.always(function() {
                                    a.unqueued--, g.queue(t, "fx").length || a.empty.fire()
                                })
                            })), 1 === t.nodeType && ("height" in e || "width" in e) && (i.overflow = [h.overflow, h.overflowX, h.overflowY], "inline" === ("none" === (u = g.css(t, "display")) ? N.get(t, "olddisplay") || Ct(t.nodeName) : u) && "none" === g.css(t, "float") && (h.display = "inline-block")), i.overflow && (h.overflow = "hidden", c.always(function() {
                                h.overflow = i.overflow[0], h.overflowX = i.overflow[1], h.overflowY = i.overflow[2]
                            })), e)
                            if (r = e[n], Vt.exec(r)) {
                                if (delete e[n], s = s || "toggle" === r, r === (p ? "hide" : "show")) {
                                    if ("show" !== r || !f || void 0 === f[n]) continue;
                                    p = !0
                                }
                                d[n] = f && f[n] || g.style(t, n)
                            } else u = void 0;
                        if (g.isEmptyObject(d)) "inline" === ("none" === u ? Ct(t.nodeName) : u) && (h.display = u);
                        else
                            for (n in f ? "hidden" in f && (p = f.hidden) : f = N.access(t, "fxshow", {}), s && (f.hidden = !p), p ? g(t).show() : c.done(function() {
                                    g(t).hide()
                                }), c.done(function() {
                                    var e;
                                    for (e in N.remove(t, "fxshow"), d) g.style(t, e, d[e])
                                }), d) o = Yt(p ? f[n] : 0, n, c), n in f || (f[n] = o.start, p && (o.end = o.start, o.start = "width" === n || "height" === n ? 1 : 0))
                    }],
                    prefilter: function(t, e) {
                        e ? Zt.prefilters.unshift(t) : Zt.prefilters.push(t)
                    }
                }), g.speed = function(t, e, i) {
                    var n = t && "object" == typeof t ? g.extend({}, t) : {
                        complete: i || !i && e || g.isFunction(t) && t,
                        duration: t,
                        easing: i && e || e && !g.isFunction(e) && e
                    };
                    return n.duration = g.fx.off ? 0 : "number" == typeof n.duration ? n.duration : n.duration in g.fx.speeds ? g.fx.speeds[n.duration] : g.fx.speeds._default, null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
                        g.isFunction(n.old) && n.old.call(this), n.queue && g.dequeue(this, n.queue)
                    }, n
                }, g.fn.extend({
                    fadeTo: function(t, e, i, n) {
                        return this.filter(V).css("opacity", 0).show().end().animate({
                            opacity: e
                        }, t, i, n)
                    },
                    animate: function(t, e, i, n) {
                        var r = g.isEmptyObject(t),
                            s = g.speed(e, i, n),
                            o = function() {
                                var e = Zt(this, g.extend({}, t), s);
                                (r || N.get(this, "finish")) && e.stop(!0)
                            };
                        return o.finish = o, r || !1 === s.queue ? this.each(o) : this.queue(s.queue, o)
                    },
                    stop: function(t, e, i) {
                        var n = function(t) {
                            var e = t.stop;
                            delete t.stop, e(i)
                        };
                        return "string" != typeof t && (i = e, e = t, t = void 0), e && !1 !== t && this.queue(t || "fx", []), this.each(function() {
                            var e = !0,
                                r = null != t && t + "queueHooks",
                                s = g.timers,
                                o = N.get(this);
                            if (r) o[r] && o[r].stop && n(o[r]);
                            else
                                for (r in o) o[r] && o[r].stop && Gt.test(r) && n(o[r]);
                            for (r = s.length; r--;) s[r].elem !== this || null != t && s[r].queue !== t || (s[r].anim.stop(i), e = !1, s.splice(r, 1));
                            !e && i || g.dequeue(this, t)
                        })
                    },
                    finish: function(t) {
                        return !1 !== t && (t = t || "fx"), this.each(function() {
                            var e, i = N.get(this),
                                n = i[t + "queue"],
                                r = i[t + "queueHooks"],
                                s = g.timers,
                                o = n ? n.length : 0;
                            for (i.finish = !0, g.queue(this, t, []), r && r.stop && r.stop.call(this, !0), e = s.length; e--;) s[e].elem === this && s[e].queue === t && (s[e].anim.stop(!0), s.splice(e, 1));
                            for (e = 0; e < o; e++) n[e] && n[e].finish && n[e].finish.call(this);
                            delete i.finish
                        })
                    }
                }), g.each(["toggle", "show", "hide"], function(t, e) {
                    var i = g.fn[e];
                    g.fn[e] = function(t, n, r) {
                        return null == t || "boolean" == typeof t ? i.apply(this, arguments) : this.animate(Jt(e, !0), t, n, r)
                    }
                }), g.each({
                    slideDown: Jt("show"),
                    slideUp: Jt("hide"),
                    slideToggle: Jt("toggle"),
                    fadeIn: {
                        opacity: "show"
                    },
                    fadeOut: {
                        opacity: "hide"
                    },
                    fadeToggle: {
                        opacity: "toggle"
                    }
                }, function(t, e) {
                    g.fn[t] = function(t, i, n) {
                        return this.animate(e, t, i, n)
                    }
                }), g.timers = [], g.fx.tick = function() {
                    var t, e = 0,
                        i = g.timers;
                    for (zt = g.now(); e < i.length; e++)(t = i[e])() || i[e] !== t || i.splice(e--, 1);
                    i.length || g.fx.stop(), zt = void 0
                }, g.fx.timer = function(t) {
                    g.timers.push(t), t() ? g.fx.start() : g.timers.pop()
                }, g.fx.interval = 13, g.fx.start = function() {
                    Kt || (Kt = i.setInterval(g.fx.tick, g.fx.interval))
                }, g.fx.stop = function() {
                    i.clearInterval(Kt), Kt = null
                }, g.fx.speeds = {
                    slow: 600,
                    fast: 200,
                    _default: 400
                }, g.fn.delay = function(t, e) {
                    return t = g.fx && g.fx.speeds[t] || t, e = e || "fx", this.queue(e, function(e, n) {
                        var r = i.setTimeout(e, t);
                        n.stop = function() {
                            i.clearTimeout(r)
                        }
                    })
                },
                function() {
                    var t = o.createElement("input"),
                        e = o.createElement("select"),
                        i = e.appendChild(o.createElement("option"));
                    t.type = "checkbox", f.checkOn = "" !== t.value, f.optSelected = i.selected, e.disabled = !0, f.optDisabled = !i.disabled, (t = o.createElement("input")).value = "t", t.type = "radio", f.radioValue = "t" === t.value
                }();
            var Qt, te = g.expr.attrHandle;
            g.fn.extend({
                attr: function(t, e) {
                    return q(this, g.attr, t, e, arguments.length > 1)
                },
                removeAttr: function(t) {
                    return this.each(function() {
                        g.removeAttr(this, t)
                    })
                }
            }), g.extend({
                attr: function(t, e, i) {
                    var n, r, s = t.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s) return void 0 === t.getAttribute ? g.prop(t, e, i) : (1 === s && g.isXMLDoc(t) || (e = e.toLowerCase(), r = g.attrHooks[e] || (g.expr.match.bool.test(e) ? Qt : void 0)), void 0 !== i ? null === i ? void g.removeAttr(t, e) : r && "set" in r && void 0 !== (n = r.set(t, i, e)) ? n : (t.setAttribute(e, i + ""), i) : r && "get" in r && null !== (n = r.get(t, e)) ? n : null == (n = g.find.attr(t, e)) ? void 0 : n)
                },
                attrHooks: {
                    type: {
                        set: function(t, e) {
                            if (!f.radioValue && "radio" === e && g.nodeName(t, "input")) {
                                var i = t.value;
                                return t.setAttribute("type", e), i && (t.value = i), e
                            }
                        }
                    }
                },
                removeAttr: function(t, e) {
                    var i, n, r = 0,
                        s = e && e.match(j);
                    if (s && 1 === t.nodeType)
                        for (; i = s[r++];) n = g.propFix[i] || i, g.expr.match.bool.test(i) && (t[n] = !1), t.removeAttribute(i)
                }
            }), Qt = {
                set: function(t, e, i) {
                    return !1 === e ? g.removeAttr(t, i) : t.setAttribute(i, i), i
                }
            }, g.each(g.expr.match.bool.source.match(/\w+/g), function(t, e) {
                var i = te[e] || g.find.attr;
                te[e] = function(t, e, n) {
                    var r, s;
                    return n || (s = te[e], te[e] = r, r = null != i(t, e, n) ? e.toLowerCase() : null, te[e] = s), r
                }
            });
            var ee = /^(?:input|select|textarea|button)$/i,
                ie = /^(?:a|area)$/i;
            g.fn.extend({
                prop: function(t, e) {
                    return q(this, g.prop, t, e, arguments.length > 1)
                },
                removeProp: function(t) {
                    return this.each(function() {
                        delete this[g.propFix[t] || t]
                    })
                }
            }), g.extend({
                prop: function(t, e, i) {
                    var n, r, s = t.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s) return 1 === s && g.isXMLDoc(t) || (e = g.propFix[e] || e, r = g.propHooks[e]), void 0 !== i ? r && "set" in r && void 0 !== (n = r.set(t, i, e)) ? n : t[e] = i : r && "get" in r && null !== (n = r.get(t, e)) ? n : t[e]
                },
                propHooks: {
                    tabIndex: {
                        get: function(t) {
                            var e = g.find.attr(t, "tabindex");
                            return e ? parseInt(e, 10) : ee.test(t.nodeName) || ie.test(t.nodeName) && t.href ? 0 : -1
                        }
                    }
                },
                propFix: {
                    for: "htmlFor",
                    class: "className"
                }
            }), f.optSelected || (g.propHooks.selected = {
                get: function(t) {
                    var e = t.parentNode;
                    return e && e.parentNode && e.parentNode.selectedIndex, null
                },
                set: function(t) {
                    var e = t.parentNode;
                    e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
                }
            }), g.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
                g.propFix[this.toLowerCase()] = this
            });
            var ne = /[\t\r\n\f]/g;

            function re(t) {
                return t.getAttribute && t.getAttribute("class") || ""
            }
            g.fn.extend({
                addClass: function(t) {
                    var e, i, n, r, s, o, a, l = 0;
                    if (g.isFunction(t)) return this.each(function(e) {
                        g(this).addClass(t.call(this, e, re(this)))
                    });
                    if ("string" == typeof t && t)
                        for (e = t.match(j) || []; i = this[l++];)
                            if (r = re(i), n = 1 === i.nodeType && (" " + r + " ").replace(ne, " ")) {
                                for (o = 0; s = e[o++];) n.indexOf(" " + s + " ") < 0 && (n += s + " ");
                                r !== (a = g.trim(n)) && i.setAttribute("class", a)
                            } return this
                },
                removeClass: function(t) {
                    var e, i, n, r, s, o, a, l = 0;
                    if (g.isFunction(t)) return this.each(function(e) {
                        g(this).removeClass(t.call(this, e, re(this)))
                    });
                    if (!arguments.length) return this.attr("class", "");
                    if ("string" == typeof t && t)
                        for (e = t.match(j) || []; i = this[l++];)
                            if (r = re(i), n = 1 === i.nodeType && (" " + r + " ").replace(ne, " ")) {
                                for (o = 0; s = e[o++];)
                                    for (; n.indexOf(" " + s + " ") > -1;) n = n.replace(" " + s + " ", " ");
                                r !== (a = g.trim(n)) && i.setAttribute("class", a)
                            } return this
                },
                toggleClass: function(t, e) {
                    var i = typeof t;
                    return "boolean" == typeof e && "string" === i ? e ? this.addClass(t) : this.removeClass(t) : g.isFunction(t) ? this.each(function(i) {
                        g(this).toggleClass(t.call(this, i, re(this), e), e)
                    }) : this.each(function() {
                        var e, n, r, s;
                        if ("string" === i)
                            for (n = 0, r = g(this), s = t.match(j) || []; e = s[n++];) r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                        else void 0 !== t && "boolean" !== i || ((e = re(this)) && N.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : N.get(this, "__className__") || ""))
                    })
                },
                hasClass: function(t) {
                    var e, i, n = 0;
                    for (e = " " + t + " "; i = this[n++];)
                        if (1 === i.nodeType && (" " + re(i) + " ").replace(ne, " ").indexOf(e) > -1) return !0;
                    return !1
                }
            });
            var se = /\r/g,
                oe = /[\x20\t\r\n\f]+/g;
            g.fn.extend({
                val: function(t) {
                    var e, i, n, r = this[0];
                    return arguments.length ? (n = g.isFunction(t), this.each(function(i) {
                        var r;
                        1 === this.nodeType && (null == (r = n ? t.call(this, i, g(this).val()) : t) ? r = "" : "number" == typeof r ? r += "" : g.isArray(r) && (r = g.map(r, function(t) {
                            return null == t ? "" : t + ""
                        })), (e = g.valHooks[this.type] || g.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, r, "value") || (this.value = r))
                    })) : r ? (e = g.valHooks[r.type] || g.valHooks[r.nodeName.toLowerCase()]) && "get" in e && void 0 !== (i = e.get(r, "value")) ? i : "string" == typeof(i = r.value) ? i.replace(se, "") : null == i ? "" : i : void 0
                }
            }), g.extend({
                valHooks: {
                    option: {
                        get: function(t) {
                            var e = g.find.attr(t, "value");
                            return null != e ? e : g.trim(g.text(t)).replace(oe, " ")
                        }
                    },
                    select: {
                        get: function(t) {
                            for (var e, i, n = t.options, r = t.selectedIndex, s = "select-one" === t.type || r < 0, o = s ? null : [], a = s ? r + 1 : n.length, l = r < 0 ? a : s ? r : 0; l < a; l++)
                                if (((i = n[l]).selected || l === r) && (f.optDisabled ? !i.disabled : null === i.getAttribute("disabled")) && (!i.parentNode.disabled || !g.nodeName(i.parentNode, "optgroup"))) {
                                    if (e = g(i).val(), s) return e;
                                    o.push(e)
                                } return o
                        },
                        set: function(t, e) {
                            for (var i, n, r = t.options, s = g.makeArray(e), o = r.length; o--;)((n = r[o]).selected = g.inArray(g.valHooks.option.get(n), s) > -1) && (i = !0);
                            return i || (t.selectedIndex = -1), s
                        }
                    }
                }
            }), g.each(["radio", "checkbox"], function() {
                g.valHooks[this] = {
                    set: function(t, e) {
                        if (g.isArray(e)) return t.checked = g.inArray(g(t).val(), e) > -1
                    }
                }, f.checkOn || (g.valHooks[this].get = function(t) {
                    return null === t.getAttribute("value") ? "on" : t.value
                })
            });
            var ae = /^(?:focusinfocus|focusoutblur)$/;
            g.extend(g.event, {
                trigger: function(t, e, n, r) {
                    var s, a, l, u, c, d, h, f = [n || o],
                        m = p.call(t, "type") ? t.type : t,
                        _ = p.call(t, "namespace") ? t.namespace.split(".") : [];
                    if (a = l = n = n || o, 3 !== n.nodeType && 8 !== n.nodeType && !ae.test(m + g.event.triggered) && (m.indexOf(".") > -1 && (_ = m.split("."), m = _.shift(), _.sort()), c = m.indexOf(":") < 0 && "on" + m, (t = t[g.expando] ? t : new g.Event(m, "object" == typeof t && t)).isTrigger = r ? 2 : 3, t.namespace = _.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + _.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), e = null == e ? [t] : g.makeArray(e, [t]), h = g.event.special[m] || {}, r || !h.trigger || !1 !== h.trigger.apply(n, e))) {
                        if (!r && !h.noBubble && !g.isWindow(n)) {
                            for (u = h.delegateType || m, ae.test(u + m) || (a = a.parentNode); a; a = a.parentNode) f.push(a), l = a;
                            l === (n.ownerDocument || o) && f.push(l.defaultView || l.parentWindow || i)
                        }
                        for (s = 0;
                            (a = f[s++]) && !t.isPropagationStopped();) t.type = s > 1 ? u : h.bindType || m, (d = (N.get(a, "events") || {})[t.type] && N.get(a, "handle")) && d.apply(a, e), (d = c && a[c]) && d.apply && I(a) && (t.result = d.apply(a, e), !1 === t.result && t.preventDefault());
                        return t.type = m, r || t.isDefaultPrevented() || h._default && !1 !== h._default.apply(f.pop(), e) || !I(n) || c && g.isFunction(n[m]) && !g.isWindow(n) && ((l = n[c]) && (n[c] = null), g.event.triggered = m, n[m](), g.event.triggered = void 0, l && (n[c] = l)), t.result
                    }
                },
                simulate: function(t, e, i) {
                    var n = g.extend(new g.Event, i, {
                        type: t,
                        isSimulated: !0
                    });
                    g.event.trigger(n, null, e)
                }
            }), g.fn.extend({
                trigger: function(t, e) {
                    return this.each(function() {
                        g.event.trigger(t, e, this)
                    })
                },
                triggerHandler: function(t, e) {
                    var i = this[0];
                    if (i) return g.event.trigger(t, e, i, !0)
                }
            }), g.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(t, e) {
                g.fn[e] = function(t, i) {
                    return arguments.length > 0 ? this.on(e, null, t, i) : this.trigger(e)
                }
            }), g.fn.extend({
                hover: function(t, e) {
                    return this.mouseenter(t).mouseleave(e || t)
                }
            }), f.focusin = "onfocusin" in i, f.focusin || g.each({
                focus: "focusin",
                blur: "focusout"
            }, function(t, e) {
                var i = function(t) {
                    g.event.simulate(e, t.target, g.event.fix(t))
                };
                g.event.special[e] = {
                    setup: function() {
                        var n = this.ownerDocument || this,
                            r = N.access(n, e);
                        r || n.addEventListener(t, i, !0), N.access(n, e, (r || 0) + 1)
                    },
                    teardown: function() {
                        var n = this.ownerDocument || this,
                            r = N.access(n, e) - 1;
                        r ? N.access(n, e, r) : (n.removeEventListener(t, i, !0), N.remove(n, e))
                    }
                }
            });
            var le = i.location,
                ue = g.now(),
                ce = /\?/;
            g.parseJSON = function(t) {
                return JSON.parse(t + "")
            }, g.parseXML = function(t) {
                var e;
                if (!t || "string" != typeof t) return null;
                try {
                    e = (new i.DOMParser).parseFromString(t, "text/xml")
                } catch (t) {
                    e = void 0
                }
                return e && !e.getElementsByTagName("parsererror").length || g.error("Invalid XML: " + t), e
            };
            var de = /#.*$/,
                he = /([?&])_=[^&]*/,
                pe = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                fe = /^(?:GET|HEAD)$/,
                ge = /^\/\//,
                me = {},
                _e = {},
                ye = "*/".concat("*"),
                ve = o.createElement("a");

            function we(t) {
                return function(e, i) {
                    "string" != typeof e && (i = e, e = "*");
                    var n, r = 0,
                        s = e.toLowerCase().match(j) || [];
                    if (g.isFunction(i))
                        for (; n = s[r++];) "+" === n[0] ? (n = n.slice(1) || "*", (t[n] = t[n] || []).unshift(i)) : (t[n] = t[n] || []).push(i)
                }
            }

            function be(t, e, i, n) {
                var r = {},
                    s = t === _e;

                function o(a) {
                    var l;
                    return r[a] = !0, g.each(t[a] || [], function(t, a) {
                        var u = a(e, i, n);
                        return "string" != typeof u || s || r[u] ? s ? !(l = u) : void 0 : (e.dataTypes.unshift(u), o(u), !1)
                    }), l
                }
                return o(e.dataTypes[0]) || !r["*"] && o("*")
            }

            function xe(t, e) {
                var i, n, r = g.ajaxSettings.flatOptions || {};
                for (i in e) void 0 !== e[i] && ((r[i] ? t : n || (n = {}))[i] = e[i]);
                return n && g.extend(!0, t, n), t
            }
            ve.href = le.href, g.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: le.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(le.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: {
                        "*": ye,
                        text: "text/plain",
                        html: "text/html",
                        xml: "application/xml, text/xml",
                        json: "application/json, text/javascript"
                    },
                    contents: {
                        xml: /\bxml\b/,
                        html: /\bhtml/,
                        json: /\bjson\b/
                    },
                    responseFields: {
                        xml: "responseXML",
                        text: "responseText",
                        json: "responseJSON"
                    },
                    converters: {
                        "* text": String,
                        "text html": !0,
                        "text json": g.parseJSON,
                        "text xml": g.parseXML
                    },
                    flatOptions: {
                        url: !0,
                        context: !0
                    }
                },
                ajaxSetup: function(t, e) {
                    return e ? xe(xe(t, g.ajaxSettings), e) : xe(g.ajaxSettings, t)
                },
                ajaxPrefilter: we(me),
                ajaxTransport: we(_e),
                ajax: function(t, e) {
                    "object" == typeof t && (e = t, t = void 0), e = e || {};
                    var n, r, s, a, l, u, c, d, h = g.ajaxSetup({}, e),
                        p = h.context || h,
                        f = h.context && (p.nodeType || p.jquery) ? g(p) : g.event,
                        m = g.Deferred(),
                        _ = g.Callbacks("once memory"),
                        y = h.statusCode || {},
                        v = {},
                        w = {},
                        b = 0,
                        x = "canceled",
                        T = {
                            readyState: 0,
                            getResponseHeader: function(t) {
                                var e;
                                if (2 === b) {
                                    if (!a)
                                        for (a = {}; e = pe.exec(s);) a[e[1].toLowerCase()] = e[2];
                                    e = a[t.toLowerCase()]
                                }
                                return null == e ? null : e
                            },
                            getAllResponseHeaders: function() {
                                return 2 === b ? s : null
                            },
                            setRequestHeader: function(t, e) {
                                var i = t.toLowerCase();
                                return b || (t = w[i] = w[i] || t, v[t] = e), this
                            },
                            overrideMimeType: function(t) {
                                return b || (h.mimeType = t), this
                            },
                            statusCode: function(t) {
                                var e;
                                if (t)
                                    if (b < 2)
                                        for (e in t) y[e] = [y[e], t[e]];
                                    else T.always(t[T.status]);
                                return this
                            },
                            abort: function(t) {
                                var e = t || x;
                                return n && n.abort(e), E(0, e), this
                            }
                        };
                    if (m.promise(T).complete = _.add, T.success = T.done, T.error = T.fail, h.url = ((t || h.url || le.href) + "").replace(de, "").replace(ge, le.protocol + "//"), h.type = e.method || e.type || h.method || h.type, h.dataTypes = g.trim(h.dataType || "*").toLowerCase().match(j) || [""], null == h.crossDomain) {
                        u = o.createElement("a");
                        try {
                            u.href = h.url, u.href = u.href, h.crossDomain = ve.protocol + "//" + ve.host != u.protocol + "//" + u.host
                        } catch (t) {
                            h.crossDomain = !0
                        }
                    }
                    if (h.data && h.processData && "string" != typeof h.data && (h.data = g.param(h.data, h.traditional)), be(me, h, e, T), 2 === b) return T;
                    for (d in (c = g.event && h.global) && 0 == g.active++ && g.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !fe.test(h.type), r = h.url, h.hasContent || (h.data && (r = h.url += (ce.test(r) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (h.url = he.test(r) ? r.replace(he, "$1_=" + ue++) : r + (ce.test(r) ? "&" : "?") + "_=" + ue++)), h.ifModified && (g.lastModified[r] && T.setRequestHeader("If-Modified-Since", g.lastModified[r]), g.etag[r] && T.setRequestHeader("If-None-Match", g.etag[r])), (h.data && h.hasContent && !1 !== h.contentType || e.contentType) && T.setRequestHeader("Content-Type", h.contentType), T.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + ye + "; q=0.01" : "") : h.accepts["*"]), h.headers) T.setRequestHeader(d, h.headers[d]);
                    if (h.beforeSend && (!1 === h.beforeSend.call(p, T, h) || 2 === b)) return T.abort();
                    for (d in x = "abort", {
                            success: 1,
                            error: 1,
                            complete: 1
                        }) T[d](h[d]);
                    if (n = be(_e, h, e, T)) {
                        if (T.readyState = 1, c && f.trigger("ajaxSend", [T, h]), 2 === b) return T;
                        h.async && h.timeout > 0 && (l = i.setTimeout(function() {
                            T.abort("timeout")
                        }, h.timeout));
                        try {
                            b = 1, n.send(v, E)
                        } catch (t) {
                            if (!(b < 2)) throw t;
                            E(-1, t)
                        }
                    } else E(-1, "No Transport");

                    function E(t, e, o, a) {
                        var u, d, v, w, x, E = e;
                        2 !== b && (b = 2, l && i.clearTimeout(l), n = void 0, s = a || "", T.readyState = t > 0 ? 4 : 0, u = t >= 200 && t < 300 || 304 === t, o && (w = function(t, e, i) {
                            for (var n, r, s, o, a = t.contents, l = t.dataTypes;
                                "*" === l[0];) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
                            if (n)
                                for (r in a)
                                    if (a[r] && a[r].test(n)) {
                                        l.unshift(r);
                                        break
                                    } if (l[0] in i) s = l[0];
                            else {
                                for (r in i) {
                                    if (!l[0] || t.converters[r + " " + l[0]]) {
                                        s = r;
                                        break
                                    }
                                    o || (o = r)
                                }
                                s = s || o
                            }
                            if (s) return s !== l[0] && l.unshift(s), i[s]
                        }(h, T, o)), w = function(t, e, i, n) {
                            var r, s, o, a, l, u = {},
                                c = t.dataTypes.slice();
                            if (c[1])
                                for (o in t.converters) u[o.toLowerCase()] = t.converters[o];
                            for (s = c.shift(); s;)
                                if (t.responseFields[s] && (i[t.responseFields[s]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = s, s = c.shift())
                                    if ("*" === s) s = l;
                                    else if ("*" !== l && l !== s) {
                                if (!(o = u[l + " " + s] || u["* " + s]))
                                    for (r in u)
                                        if ((a = r.split(" "))[1] === s && (o = u[l + " " + a[0]] || u["* " + a[0]])) {
                                            !0 === o ? o = u[r] : !0 !== u[r] && (s = a[0], c.unshift(a[1]));
                                            break
                                        } if (!0 !== o)
                                    if (o && t.throws) e = o(e);
                                    else try {
                                        e = o(e)
                                    } catch (t) {
                                        return {
                                            state: "parsererror",
                                            error: o ? t : "No conversion from " + l + " to " + s
                                        }
                                    }
                            }
                            return {
                                state: "success",
                                data: e
                            }
                        }(h, w, T, u), u ? (h.ifModified && ((x = T.getResponseHeader("Last-Modified")) && (g.lastModified[r] = x), (x = T.getResponseHeader("etag")) && (g.etag[r] = x)), 204 === t || "HEAD" === h.type ? E = "nocontent" : 304 === t ? E = "notmodified" : (E = w.state, d = w.data, u = !(v = w.error))) : (v = E, !t && E || (E = "error", t < 0 && (t = 0))), T.status = t, T.statusText = (e || E) + "", u ? m.resolveWith(p, [d, E, T]) : m.rejectWith(p, [T, E, v]), T.statusCode(y), y = void 0, c && f.trigger(u ? "ajaxSuccess" : "ajaxError", [T, h, u ? d : v]), _.fireWith(p, [T, E]), c && (f.trigger("ajaxComplete", [T, h]), --g.active || g.event.trigger("ajaxStop")))
                    }
                    return T
                },
                getJSON: function(t, e, i) {
                    return g.get(t, e, i, "json")
                },
                getScript: function(t, e) {
                    return g.get(t, void 0, e, "script")
                }
            }), g.each(["get", "post"], function(t, e) {
                g[e] = function(t, i, n, r) {
                    return g.isFunction(i) && (r = r || n, n = i, i = void 0), g.ajax(g.extend({
                        url: t,
                        type: e,
                        dataType: r,
                        data: i,
                        success: n
                    }, g.isPlainObject(t) && t))
                }
            }), g._evalUrl = function(t) {
                return g.ajax({
                    url: t,
                    type: "GET",
                    dataType: "script",
                    async: !1,
                    global: !1,
                    throws: !0
                })
            }, g.fn.extend({
                wrapAll: function(t) {
                    var e;
                    return g.isFunction(t) ? this.each(function(e) {
                        g(this).wrapAll(t.call(this, e))
                    }) : (this[0] && (e = g(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                        for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                        return t
                    }).append(this)), this)
                },
                wrapInner: function(t) {
                    return g.isFunction(t) ? this.each(function(e) {
                        g(this).wrapInner(t.call(this, e))
                    }) : this.each(function() {
                        var e = g(this),
                            i = e.contents();
                        i.length ? i.wrapAll(t) : e.append(t)
                    })
                },
                wrap: function(t) {
                    var e = g.isFunction(t);
                    return this.each(function(i) {
                        g(this).wrapAll(e ? t.call(this, i) : t)
                    })
                },
                unwrap: function() {
                    return this.parent().each(function() {
                        g.nodeName(this, "body") || g(this).replaceWith(this.childNodes)
                    }).end()
                }
            }), g.expr.filters.hidden = function(t) {
                return !g.expr.filters.visible(t)
            }, g.expr.filters.visible = function(t) {
                return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0
            };
            var Te = /%20/g,
                Ee = /\[\]$/,
                Oe = /\r?\n/g,
                Ce = /^(?:submit|button|image|reset|file)$/i,
                Pe = /^(?:input|select|textarea|keygen)/i;

            function De(t, e, i, n) {
                var r;
                if (g.isArray(e)) g.each(e, function(e, r) {
                    i || Ee.test(t) ? n(t, r) : De(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, i, n)
                });
                else if (i || "object" !== g.type(e)) n(t, e);
                else
                    for (r in e) De(t + "[" + r + "]", e[r], i, n)
            }
            g.param = function(t, e) {
                var i, n = [],
                    r = function(t, e) {
                        e = g.isFunction(e) ? e() : null == e ? "" : e, n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
                    };
                if (void 0 === e && (e = g.ajaxSettings && g.ajaxSettings.traditional), g.isArray(t) || t.jquery && !g.isPlainObject(t)) g.each(t, function() {
                    r(this.name, this.value)
                });
                else
                    for (i in t) De(i, t[i], e, r);
                return n.join("&").replace(Te, "+")
            }, g.fn.extend({
                serialize: function() {
                    return g.param(this.serializeArray())
                },
                serializeArray: function() {
                    return this.map(function() {
                        var t = g.prop(this, "elements");
                        return t ? g.makeArray(t) : this
                    }).filter(function() {
                        var t = this.type;
                        return this.name && !g(this).is(":disabled") && Pe.test(this.nodeName) && !Ce.test(t) && (this.checked || !X.test(t))
                    }).map(function(t, e) {
                        var i = g(this).val();
                        return null == i ? null : g.isArray(i) ? g.map(i, function(t) {
                            return {
                                name: e.name,
                                value: t.replace(Oe, "\r\n")
                            }
                        }) : {
                            name: e.name,
                            value: i.replace(Oe, "\r\n")
                        }
                    }).get()
                }
            }), g.ajaxSettings.xhr = function() {
                try {
                    return new i.XMLHttpRequest
                } catch (t) {}
            };
            var Me = {
                    0: 200,
                    1223: 204
                },
                Re = g.ajaxSettings.xhr();
            f.cors = !!Re && "withCredentials" in Re, f.ajax = Re = !!Re, g.ajaxTransport(function(t) {
                var e, n;
                if (f.cors || Re && !t.crossDomain) return {
                    send: function(r, s) {
                        var o, a = t.xhr();
                        if (a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                            for (o in t.xhrFields) a[o] = t.xhrFields[o];
                        for (o in t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"), r) a.setRequestHeader(o, r[o]);
                        e = function(t) {
                            return function() {
                                e && (e = n = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? s(0, "error") : s(a.status, a.statusText) : s(Me[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                                    binary: a.response
                                } : {
                                    text: a.responseText
                                }, a.getAllResponseHeaders()))
                            }
                        }, a.onload = e(), n = a.onerror = e("error"), void 0 !== a.onabort ? a.onabort = n : a.onreadystatechange = function() {
                            4 === a.readyState && i.setTimeout(function() {
                                e && n()
                            })
                        }, e = e("abort");
                        try {
                            a.send(t.hasContent && t.data || null)
                        } catch (t) {
                            if (e) throw t
                        }
                    },
                    abort: function() {
                        e && e()
                    }
                }
            }), g.ajaxSetup({
                accepts: {
                    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                },
                contents: {
                    script: /\b(?:java|ecma)script\b/
                },
                converters: {
                    "text script": function(t) {
                        return g.globalEval(t), t
                    }
                }
            }), g.ajaxPrefilter("script", function(t) {
                void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
            }), g.ajaxTransport("script", function(t) {
                var e, i;
                if (t.crossDomain) return {
                    send: function(n, r) {
                        e = g("<script>").prop({
                            charset: t.scriptCharset,
                            src: t.url
                        }).on("load error", i = function(t) {
                            e.remove(), i = null, t && r("error" === t.type ? 404 : 200, t.type)
                        }), o.head.appendChild(e[0])
                    },
                    abort: function() {
                        i && i()
                    }
                }
            });
            var ke = [],
                Se = /(=)\?(?=&|$)|\?\?/;
            g.ajaxSetup({
                jsonp: "callback",
                jsonpCallback: function() {
                    var t = ke.pop() || g.expando + "_" + ue++;
                    return this[t] = !0, t
                }
            }), g.ajaxPrefilter("json jsonp", function(t, e, n) {
                var r, s, o, a = !1 !== t.jsonp && (Se.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Se.test(t.data) && "data");
                if (a || "jsonp" === t.dataTypes[0]) return r = t.jsonpCallback = g.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Se, "$1" + r) : !1 !== t.jsonp && (t.url += (ce.test(t.url) ? "&" : "?") + t.jsonp + "=" + r), t.converters["script json"] = function() {
                    return o || g.error(r + " was not called"), o[0]
                }, t.dataTypes[0] = "json", s = i[r], i[r] = function() {
                    o = arguments
                }, n.always(function() {
                    void 0 === s ? g(i).removeProp(r) : i[r] = s, t[r] && (t.jsonpCallback = e.jsonpCallback, ke.push(r)), o && g.isFunction(s) && s(o[0]), o = s = void 0
                }), "script"
            }), g.parseHTML = function(t, e, i) {
                if (!t || "string" != typeof t) return null;
                "boolean" == typeof e && (i = e, e = !1), e = e || o;
                var n = O.exec(t),
                    r = !i && [];
                return n ? [e.createElement(n[1])] : (n = rt([t], e, r), r && r.length && g(r).remove(), g.merge([], n.childNodes))
            };
            var Le = g.fn.load;

            function je(t) {
                return g.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
            }
            g.fn.load = function(t, e, i) {
                if ("string" != typeof t && Le) return Le.apply(this, arguments);
                var n, r, s, o = this,
                    a = t.indexOf(" ");
                return a > -1 && (n = g.trim(t.slice(a)), t = t.slice(0, a)), g.isFunction(e) ? (i = e, e = void 0) : e && "object" == typeof e && (r = "POST"), o.length > 0 && g.ajax({
                    url: t,
                    type: r || "GET",
                    dataType: "html",
                    data: e
                }).done(function(t) {
                    s = arguments, o.html(n ? g("<div>").append(g.parseHTML(t)).find(n) : t)
                }).always(i && function(t, e) {
                    o.each(function() {
                        i.apply(this, s || [t.responseText, e, t])
                    })
                }), this
            }, g.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
                g.fn[e] = function(t) {
                    return this.on(e, t)
                }
            }), g.expr.filters.animated = function(t) {
                return g.grep(g.timers, function(e) {
                    return t === e.elem
                }).length
            }, g.offset = {
                setOffset: function(t, e, i) {
                    var n, r, s, o, a, l, u = g.css(t, "position"),
                        c = g(t),
                        d = {};
                    "static" === u && (t.style.position = "relative"), a = c.offset(), s = g.css(t, "top"), l = g.css(t, "left"), ("absolute" === u || "fixed" === u) && (s + l).indexOf("auto") > -1 ? (o = (n = c.position()).top, r = n.left) : (o = parseFloat(s) || 0, r = parseFloat(l) || 0), g.isFunction(e) && (e = e.call(t, i, g.extend({}, a))), null != e.top && (d.top = e.top - a.top + o), null != e.left && (d.left = e.left - a.left + r), "using" in e ? e.using.call(t, d) : c.css(d)
                }
            }, g.fn.extend({
                offset: function(t) {
                    if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                        g.offset.setOffset(this, t, e)
                    });
                    var e, i, n = this[0],
                        r = {
                            top: 0,
                            left: 0
                        },
                        s = n && n.ownerDocument;
                    return s ? (e = s.documentElement, g.contains(e, n) ? (r = n.getBoundingClientRect(), i = je(s), {
                        top: r.top + i.pageYOffset - e.clientTop,
                        left: r.left + i.pageXOffset - e.clientLeft
                    }) : r) : void 0
                },
                position: function() {
                    if (this[0]) {
                        var t, e, i = this[0],
                            n = {
                                top: 0,
                                left: 0
                            };
                        return "fixed" === g.css(i, "position") ? e = i.getBoundingClientRect() : (t = this.offsetParent(), e = this.offset(), g.nodeName(t[0], "html") || (n = t.offset()), n.top += g.css(t[0], "borderTopWidth", !0), n.left += g.css(t[0], "borderLeftWidth", !0)), {
                            top: e.top - n.top - g.css(i, "marginTop", !0),
                            left: e.left - n.left - g.css(i, "marginLeft", !0)
                        }
                    }
                },
                offsetParent: function() {
                    return this.map(function() {
                        for (var t = this.offsetParent; t && "static" === g.css(t, "position");) t = t.offsetParent;
                        return t || kt
                    })
                }
            }), g.each({
                scrollLeft: "pageXOffset",
                scrollTop: "pageYOffset"
            }, function(t, e) {
                var i = "pageYOffset" === e;
                g.fn[t] = function(n) {
                    return q(this, function(t, n, r) {
                        var s = je(t);
                        if (void 0 === r) return s ? s[e] : t[n];
                        s ? s.scrollTo(i ? s.pageXOffset : r, i ? r : s.pageYOffset) : t[n] = r
                    }, t, n, arguments.length)
                }
            }), g.each(["top", "left"], function(t, e) {
                g.cssHooks[e] = Lt(f.pixelPosition, function(t, i) {
                    if (i) return i = St(t, e), Dt.test(i) ? g(t).position()[e] + "px" : i
                })
            }), g.each({
                Height: "height",
                Width: "width"
            }, function(t, e) {
                g.each({
                    padding: "inner" + t,
                    content: e,
                    "": "outer" + t
                }, function(i, n) {
                    g.fn[n] = function(n, r) {
                        var s = arguments.length && (i || "boolean" != typeof n),
                            o = i || (!0 === n || !0 === r ? "margin" : "border");
                        return q(this, function(e, i, n) {
                            var r;
                            return g.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (r = e.documentElement, Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t])) : void 0 === n ? g.css(e, i, o) : g.style(e, i, n, o)
                        }, e, s ? n : void 0, s, null)
                    }
                })
            }), g.fn.extend({
                bind: function(t, e, i) {
                    return this.on(t, null, e, i)
                },
                unbind: function(t, e) {
                    return this.off(t, null, e)
                },
                delegate: function(t, e, i, n) {
                    return this.on(e, t, i, n)
                },
                undelegate: function(t, e, i) {
                    return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i)
                },
                size: function() {
                    return this.length
                }
            }), g.fn.andSelf = g.fn.addBack, void 0 === (n = function() {
                return g
            }.apply(e, [])) || (t.exports = n);
            var Ae = i.jQuery,
                qe = i.$;
            return g.noConflict = function(t) {
                return i.$ === g && (i.$ = qe), t && i.jQuery === g && (i.jQuery = Ae), g
            }, r || (i.jQuery = i.$ = g), g
        }, "object" == typeof t.exports ? t.exports = r.document ? s(r, !0) : function(t) {
            if (!t.document) throw new Error("jQuery requires a window with a document");
            return s(t)
        } : s(r)
    },
    720: function(t, e, i) {
        "use strict";
        i.d(e, "a", function() {
            return We
        });
        class n {
            valueOf() {}
            liquidMethodMissing(t) {}
        }
        var r = function() {
            return (r = Object.assign || function(t) {
                for (var e, i = 1, n = arguments.length; i < n; i++)
                    for (var r in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                return t
            }).apply(this, arguments)
        };
        const s = Object.prototype.toString,
            o = String.prototype.toLowerCase;

        function a(t) {
            return "[object String]" === s.call(t)
        }

        function l(t) {
            return "function" == typeof t
        }

        function u(t) {
            return h(t = c(t)) ? "" : String(t)
        }

        function c(t) {
            return t instanceof n ? t.valueOf() : t
        }

        function d(t) {
            return "number" == typeof t
        }

        function h(t) {
            return null == t
        }

        function p(t) {
            return "[object Array]" === s.call(t)
        }

        function f(t, e) {
            t = t || {};
            for (const i in t)
                if (t.hasOwnProperty(i) && !1 === e(t[i], i, t)) break;
            return t
        }

        function g(t) {
            return t[t.length - 1]
        }

        function m(t) {
            const e = typeof t;
            return null !== t && ("object" === e || "function" === e)
        }

        function _(t, e, i = 1) {
            const n = [];
            for (let r = t; r < e; r += i) n.push(r);
            return n
        }

        function y(t, e, i = " ") {
            return v(t, e, i, (t, e) => e + t)
        }

        function v(t, e, i, n) {
            let r = e - (t = String(t)).length;
            for (; r-- > 0;) t = n(t, i);
            return t
        }

        function w(t) {
            return t
        }

        function b(t) {
            return t.replace(/(\w?)([A-Z])/g, (t, e, i) => (e ? e + "_" : "") + i.toLowerCase())
        }

        function x(t, e) {
            return null == t && null == e ? 0 : null == t ? 1 : null == e ? -1 : (t = o.call(t)) < (e = o.call(e)) ? -1 : t > e ? 1 : 0
        }
        class T {
            constructor(t, e, i, n) {
                this.key = t, this.value = e, this.next = i, this.prev = n
            }
        }
        class E {
            constructor(t, e = 0) {
                this.limit = t, this.size = e, this.cache = {}, this.head = new T("HEAD", null, null, null), this.tail = new T("TAIL", null, null, null), this.head.next = this.tail, this.tail.prev = this.head
            }
            write(t, e) {
                if (this.cache[t]) this.cache[t].value = e;
                else {
                    const i = new T(t, e, this.head.next, this.head);
                    this.head.next.prev = i, this.head.next = i, this.cache[t] = i, this.size++, this.ensureLimit()
                }
            }
            read(t) {
                if (!this.cache[t]) return;
                const {
                    value: e
                } = this.cache[t];
                return this.remove(t), this.write(t, e), e
            }
            remove(t) {
                const e = this.cache[t];
                e.prev.next = e.next, e.next.prev = e.prev, delete this.cache[t], this.size--
            }
            clear() {
                this.head.next = this.tail, this.tail.prev = this.head, this.size = 0, this.cache = {}
            }
            ensureLimit() {
                this.size > this.limit && this.remove(this.tail.prev.key)
            }
        }

        function O(t) {
            return t && l(t.equals)
        }

        function C(t, e) {
            return !P(t, e)
        }

        function P(t, e) {
            return e.opts.jsTruthy ? !t : !1 === t || null == t
        }
        const D = {
            "==": (t, e) => O(t) ? t.equals(e) : O(e) ? e.equals(t) : t === e,
            "!=": (t, e) => O(t) ? !t.equals(e) : O(e) ? !e.equals(t) : t !== e,
            ">": (t, e) => O(t) ? t.gt(e) : O(e) ? e.lt(t) : t > e,
            "<": (t, e) => O(t) ? t.lt(e) : O(e) ? e.gt(t) : t < e,
            ">=": (t, e) => O(t) ? t.geq(e) : O(e) ? e.leq(t) : t >= e,
            "<=": (t, e) => O(t) ? t.leq(e) : O(e) ? e.geq(t) : t <= e,
            contains: (t, e) => !(!t || !l(t.indexOf)) && t.indexOf(e) > -1,
            and: (t, e, i) => C(t, i) && C(e, i),
            or: (t, e, i) => C(t, i) || C(e, i)
        };

        function M(t) {
            const e = {};
            for (const [i, n] of Object.entries(t)) {
                let t = e;
                for (let e = 0; e < i.length; e++) {
                    const n = i[e];
                    t[n] = t[n] || {}, e === i.length - 1 && "=" !== n && (t[n].needBoundary = !0), t = t[n]
                }
                t.handler = n, t.end = !0
            }
            return e
        }
        const R = {
            root: ["."],
            cache: void 0,
            extname: "",
            fs: Object.freeze({
                resolve: function(t, e, i) {
                    return t.length && "/" !== g(t) && (t += "/"),
                        function(t, e) {
                            const i = document.createElement("base");
                            i.href = t;
                            const n = document.getElementsByTagName("head")[0];
                            n.insertBefore(i, n.firstChild);
                            const r = document.createElement("a");
                            r.href = e;
                            const s = r.href;
                            return n.removeChild(i), s
                        }(t, e).replace(/^(\w+:\/\/[^\/]+)(\/[^?]+)/, (t, e, n) => {
                            const r = n.split("/").pop();
                            return /\.\w+$/.test(r) ? t : e + n + i
                        })
                },
                readFile: async function(t) {
                    return new Promise((e, i) => {
                        const n = new XMLHttpRequest;
                        n.onload = () => {
                            n.status >= 200 && n.status < 300 ? e(n.responseText) : i(new Error(n.statusText))
                        }, n.onerror = () => {
                            i(new Error("An error occurred whilst receiving the response."))
                        }, n.open("GET", t), n.send()
                    })
                },
                readFileSync: function(t) {
                    const e = new XMLHttpRequest;
                    if (e.open("GET", t, !1), e.send(), e.status < 200 || e.status >= 300) throw new Error(e.statusText);
                    return e.responseText
                },
                exists: async function(t) {
                    return !0
                },
                existsSync: function(t) {
                    return !0
                }
            }),
            dynamicPartials: !0,
            jsTruthy: !1,
            trimTagRight: !1,
            trimTagLeft: !1,
            trimOutputRight: !1,
            trimOutputLeft: !1,
            greedy: !0,
            tagDelimiterLeft: "{%",
            tagDelimiterRight: "%}",
            outputDelimiterLeft: "{{",
            outputDelimiterRight: "}}",
            preserveTimezones: !1,
            strictFilters: !1,
            strictVariables: !1,
            lenientIf: !1,
            globals: {},
            keepOutputType: !1,
            operators: D,
            operatorsTrie: M(D)
        };

        function k(t) {
            if ((t = t || {}).hasOwnProperty("root") && (t.root = S(t.root)), t.hasOwnProperty("cache")) {
                let e;
                e = "number" == typeof t.cache ? t.cache > 0 ? new E(t.cache) : void 0 : "object" == typeof t.cache ? t.cache : t.cache ? new E(1024) : void 0, t.cache = e
            }
            return t.hasOwnProperty("operators") && (t.operatorsTrie = M(t.operators)), t
        }

        function S(t) {
            return p(t) ? t : a(t) ? [t] : []
        }
        class L extends Error {
            constructor(t, e) {
                super(t.message), this.originalError = t, this.token = e
            }
            update() {
                const t = this.originalError,
                    e = function(t) {
                        const [e] = t.getPosition(), i = t.input.split("\n"), n = Math.max(e - 2, 1), r = Math.min(e + 3, i.length);
                        return _(n, r + 1).map(t => {
                            const n = t === e ? ">> " : "   ",
                                s = y(String(t), String(r).length),
                                o = i[t - 1];
                            return `${n}${s}| ${o}`
                        }).join("\n")
                    }(this.token);
                this.message = function(t, e) {
                    e.file && (t += `, file:${e.file}`);
                    const [i, n] = e.getPosition();
                    return t += `, line:${i}, col:${n}`
                }(t.message, this.token), this.stack = this.message + "\n" + e + "\n" + this.stack + "\nFrom " + t.stack
            }
        }
        class j extends L {
            constructor(t, e) {
                super(new Error(t), e), this.name = "TokenizationError", super.update()
            }
        }
        class A extends L {
            constructor(t, e) {
                super(t, e), this.name = "ParseError", this.message = t.message, super.update()
            }
        }
        class q extends L {
            constructor(t, e) {
                super(t, e.token), this.name = "RenderError", this.message = t.message, super.update()
            }
            static is(t) {
                return "RenderError" === t.name
            }
        }
        class I extends L {
            constructor(t, e) {
                super(t, e), this.name = "UndefinedVariableError", this.message = t.message, super.update()
            }
        }
        class B extends Error {
            constructor(t) {
                super(`undefined variable: ${t}`), this.name = "InternalUndefinedVariableError", this.variableName = t
            }
        }
        class N extends Error {
            constructor(t) {
                super(t), this.name = "AssertionError", this.message = t + ""
            }
        }
        class W {
            constructor(t = {}, e = R, i = !1) {
                this.scopes = [{}], this.registers = {}, this.sync = i, this.opts = e, this.globals = e.globals, this.environments = t
            }
            getRegister(t, e = {}) {
                return this.registers[t] = this.registers[t] || e
            }
            setRegister(t, e) {
                return this.registers[t] = e
            }
            saveRegister(...t) {
                return t.map(t => [t, this.getRegister(t)])
            }
            restoreRegister(t) {
                return t.forEach(([t, e]) => this.setRegister(t, e))
            }
            getAll() {
                return [this.globals, this.environments, ...this.scopes].reduce((t, e) => r(t, e), {})
            }
            get(t) {
                const e = this.findScope(t[0]);
                return this.getFromScope(e, t)
            }
            getFromScope(t, e) {
                return "string" == typeof e && (e = e.split(".")), e.reduce((t, e) => {
                    if (t = function(t, e) {
                            if (h(t)) return t;
                            if (t = function t(e) {
                                    return e && l(e.toLiquid) ? t(e.toLiquid()) : e
                                }(t), l(t[e])) return t[e]();
                            if (t instanceof n) return t.hasOwnProperty(e) ? t[e] : t.liquidMethodMissing(e);
                            return "size" === e ? function(t) {
                                return p(t) || a(t) ? t.length : t.size
                            }(t) : "first" === e ? function(t) {
                                return p(t) ? t[0] : t.first
                            }(t) : "last" === e ? function(t) {
                                return p(t) ? t[t.length - 1] : t.last
                            }(t) : t[e]
                        }(t, e), h(t) && this.opts.strictVariables) throw new B(e);
                    return t
                }, t)
            }
            push(t) {
                return this.scopes.push(t)
            }
            pop() {
                return this.scopes.pop()
            }
            bottom() {
                return this.scopes[0]
            }
            findScope(t) {
                for (let e = this.scopes.length - 1; e >= 0; e--) {
                    const i = this.scopes[e];
                    if (t in i) return i
                }
                return t in this.environments ? this.environments : this.globals
            }
        }
        var $;

        function F(t) {
            return !!(Q(t) & $.Delimited)
        }

        function U(t) {
            return Q(t) === $.Operator
        }

        function H(t) {
            return Q(t) === $.HTML
        }

        function z(t) {
            return Q(t) === $.Output
        }

        function K(t) {
            return Q(t) === $.Tag
        }

        function V(t) {
            return Q(t) === $.Quoted
        }

        function G(t) {
            return Q(t) === $.Literal
        }

        function X(t) {
            return Q(t) === $.Number
        }

        function J(t) {
            return Q(t) === $.PropertyAccess
        }

        function Y(t) {
            return Q(t) === $.Word
        }

        function Z(t) {
            return Q(t) === $.Range
        }

        function Q(t) {
            return t ? t.kind : -1
        }! function(t) {
            t[t.Number = 1] = "Number", t[t.Literal = 2] = "Literal", t[t.Tag = 4] = "Tag", t[t.Output = 8] = "Output", t[t.HTML = 16] = "HTML", t[t.Filter = 32] = "Filter", t[t.Hash = 64] = "Hash", t[t.PropertyAccess = 128] = "PropertyAccess", t[t.Word = 256] = "Word", t[t.Range = 512] = "Range", t[t.Quoted = 1024] = "Quoted", t[t.Operator = 2048] = "Operator", t[t.Delimited = 12] = "Delimited"
        }($ || ($ = {}));
        const tt = [0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 4, 4, 4, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 8, 0, 0, 0, 0, 8, 0, 0, 0, 64, 0, 65, 0, 0, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 0, 0, 2, 2, 2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
            et = 1,
            it = 4,
            nt = 8,
            rt = 16,
            st = 32,
            ot = 64;

        function at(t, e) {
            if (!t || !H(t)) return;
            const i = e ? it : rt;
            for (; tt[t.input.charCodeAt(t.end - 1 - t.trimRight)] & i;) t.trimRight++
        }

        function lt(t, e) {
            if (!t || !H(t)) return;
            const i = e ? it : rt;
            for (; tt[t.input.charCodeAt(t.begin + t.trimLeft)] & i;) t.trimLeft++;
            "\n" === t.input.charAt(t.begin + t.trimLeft) && t.trimLeft++
        }
        tt[160] = tt[5760] = tt[6158] = tt[8192] = tt[8193] = tt[8194] = tt[8195] = tt[8196] = tt[8197] = tt[8198] = tt[8199] = tt[8200] = tt[8201] = tt[8202] = tt[8232] = tt[8233] = tt[8239] = tt[8287] = tt[12288] = it;
        class ut {
            constructor(t, e, i, n, r) {
                this.kind = t, this.input = e, this.begin = i, this.end = n, this.file = r
            }
            getText() {
                return this.input.slice(this.begin, this.end)
            }
            getPosition() {
                let [t, e] = [1, 1];
                for (let i = 0; i < this.begin; i++) "\n" === this.input[i] ? (t++, e = 1) : e++;
                return [t, e]
            }
            size() {
                return this.end - this.begin
            }
        }
        class ct extends ut {
            constructor(t, e) {
                super($.Number, t.input, t.begin, e ? e.end : t.end, t.file), this.whole = t, this.decimal = e
            }
        }
        class dt extends ut {
            constructor(t, e, i, n) {
                super($.Word, t, e, i, n), this.input = t, this.begin = e, this.end = i, this.file = n, this.content = this.getText()
            }
            isNumber(t = !1) {
                for (let e = t && tt[this.input.charCodeAt(this.begin)] & ot ? this.begin + 1 : this.begin; e < this.end; e++)
                    if (!(tt[this.input.charCodeAt(e)] & st)) return !1;
                return !0
            }
        }
        class ht extends n {
            equals(t) {
                return !(t instanceof ht) && (a(t = c(t)) || p(t) ? 0 === t.length : !!m(t) && 0 === Object.keys(t).length)
            }
            gt() {
                return !1
            }
            geq() {
                return !1
            }
            lt() {
                return !1
            }
            leq() {
                return !1
            }
            valueOf() {
                return ""
            }
        }
        const pt = new class extends n {
                equals(t) {
                    return h(c(t))
                }
                gt() {
                    return !1
                }
                geq() {
                    return !1
                }
                lt() {
                    return !1
                }
                leq() {
                    return !1
                }
                valueOf() {
                    return null
                }
            },
            ft = {
                true: !0,
                false: !1,
                nil: pt,
                null: pt,
                empty: new ht,
                blank: new class extends ht {
                    equals(t) {
                        return !1 === t || !!h(c(t)) || (a(t) ? /^\s*$/.test(t) : super.equals(t))
                    }
                }
            };
        class gt extends ut {
            constructor(t, e, i, n) {
                super($.Literal, t, e, i, n), this.input = t, this.begin = e, this.end = i, this.file = n, this.literal = this.getText()
            }
        }
        const mt = {
            "==": 1,
            "!=": 1,
            ">": 1,
            "<": 1,
            ">=": 1,
            "<=": 1,
            contains: 1,
            and: 0,
            or: 0
        };
        class _t extends ut {
            constructor(t, e, i, n) {
                super($.Operator, t, e, i, n), this.input = t, this.begin = e, this.end = i, this.file = n, this.operator = this.getText()
            }
            getPrecedence() {
                const t = this.getText();
                return t in mt ? mt[t] : 1
            }
        }
        const yt = /[\da-fA-F]/,
            vt = /[0-7]/,
            wt = {
                b: "\b",
                f: "\f",
                n: "\n",
                r: "\r",
                t: "\t",
                v: "\v"
            };

        function bt(t) {
            const e = t.charCodeAt(0);
            return e >= 97 ? e - 87 : e >= 65 ? e - 55 : e - 48
        }

        function xt(t) {
            let e = "";
            for (let i = 1; i < t.length - 1; i++)
                if ("\\" === t[i])
                    if (void 0 !== wt[t[i + 1]]) e += wt[t[++i]];
                    else if ("u" === t[i + 1]) {
                let n = 0,
                    r = i + 2;
                for (; r <= i + 5 && yt.test(t[r]);) n = 16 * n + bt(t[r++]);
                i = r - 1, e += String.fromCharCode(n)
            } else if (vt.test(t[i + 1])) {
                let n = i + 1,
                    r = 0;
                for (; n <= i + 3 && vt.test(t[n]);) r = 8 * r + bt(t[n++]);
                i = n - 1, e += String.fromCharCode(r)
            } else e += t[++i];
            else e += t[i];
            return e
        }
        class Tt extends ut {
            constructor(t, e, i) {
                super($.PropertyAccess, t.input, t.begin, i, t.file), this.variable = t, this.props = e
            }
            getVariableAsText() {
                return this.variable instanceof dt ? this.variable.getText() : xt(this.variable.getText())
            }
        }

        function Et(t, e) {
            if (!t) {
                const i = e ? e() : `expect ${t} to be true`;
                throw new N(i)
            }
        }
        class Ot extends ut {
            constructor(t, e, i, n, r, s) {
                super($.Filter, i, n, r, s), this.name = t, this.args = e
            }
        }
        class Ct extends ut {
            constructor(t, e, i, n, r, s) {
                super($.Hash, t, e, i, s), this.input = t, this.begin = e, this.end = i, this.name = n, this.value = r, this.file = s
            }
        }
        class Pt extends ut {
            constructor(t, e, i, n) {
                super($.Quoted, t, e, i, n), this.input = t, this.begin = e, this.end = i, this.file = n
            }
        }
        class Dt extends ut {
            constructor(t, e, i, n) {
                super($.HTML, t, e, i, n), this.input = t, this.begin = e, this.end = i, this.file = n, this.trimLeft = 0, this.trimRight = 0
            }
            getContent() {
                return this.input.slice(this.begin + this.trimLeft, this.end - this.trimRight)
            }
        }
        class Mt extends ut {
            constructor(t, e, i, n, r, s, o, a) {
                super(t, i, n, r, a), this.trimLeft = !1, this.trimRight = !1, this.content = this.getText();
                const l = "-" === e[0],
                    u = "-" === g(e);
                this.content = e.slice(l ? 1 : 0, u ? -1 : e.length).trim(), this.trimLeft = l || s, this.trimRight = u || o
            }
        }
        class Rt extends Mt {
            constructor(t, e, i, n, r) {
                const {
                    trimTagLeft: s,
                    trimTagRight: o,
                    tagDelimiterLeft: a,
                    tagDelimiterRight: l
                } = n, u = t.slice(e + a.length, i - l.length);
                super($.Tag, u, t, e, i, s, o, r);
                const c = new Bt(this.content, n.operatorsTrie);
                if (this.name = c.readIdentifier().getText(), !this.name) throw new j("illegal tag syntax", this);
                c.skipBlank(), this.args = c.remaining()
            }
        }
        class kt extends ut {
            constructor(t, e, i, n, r, s) {
                super($.Range, t, e, i, s), this.input = t, this.begin = e, this.end = i, this.lhs = n, this.rhs = r, this.file = s
            }
        }
        class St extends Mt {
            constructor(t, e, i, n, r) {
                const {
                    trimOutputLeft: s,
                    trimOutputRight: o,
                    outputDelimiterLeft: a,
                    outputDelimiterRight: l
                } = n, u = t.slice(e + a.length, i - l.length);
                super($.Output, u, t, e, i, s, o, r)
            }
        }
        class Lt {
            constructor(t) {
                this.postfix = [...It(t)]
            }* evaluate(t, e) {
                Et(t, () => "unable to evaluate: context not defined");
                const i = [];
                for (const n of this.postfix)
                    if (U(n)) {
                        const e = yield i.pop(), r = yield i.pop(), s = qt(t.opts.operators, n, r, e, t);
                        i.push(s)
                    } else i.push(yield jt(n, t, e && 1 === this.postfix.length));
                return i[0]
            }
        }

        function jt(t, e, i = !1) {
            return J(t) ? function(t, e, i) {
                const n = t.getVariableAsText(),
                    r = t.props.map(t => jt(t, e, !1));
                try {
                    return e.get([n, ...r])
                } catch (e) {
                    if (i && "InternalUndefinedVariableError" === e.name) return null;
                    throw new I(e, t)
                }
            }(t, e, i) : Z(t) ? function(t, e) {
                const i = jt(t.lhs, e),
                    n = jt(t.rhs, e);
                return _(+i, +n + 1)
            }(t, e) : G(t) ? function(t) {
                return ft[t.literal]
            }(t) : X(t) ? function(t) {
                const e = t.whole.content + "." + (t.decimal ? t.decimal.content : "");
                return Number(e)
            }(t) : Y(t) ? t.getText() : V(t) ? At(t) : void 0
        }

        function At(t) {
            return xt(t.getText())
        }

        function qt(t, e, i, n, r) {
            return (0, t[e.operator])(i, n, r)
        }

        function* It(t) {
            const e = [];
            for (const i of t)
                if (U(i)) {
                    for (; e.length && e[e.length - 1].getPrecedence() > i.getPrecedence();) yield e.pop();
                    e.push(i)
                } else yield i;
            for (; e.length;) yield e.pop()
        }
        class Bt {
            constructor(t, e, i = "") {
                this.input = t, this.trie = e, this.file = i, this.p = 0, this.rawBeginAt = -1, this.N = t.length
            }
            readExpression() {
                return new Lt(this.readExpressionTokens())
            }* readExpressionTokens() {
                const t = this.readValue();
                if (t)
                    for (yield t; this.p < this.N;) {
                        const t = this.readOperator();
                        if (!t) return;
                        const e = this.readValue();
                        if (!e) return;
                        yield t, yield e
                    }
            }
            readOperator() {
                this.skipBlank();
                const t = function(t, e, i, n = t.length) {
                    let r, s = i,
                        o = e;
                    for (; s[t[o]] && o < n;)(s = s[t[o++]]).end && (r = s);
                    return r ? r.needBoundary && t.charCodeAt(o) & et ? -1 : o : -1
                }(this.input, this.p, this.trie, this.p + 8);
                if (-1 !== t) return new _t(this.input, this.p, this.p = t, this.file)
            }
            readFilters() {
                const t = [];
                for (;;) {
                    const e = this.readFilter();
                    if (!e) return t;
                    t.push(e)
                }
            }
            readFilter() {
                if (this.skipBlank(), this.end()) return null;
                Et("|" === this.peek(), () => `unexpected token at ${this.snapshot()}`), this.p++;
                const t = this.p,
                    e = this.readIdentifier();
                if (!e.size()) return null;
                const i = [];
                if (this.skipBlank(), ":" === this.peek())
                    do {
                        ++this.p;
                        const t = this.readFilterArg();
                        for (t && i.push(t); this.p < this.N && "," !== this.peek() && "|" !== this.peek();) ++this.p
                    } while ("," === this.peek());
                return new Ot(e.getText(), i, this.input, t, this.p, this.file)
            }
            readFilterArg() {
                const t = this.readValue();
                if (!t) return;
                if (this.skipBlank(), ":" !== this.peek()) return t;
                ++this.p;
                const e = this.readValue();
                return [t.getText(), e]
            }
            readTopLevelTokens(t = R) {
                const e = [];
                for (; this.p < this.N;) {
                    const i = this.readTopLevelToken(t);
                    e.push(i)
                }
                return function(t, e) {
                    let i = !1;
                    for (let n = 0; n < t.length; n++) {
                        const r = t[n];
                        F(r) && (!i && r.trimLeft && at(t[n - 1], e.greedy), K(r) && ("raw" === r.name ? i = !0 : "endraw" === r.name && (i = !1)), !i && r.trimRight && lt(t[n + 1], e.greedy))
                    }
                }(e, t), e
            }
            readTopLevelToken(t) {
                const {
                    tagDelimiterLeft: e,
                    outputDelimiterLeft: i
                } = t;
                return this.rawBeginAt > -1 ? this.readEndrawOrRawContent(t) : this.match(e) ? this.readTagToken(t) : this.match(i) ? this.readOutputToken(t) : this.readHTMLToken(t)
            }
            readHTMLToken(t) {
                const e = this.p;
                for (; this.p < this.N;) {
                    const {
                        tagDelimiterLeft: e,
                        outputDelimiterLeft: i
                    } = t;
                    if (this.match(e)) break;
                    if (this.match(i)) break;
                    ++this.p
                }
                return new Dt(this.input, e, this.p, this.file)
            }
            readTagToken(t = R) {
                const {
                    file: e,
                    input: i
                } = this, n = this.p;
                if (-1 === this.readToDelimiter(t.tagDelimiterRight)) throw this.mkError(`tag ${this.snapshot(n)} not closed`, n);
                const r = new Rt(i, n, this.p, t, e);
                return "raw" === r.name && (this.rawBeginAt = n), r
            }
            readToDelimiter(t) {
                for (; this.p < this.N;)
                    if (this.peekType() & nt) this.readQuoted();
                    else if (++this.p, this.rmatch(t)) return this.p;
                return -1
            }
            readOutputToken(t = R) {
                const {
                    file: e,
                    input: i
                } = this, {
                    outputDelimiterRight: n
                } = t, r = this.p;
                if (-1 === this.readToDelimiter(n)) throw this.mkError(`output ${this.snapshot(r)} not closed`, r);
                return new St(i, r, this.p, t, e)
            }
            readEndrawOrRawContent(t) {
                const {
                    tagDelimiterLeft: e,
                    tagDelimiterRight: i
                } = t, n = this.p;
                let r = this.readTo(e) - e.length;
                for (; this.p < this.N;)
                    if ("endraw" === this.readIdentifier().getText())
                        for (; this.p <= this.N;) {
                            if (this.rmatch(i)) {
                                const e = this.p;
                                return n === r ? (this.rawBeginAt = -1, new Rt(this.input, n, e, t, this.file)) : (this.p = r, new Dt(this.input, n, r, this.file))
                            }
                            if (this.rmatch(e)) break;
                            this.p++
                        } else r = this.readTo(e) - e.length;
                throw this.mkError(`raw ${this.snapshot(this.rawBeginAt)} not closed`, n)
            }
            mkError(t, e) {
                return new j(t, new dt(this.input, e, this.N, this.file))
            }
            snapshot(t = this.p) {
                return JSON.stringify((e = this.input.slice(t), i = 16, e.length > i ? e.substr(0, i - 3) + "..." : e));
                var e, i
            }
            readWord() {
                return console.warn("Tokenizer#readWord() will be removed, use #readIdentifier instead"), this.readIdentifier()
            }
            readIdentifier() {
                this.skipBlank();
                const t = this.p;
                for (; this.peekType() & et;) ++this.p;
                return new dt(this.input, t, this.p, this.file)
            }
            readHashes() {
                const t = [];
                for (;;) {
                    const e = this.readHash();
                    if (!e) return t;
                    t.push(e)
                }
            }
            readHash() {
                this.skipBlank(), "," === this.peek() && ++this.p;
                const t = this.p,
                    e = this.readIdentifier();
                if (!e.size()) return;
                let i;
                return this.skipBlank(), ":" === this.peek() && (++this.p, i = this.readValue()), new Ct(this.input, t, this.p, e, i, this.file)
            }
            remaining() {
                return this.input.slice(this.p)
            }
            advance(t = 1) {
                this.p += t
            }
            end() {
                return this.p >= this.N
            }
            readTo(t) {
                for (; this.p < this.N;)
                    if (++this.p, this.rmatch(t)) return this.p;
                return -1
            }
            readValue() {
                const t = this.readQuoted() || this.readRange();
                if (t) return t;
                if ("[" === this.peek()) {
                    this.p++;
                    const t = this.readQuoted();
                    if (!t) return;
                    if ("]" !== this.peek()) return;
                    return this.p++, new Tt(t, [], this.p)
                }
                const e = this.readIdentifier();
                if (!e.size()) return;
                let i = e.isNumber(!0);
                const n = [];
                for (;;)
                    if ("[" === this.peek()) {
                        i = !1, this.p++;
                        const t = this.readValue() || new dt(this.input, this.p, this.p, this.file);
                        this.readTo("]"), n.push(t)
                    } else {
                        if ("." !== this.peek() || "." === this.peek(1)) break; {
                            this.p++;
                            const t = this.readIdentifier();
                            if (!t.size()) break;
                            t.isNumber() || (i = !1), n.push(t)
                        }
                    } return !n.length && ft.hasOwnProperty(e.content) ? new gt(this.input, e.begin, e.end, this.file) : i ? new ct(e, n[0]) : new Tt(e, n, this.p)
            }
            readRange() {
                this.skipBlank();
                const t = this.p;
                if ("(" !== this.peek()) return;
                ++this.p;
                const e = this.readValueOrThrow();
                this.p += 2;
                const i = this.readValueOrThrow();
                return ++this.p, new kt(this.input, t, this.p, e, i, this.file)
            }
            readValueOrThrow() {
                const t = this.readValue();
                return Et(t, () => `unexpected token ${this.snapshot()}, value expected`), t
            }
            readQuoted() {
                this.skipBlank();
                const t = this.p;
                if (!(this.peekType() & nt)) return;
                ++this.p;
                let e = !1;
                for (; this.p < this.N && (++this.p, this.input[this.p - 1] !== this.input[t] || e);) e ? e = !1 : "\\" === this.input[this.p - 1] && (e = !0);
                return new Pt(this.input, t, this.p, this.file)
            }
            readFileName() {
                const t = this.p;
                for (; !(this.peekType() & it) && "," !== this.peek() && this.p < this.N;) this.p++;
                return new dt(this.input, t, this.p, this.file)
            }
            match(t) {
                for (let e = 0; e < t.length; e++)
                    if (t[e] !== this.input[this.p + e]) return !1;
                return !0
            }
            rmatch(t) {
                for (let e = 0; e < t.length; e++)
                    if (t[t.length - 1 - e] !== this.input[this.p - 1 - e]) return !1;
                return !0
            }
            peekType(t = 0) {
                return tt[this.input.charCodeAt(this.p + t)]
            }
            peek(t = 0) {
                return this.input[this.p + t]
            }
            skipBlank() {
                for (; this.peekType() & it;) ++this.p
            }
        }
        class Nt {
            constructor(t) {
                this.html = "", this.break = !1, this.continue = !1, this.keepOutputType = !1, this.keepOutputType = t
            }
            write(t) {
                t = !0 === this.keepOutputType ? c(t) : u(c(t)), !0 === this.keepOutputType && "string" != typeof t && "" === this.html ? this.html = t : this.html = u(this.html) + u(t)
            }
        }
        class Wt {
            * renderTemplates(t, e, i) {
                i || (i = new Nt(e.opts.keepOutputType));
                for (const n of t) try {
                    const t = yield n.render(e, i);
                    if (t && i.write(t), i.break || i.continue) break
                } catch (t) {
                    throw q.is(t) ? t : new q(t, n)
                }
                return i.html
            }
        }
        class $t {
            constructor(t, e) {
                this.handlers = {}, this.stopRequested = !1, this.tokens = t, this.parseToken = e
            }
            on(t, e) {
                return this.handlers[t] = e, this
            }
            trigger(t, e) {
                const i = this.handlers[t];
                return !!i && (i(e), !0)
            }
            start() {
                let t;
                for (this.trigger("start"); !this.stopRequested && (t = this.tokens.shift());) {
                    if (this.trigger("token", t)) continue;
                    if (K(t) && this.trigger(`tag:${t.name}`, t)) continue;
                    const e = this.parseToken(t, this.tokens);
                    this.trigger("template", e)
                }
                return this.stopRequested || this.trigger("end"), this
            }
            stop() {
                return this.stopRequested = !0, this
            }
        }
        class Ft {
            constructor(t) {
                this.token = t
            }
        }
        class Ut {
            constructor(t) {
                this.hash = {};
                const e = new Bt(t, {});
                for (const t of e.readHashes()) this.hash[t.name.content] = t.value
            }* render(t) {
                const e = {};
                for (const i of Object.keys(this.hash)) e[i] = yield jt(this.hash[i], t);
                return e
            }
        }
        class Ht {
            constructor(t, e, i, n) {
                this.name = t, this.impl = e || w, this.args = i, this.liquid = n
            }
            render(t, e) {
                const i = [];
                for (const t of this.args) p(t) ? i.push([t[0], jt(t[1], e)]) : i.push(jt(t, e));
                return this.impl.apply({
                    context: e,
                    liquid: this.liquid
                }, [t, ...i])
            }
        }
        class zt {
            constructor(t, e) {
                this.filters = [];
                const i = new Bt(t, e.options.operatorsTrie);
                this.initial = i.readExpression(), this.filters = i.readFilters().map(({
                    name: t,
                    args: i
                }) => new Ht(t, e.filters.get(t), i, e))
            }* value(t, e) {
                e = e || t.opts.lenientIf && this.filters.length > 0 && "default" === this.filters[0].name;
                let i = yield this.initial.evaluate(t, e);
                for (const e of this.filters) i = yield e.render(i, t);
                return i
            }
        }

        function Kt(t) {
            const e = {
                then: e => e(t),
                catch: () => e
            };
            return e
        }

        function Vt(t) {
            const e = {
                then: (i, n) => n ? n(t) : e,
                catch: e => e(t)
            };
            return e
        }

        function Gt(t) {
            return function(t) {
                return t && l(t.then)
            }(t) ? t : function(t) {
                return t && l(t.next) && l(t.throw) && l(t.return)
            }(t) ? function e(i) {
                let n;
                try {
                    n = t.next(i)
                } catch (t) {
                    return Vt(t)
                }
                if (n.done) return Kt(n.value);
                return Gt(n.value).then(e, i => {
                    let n;
                    try {
                        n = t.throw(i)
                    } catch (t) {
                        return Vt(t)
                    }
                    return n.done ? Kt(n.value) : e(n.value)
                })
            }() : Kt(t)
        }

        function Xt(t) {
            return Promise.resolve(Gt(t))
        }

        function Jt(t) {
            let e;
            return Gt(t).then(t => Kt(e = t)).catch(t => {
                throw t
            }), e
        }
        class Yt extends Ft {
            constructor(t, e, i) {
                super(t), this.name = t.name;
                const n = i.tags.get(t.name);
                this.impl = Object.create(n), this.impl.liquid = i, this.impl.parse && this.impl.parse(t, e)
            }* render(t, e) {
                const i = yield new Ut(this.token.args).render(t), n = this.impl;
                if (l(n.render)) return yield n.render(t, e, i)
            }
        }
        class Zt extends Ft {
            constructor(t, e) {
                super(t), this.value = new zt(t.content, e)
            }* render(t, e) {
                const i = yield this.value.value(t, !1);
                e.write(i)
            }
        }
        class Qt extends Ft {
            constructor(t) {
                super(t), this.str = t.getContent()
            }* render(t, e) {
                e.write(this.str)
            }
        }
        class te {
            constructor(t) {
                this.liquid = t
            }
            parse(t) {
                let e;
                const i = [];
                for (; e = t.shift();) i.push(this.parseToken(e, t));
                return i
            }
            parseToken(t, e) {
                try {
                    return K(t) ? new Yt(t, e, this.liquid) : z(t) ? new Zt(t, this.liquid) : new Qt(t)
                } catch (e) {
                    throw new A(e, t)
                }
            }
            parseStream(t) {
                return new $t(t, (t, e) => this.parseToken(t, e))
            }
        }
        var ee = {
            parse: function(t) {
                const e = new Bt(t.args, this.liquid.options.operatorsTrie);
                this.key = e.readIdentifier().content, e.skipBlank(), Et("=" === e.peek(), () => `illegal token ${t.getText()}`), e.advance(), this.value = e.remaining()
            },
            render: function*(t) {
                t.bottom()[this.key] = yield this.liquid._evalValue(this.value, t)
            }
        };

        function ie(t) {
            return p(t) ? t : a(t) && t.length > 0 ? [t] : m(t) ? Object.keys(t).map(e => [e, t[e]]) : []
        }

        function ne(t) {
            return p(t) ? t : [t]
        }
        class re extends n {
            constructor(t) {
                super(), this.i = 0, this.length = t
            }
            next() {
                this.i++
            }
            index0() {
                return this.i
            }
            index() {
                return this.i + 1
            }
            first() {
                return 0 === this.i
            }
            last() {
                return this.i === this.length - 1
            }
            rindex() {
                return this.length - this.i
            }
            rindex0() {
                return this.length - this.i - 1
            }
            valueOf() {
                return JSON.stringify(this)
            }
        }
        var se = {
                type: "block",
                parse: function(t, e) {
                    const i = new Bt(t.args, this.liquid.options.operatorsTrie),
                        n = i.readIdentifier(),
                        r = i.readIdentifier(),
                        s = i.readValue();
                    let o;
                    Et(n.size() && "in" === r.content && s, () => `illegal tag: ${t.getText()}`), this.variable = n.content, this.collection = s, this.hash = new Ut(i.remaining()), this.templates = [], this.elseTemplates = [];
                    const a = this.liquid.parser.parseStream(e).on("start", () => o = this.templates).on("tag:else", () => o = this.elseTemplates).on("tag:endfor", () => a.stop()).on("template", t => o.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    });
                    a.start()
                },
                render: function*(t, e) {
                    const i = this.liquid.renderer;
                    let n = ie(yield jt(this.collection, t));
                    if (!n.length) return void(yield i.renderTemplates(this.elseTemplates, t, e));
                    const r = yield this.hash.render(t), s = r.offset || 0, o = void 0 === r.limit ? n.length : r.limit;
                    n = n.slice(s, s + o), "reversed" in r && n.reverse();
                    const a = {
                        forloop: new re(n.length)
                    };
                    t.push(a);
                    for (const r of n) {
                        if (a[this.variable] = r, yield i.renderTemplates(this.templates, t, e), e.break) {
                            e.break = !1;
                            break
                        }
                        e.continue = !1, a.forloop.next()
                    }
                    t.pop()
                }
            },
            oe = {
                parse: function(t, e) {
                    const i = new Bt(t.args, this.liquid.options.operatorsTrie);
                    this.variable = function(t) {
                        const e = t.readIdentifier().content;
                        if (e) return e;
                        const i = t.readQuoted();
                        if (i) return At(i)
                    }(i), Et(this.variable, () => `${t.args} not valid identifier`), this.templates = [];
                    const n = this.liquid.parser.parseStream(e);
                    n.on("tag:endcapture", () => n.stop()).on("template", t => this.templates.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    }), n.start()
                },
                render: function*(t) {
                    const e = this.liquid.renderer,
                        i = yield e.renderTemplates(this.templates, t);
                    t.bottom()[this.variable] = i
                }
            };
        var ae, le = {
                parse: function(t, e) {
                    this.cond = new zt(t.args, this.liquid), this.cases = [], this.elseTemplates = [];
                    let i = [];
                    const n = this.liquid.parser.parseStream(e).on("tag:when", t => {
                        this.cases.push({
                            val: new zt(t.args, this.liquid),
                            templates: i = []
                        })
                    }).on("tag:else", () => i = this.elseTemplates).on("tag:endcase", () => n.stop()).on("template", t => i.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    });
                    n.start()
                },
                render: function*(t, e) {
                    const i = this.liquid.renderer,
                        n = c(yield this.cond.value(t, t.opts.lenientIf));
                    for (const r of this.cases) {
                        if (c(yield r.val.value(t, t.opts.lenientIf)) === n) return void(yield i.renderTemplates(r.templates, t, e))
                    }
                    yield i.renderTemplates(this.elseTemplates, t, e)
                }
            },
            ue = {
                parse: function(t, e) {
                    const i = this.liquid.parser.parseStream(e);
                    i.on("token", t => {
                        "endcomment" === t.name && i.stop()
                    }).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    }), i.start()
                }
            };
        ! function(t) {
            t[t.OUTPUT = 0] = "OUTPUT", t[t.STORE = 1] = "STORE"
        }(ae || (ae = {}));
        var ce = ae;
        class de extends n {
            constructor(t = (() => "")) {
                super(), this.superBlockRender = t
            }
            super() {
                return this.superBlockRender()
            }
        }
        class he extends re {
            constructor(t, e) {
                super(t), this.length = t, this.cols = e
            }
            row() {
                return Math.floor(this.i / this.cols) + 1
            }
            col0() {
                return this.i % this.cols
            }
            col() {
                return this.col0() + 1
            }
            col_first() {
                return 0 === this.col0()
            }
            col_last() {
                return this.col() === this.cols
            }
        }
        const pe = {
                assign: ee,
                for: se,
                capture: oe,
                case: le,
                comment: ue,
                include: {
                    parse: function(t) {
                        const e = t.args,
                            i = new Bt(e, this.liquid.options.operatorsTrie);
                        this.file = this.liquid.options.dynamicPartials ? i.readValue() : i.readFileName(), Et(this.file, () => `illegal argument "${t.args}"`);
                        const n = i.p;
                        "with" === i.readIdentifier().content ? (i.skipBlank(), ":" !== i.peek() ? this.withVar = i.readValue() : i.p = n) : i.p = n, this.hash = new Ut(i.remaining())
                    },
                    render: function*(t, e) {
                        const {
                            liquid: i,
                            hash: n,
                            withVar: r,
                            file: s
                        } = this, {
                            renderer: o
                        } = i, a = t.opts.dynamicPartials ? V(s) ? yield o.renderTemplates(i.parse(At(s)), t): yield jt(s, t): s.getText();
                        Et(a, () => `illegal filename "${s.getText()}":"${a}"`);
                        const l = t.saveRegister("blocks", "blockMode");
                        t.setRegister("blocks", {}), t.setRegister("blockMode", ce.OUTPUT);
                        const u = yield n.render(t);
                        r && (u[a] = jt(r, t));
                        const c = yield i._parseFile(a, t.opts, t.sync);
                        t.push(u), yield o.renderTemplates(c, t, e), t.pop(), t.restoreRegister(l)
                    }
                },
                render: {
                    parse: function(t) {
                        const e = t.args,
                            i = new Bt(e, this.liquid.options.operatorsTrie);
                        for (this.file = this.liquid.options.dynamicPartials ? i.readValue() : i.readFileName(), Et(this.file, () => `illegal argument "${t.args}"`); !i.end();) {
                            i.skipBlank();
                            const t = i.p,
                                e = i.readIdentifier();
                            if (("with" === e.content || "for" === e.content) && (i.skipBlank(), ":" !== i.peek())) {
                                const t = i.readValue();
                                if (t) {
                                    const n = i.p;
                                    let r;
                                    "as" === i.readIdentifier().content ? r = i.readIdentifier() : i.p = n, this[e.content] = {
                                        value: t,
                                        alias: r && r.content
                                    }, i.skipBlank(), "," === i.peek() && i.advance();
                                    continue
                                }
                            }
                            i.p = t;
                            break
                        }
                        this.hash = new Ut(i.remaining())
                    },
                    render: function*(t, e) {
                        const {
                            liquid: i,
                            file: n,
                            hash: r
                        } = this, {
                            renderer: s
                        } = i, o = t.opts.dynamicPartials ? V(n) ? yield s.renderTemplates(i.parse(At(n)), t): jt(n, t): n.getText();
                        Et(o, () => `illegal filename "${n.getText()}":"${o}"`);
                        const a = new W({}, t.opts, t.sync),
                            l = yield r.render(t);
                        if (this.with) {
                            const {
                                value: e,
                                alias: i
                            } = this.with;
                            l[i || o] = jt(e, t)
                        }
                        if (a.push(l), this.for) {
                            const {
                                value: n,
                                alias: r
                            } = this.for;
                            let u = jt(n, t);
                            u = ie(u), l.forloop = new re(u.length);
                            for (const t of u) {
                                l[r] = t;
                                const n = yield i._parseFile(o, a.opts, a.sync);
                                yield s.renderTemplates(n, a, e), l.forloop.next()
                            }
                        } else {
                            const t = yield i._parseFile(o, a.opts, a.sync);
                            yield s.renderTemplates(t, a, e)
                        }
                    }
                },
                decrement: {
                    parse: function(t) {
                        const e = new Bt(t.args, this.liquid.options.operatorsTrie);
                        this.variable = e.readIdentifier().content
                    },
                    render: function(t, e) {
                        const i = t.environments;
                        d(i[this.variable]) || (i[this.variable] = 0), e.write(u(--i[this.variable]))
                    }
                },
                increment: {
                    parse: function(t) {
                        const e = new Bt(t.args, this.liquid.options.operatorsTrie);
                        this.variable = e.readIdentifier().content
                    },
                    render: function(t, e) {
                        const i = t.environments;
                        d(i[this.variable]) || (i[this.variable] = 0);
                        const n = i[this.variable];
                        i[this.variable]++, e.write(u(n))
                    }
                },
                cycle: {
                    parse: function(t) {
                        const e = new Bt(t.args, this.liquid.options.operatorsTrie),
                            i = e.readValue();
                        for (e.skipBlank(), this.candidates = [], i && (":" === e.peek() ? (this.group = i, e.advance()) : this.candidates.push(i)); !e.end();) {
                            const t = e.readValue();
                            t && this.candidates.push(t), e.readTo(",")
                        }
                        Et(this.candidates.length, () => `empty candidates: ${t.getText()}`)
                    },
                    render: function(t, e) {
                        const i = `cycle:${jt(this.group,t)}:` + this.candidates.join(","),
                            n = t.getRegister("cycle");
                        let r = n[i];
                        void 0 === r && (r = n[i] = 0);
                        const s = this.candidates[r];
                        r = (r + 1) % this.candidates.length, n[i] = r;
                        const o = jt(s, t);
                        e.write(o)
                    }
                },
                if: {
                    parse: function(t, e) {
                        let i;
                        this.branches = [], this.elseTemplates = [];
                        const n = this.liquid.parser.parseStream(e).on("start", () => this.branches.push({
                            cond: new zt(t.args, this.liquid),
                            templates: i = []
                        })).on("tag:elsif", t => {
                            this.branches.push({
                                cond: new zt(t.args, this.liquid),
                                templates: i = []
                            })
                        }).on("tag:else", () => i = this.elseTemplates).on("tag:endif", () => n.stop()).on("template", t => i.push(t)).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        });
                        n.start()
                    },
                    render: function*(t, e) {
                        const i = this.liquid.renderer;
                        for (const n of this.branches) {
                            if (C(yield n.cond.value(t, t.opts.lenientIf), t)) return void(yield i.renderTemplates(n.templates, t, e))
                        }
                        yield i.renderTemplates(this.elseTemplates, t, e)
                    }
                },
                layout: {
                    parse: function(t, e) {
                        const i = new Bt(t.args, this.liquid.options.operatorsTrie),
                            n = this.liquid.options.dynamicPartials ? i.readValue() : i.readFileName();
                        Et(n, () => `illegal argument "${t.args}"`), this.file = n, this.hash = new Ut(i.remaining()), this.tpls = this.liquid.parser.parse(e)
                    },
                    render: function*(t, e) {
                        const {
                            liquid: i,
                            hash: n,
                            file: r
                        } = this, {
                            renderer: s
                        } = i;
                        if ("none" === r.getText()) {
                            t.setRegister("blockMode", ce.OUTPUT);
                            const i = yield s.renderTemplates(this.tpls, t);
                            return void e.write(i)
                        }
                        const o = t.opts.dynamicPartials ? V(r) ? yield s.renderTemplates(i.parse(At(r)), t): jt(this.file, t): r.getText();
                        Et(o, () => `file "${r.getText()}"("${o}") not available`);
                        const a = yield i._parseFile(o, t.opts, t.sync);
                        t.setRegister("blockMode", ce.STORE);
                        const l = yield s.renderTemplates(this.tpls, t), u = t.getRegister("blocks");
                        void 0 === u[""] && (u[""] = () => l), t.setRegister("blockMode", ce.OUTPUT), t.push(yield n.render(t));
                        const c = yield s.renderTemplates(a, t);
                        t.pop(), e.write(c)
                    }
                },
                block: {
                    parse(t, e) {
                        const i = /\w+/.exec(t.args);
                        this.block = i ? i[0] : "", this.tpls = [];
                        const n = this.liquid.parser.parseStream(e).on("tag:endblock", () => n.stop()).on("template", t => this.tpls.push(t)).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        });
                        n.start()
                    },
                    * render(t, e) {
                        const i = this.getBlockRender(t);
                        yield this.emitHTML(t, e, i)
                    },
                    getBlockRender(t) {
                        const {
                            liquid: e,
                            tpls: i
                        } = this, n = t.getRegister("blocks")[this.block], r = function*(n) {
                            t.push({
                                block: n
                            });
                            const r = yield e.renderer.renderTemplates(i, t);
                            return t.pop(), r
                        };
                        return n ? t => n(new de(() => r(t))) : r
                    },
                    * emitHTML(t, e, i) {
                        t.getRegister("blockMode", ce.OUTPUT) === ce.STORE ? t.getRegister("blocks")[this.block] = i : e.write(yield i(new de))
                    }
                },
                raw: {
                    parse: function(t, e) {
                        this.tokens = [];
                        const i = this.liquid.parser.parseStream(e);
                        i.on("token", t => {
                            "endraw" === t.name ? i.stop() : this.tokens.push(t)
                        }).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        }), i.start()
                    },
                    render: function() {
                        return this.tokens.map(t => t.getText()).join("")
                    }
                },
                tablerow: {
                    parse: function(t, e) {
                        const i = new Bt(t.args, this.liquid.options.operatorsTrie);
                        this.variable = i.readIdentifier(), i.skipBlank();
                        const n = i.readIdentifier();
                        let r;
                        Et(n && "in" === n.content, () => `illegal tag: ${t.getText()}`), this.collection = i.readValue(), this.hash = new Ut(i.remaining()), this.templates = [];
                        const s = this.liquid.parser.parseStream(e).on("start", () => r = this.templates).on("tag:endtablerow", () => s.stop()).on("template", t => r.push(t)).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        });
                        s.start()
                    },
                    render: function*(t, e) {
                        let i = ie(yield jt(this.collection, t));
                        const n = yield this.hash.render(t), r = n.offset || 0, s = void 0 === n.limit ? i.length : n.limit;
                        i = i.slice(r, r + s);
                        const o = n.cols || i.length,
                            a = this.liquid.renderer,
                            l = new he(i.length, o),
                            u = {
                                tablerowloop: l
                            };
                        t.push(u);
                        for (let n = 0; n < i.length; n++, l.next()) u[this.variable.content] = i[n], 0 === l.col0() && (1 !== l.row() && e.write("</tr>"), e.write(`<tr class="row${l.row()}">`)), e.write(`<td class="col${l.col()}">`), yield a.renderTemplates(this.templates, t, e), e.write("</td>");
                        i.length && e.write("</tr>"), t.pop()
                    }
                },
                unless: {
                    parse: function(t, e) {
                        let i;
                        this.templates = [], this.branches = [], this.elseTemplates = [];
                        const n = this.liquid.parser.parseStream(e).on("start", () => {
                            i = this.templates, this.cond = new zt(t.args, this.liquid)
                        }).on("tag:elsif", t => {
                            this.branches.push({
                                cond: new zt(t.args, this.liquid),
                                templates: i = []
                            })
                        }).on("tag:else", () => i = this.elseTemplates).on("tag:endunless", () => n.stop()).on("template", t => i.push(t)).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        });
                        n.start()
                    },
                    render: function*(t, e) {
                        const i = this.liquid.renderer;
                        if (P(yield this.cond.value(t, t.opts.lenientIf), t)) yield i.renderTemplates(this.templates, t, e);
                        else {
                            for (const n of this.branches) {
                                if (C(yield n.cond.value(t, t.opts.lenientIf), t)) return void(yield i.renderTemplates(n.templates, t, e))
                            }
                            yield i.renderTemplates(this.elseTemplates, t, e)
                        }
                    }
                },
                break: {
                    render: function(t, e) {
                        e.break = !0
                    }
                },
                continue: {
                    render: function(t, e) {
                        e.continue = !0
                    }
                }
            },
            fe = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&#34;",
                "'": "&#39;"
            },
            ge = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&#34;": '"',
                "&#39;": "'"
            };

        function me(t) {
            return u(t).replace(/&|<|>|"|'/g, t => fe[t])
        }
        const _e = Math.abs,
            ye = Math.max,
            ve = Math.min,
            we = Math.ceil,
            be = Math.floor;
        const xe = /%([-_0^#:]+)?(\d+)?([EO])?(.)/,
            Te = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            Ee = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            Oe = Te.map(De),
            Ce = Ee.map(De),
            Pe = {
                1: "st",
                2: "nd",
                3: "rd",
                default: "th"
            };

        function De(t) {
            return t.slice(0, 3)
        }

        function Me(t) {
            return [31, function(t) {
                const e = t.getFullYear();
                return !(0 != (3 & e) || !(e % 100 || e % 400 == 0 && e))
            }(t) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        }

        function Re(t) {
            let e = 0;
            for (let i = 0; i < t.getMonth(); ++i) e += Me(t)[i];
            return e + t.getDate()
        }

        function ke(t, e) {
            const i = Re(t) + (e - t.getDay()),
                n = 7 - new Date(t.getFullYear(), 0, 1).getDay() + e;
            return String(Math.floor((i - n) / 7) + 1)
        }
        const Se = {
                d: 2,
                e: 2,
                H: 2,
                I: 2,
                j: 3,
                k: 2,
                l: 2,
                L: 3,
                m: 2,
                M: 2,
                S: 2,
                U: 2,
                W: 2
            },
            Le = {
                a: " ",
                A: " ",
                b: " ",
                B: " ",
                c: " ",
                e: " ",
                k: " ",
                l: " ",
                p: " ",
                P: " "
            },
            je = {
                a: t => Ce[t.getDay()],
                A: t => Ee[t.getDay()],
                b: t => Oe[t.getMonth()],
                B: t => Te[t.getMonth()],
                c: t => t.toLocaleString(),
                C: t => (function(t) {
                    return parseInt(t.getFullYear().toString().substring(0, 2), 10)
                })(t),
                d: t => t.getDate(),
                e: t => t.getDate(),
                H: t => t.getHours(),
                I: t => String(t.getHours() % 12 || 12),
                j: t => Re(t),
                k: t => t.getHours(),
                l: t => String(t.getHours() % 12 || 12),
                L: t => t.getMilliseconds(),
                m: t => t.getMonth() + 1,
                M: t => t.getMinutes(),
                N: (t, e) => {
                    const i = Number(e.width) || 9;
                    return function(t, e, i = " ") {
                        return v(t, e, i, (t, e) => t + e)
                    }(String(t.getMilliseconds()).substr(0, i), i, "0")
                },
                p: t => t.getHours() < 12 ? "AM" : "PM",
                P: t => t.getHours() < 12 ? "am" : "pm",
                q: t => (function(t) {
                    const e = t.getDate().toString(),
                        i = parseInt(e.slice(-1));
                    return Pe[i] || Pe.default
                })(t),
                s: t => Math.round(t.valueOf() / 1e3),
                S: t => t.getSeconds(),
                u: t => t.getDay() || 7,
                U: t => ke(t, 0),
                w: t => t.getDay(),
                W: t => ke(t, 1),
                x: t => t.toLocaleDateString(),
                X: t => t.toLocaleTimeString(),
                y: t => t.getFullYear().toString().substring(2, 4),
                Y: t => t.getFullYear(),
                z: (t, e) => {
                    const i = t.getTimezoneOffset(),
                        n = Math.abs(i),
                        r = n % 60;
                    return (i > 0 ? "-" : "+") + y(Math.floor(n / 60), 2, "0") + (e.flags[":"] ? ":" : "") + y(r, 2, "0")
                },
                t: () => "\t",
                n: () => "\n",
                "%": () => "%"
            };

        function Ae(t, e) {
            const [i, n = "", r, s, o] = e, a = je[o];
            if (!a) return i;
            const l = {};
            for (const t of n) l[t] = !0;
            let u = String(a(t, {
                    flags: l,
                    width: r,
                    modifier: s
                })),
                c = Le[o] || "0",
                d = r || Se[o] || 0;
            var h;
            return l["^"] ? u = u.toUpperCase() : l["#"] && (h = u, u = [...h].some(t => t >= "a" && t <= "z") ? h.toUpperCase() : h.toLowerCase()), l._ ? c = " " : l[0] && (c = "0"), l["-"] && (d = 0), y(u, d, c)
        }
        je.h = je.b;
        class qe extends Date {
            constructor(t) {
                super(t), this.dateString = t, this.ISO8601_TIMEZONE_PATTERN = /([zZ]|([+-])(\d{2}):(\d{2}))$/, this.inputTimezoneOffset = 0;
                const e = t.match(this.ISO8601_TIMEZONE_PATTERN);
                if (e && "Z" === e[1]) this.inputTimezoneOffset = this.getTimezoneOffset();
                else if (e && e[2] && e[3] && e[4]) {
                    const [, , t, i, n] = e, r = ("+" === t ? 1 : -1) * (60 * parseInt(i, 10) + parseInt(n, 10));
                    this.inputTimezoneOffset = this.getTimezoneOffset() + r
                }
            }
            getDisplayDate() {
                return new Date(+this + 60 * this.inputTimezoneOffset * 1e3)
            }
        }
        var Ie = Object.freeze({
            escape: me,
            escapeOnce: function(t) {
                return me(function(t) {
                    return String(t).replace(/&(amp|lt|gt|#34|#39);/g, t => ge[t])
                }(t))
            },
            newlineToBr: function(t) {
                return t.replace(/\n/g, "<br />\n")
            },
            stripHtml: function(t) {
                return t.replace(/<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g, "")
            },
            abs: _e,
            atLeast: ye,
            atMost: ve,
            ceil: we,
            dividedBy: (t, e) => t / e,
            floor: be,
            minus: (t, e) => t - e,
            modulo: (t, e) => t % e,
            times: (t, e) => t * e,
            round: function(t, e = 0) {
                const i = Math.pow(10, e);
                return Math.round(t * i) / i
            },
            plus: function(t, e) {
                return Number(t) + Number(e)
            },
            sortNatural: function(t, e) {
                return t && t.sort ? void 0 !== e ? [...t].sort((t, i) => x(t[e], i[e])) : [...t].sort(x) : []
            },
            urlDecode: t => t.split("+").map(decodeURIComponent).join(" "),
            urlEncode: t => t.split(" ").map(encodeURIComponent).join("+"),
            join: (t, e) => t.join(void 0 === e ? " " : e),
            last: t => p(t) ? g(t) : "",
            first: t => p(t) ? t[0] : "",
            reverse: t => [...t].reverse(),
            sort: function(t, e) {
                const i = t => e ? this.context.getFromScope(t, e.split(".")) : t;
                return ne(t).sort((t, e) => (t = i(t)) < (e = i(e)) ? -1 : t > e ? 1 : 0)
            },
            size: t => t && t.length || 0,
            map: function(t, e) {
                return ne(t).map(t => this.context.getFromScope(t, e.split(".")))
            },
            compact: function(t) {
                return ne(t).filter(t => !h(t))
            },
            concat: function(t, e) {
                return ne(t).concat(e)
            },
            slice: function(t, e, i = 1) {
                return e = e < 0 ? t.length + e : e, t.slice(e, e + i)
            },
            where: function(t, e, i) {
                return ne(t).filter(t => {
                    const n = this.context.getFromScope(t, String(e).split("."));
                    return void 0 === i ? C(n, this.context) : n === i
                })
            },
            uniq: function(t) {
                const e = {};
                return (t || []).filter(t => !e.hasOwnProperty(String(t)) && (e[String(t)] = !0, !0))
            },
            date: function(t, e) {
                let i = t;
                return "now" === t || "today" === t ? i = new Date : d(t) ? i = new Date(1e3 * t) : a(t) && (i = /^\d+$/.test(t) ? new Date(1e3 * +t) : this.context.opts.preserveTimezones ? new qe(t) : new Date(t)),
                    function(t) {
                        return t instanceof Date && !isNaN(t.getTime())
                    }(i) ? function(t, e) {
                        let i = t;
                        i instanceof qe && (i = i.getDisplayDate());
                        let n, r = "",
                            s = e;
                        for (; n = xe.exec(s);) r += s.slice(0, n.index), s = s.slice(n.index + n[0].length), r += Ae(i, n);
                        return r + s
                    }(i, e) : t
            },
            Default: function(t, e) {
                return p(t) || a(t) ? t.length ? t : e : P(c(t), this.context) ? e : t
            },
            json: function(t) {
                return JSON.stringify(t)
            },
            append: function(t, e) {
                return Et(void 0 !== e, () => "append expect 2 arguments"), u(t) + u(e)
            },
            prepend: function(t, e) {
                return Et(void 0 !== e, () => "prepend expect 2 arguments"), u(e) + u(t)
            },
            lstrip: function(t) {
                return u(t).replace(/^\s+/, "")
            },
            downcase: function(t) {
                return u(t).toLowerCase()
            },
            upcase: function(t) {
                return u(t).toUpperCase()
            },
            remove: function(t, e) {
                return u(t).split(String(e)).join("")
            },
            removeFirst: function(t, e) {
                return u(t).replace(String(e), "")
            },
            rstrip: function(t) {
                return u(t).replace(/\s+$/, "")
            },
            split: function(t, e) {
                return u(t).split(String(e))
            },
            strip: function(t) {
                return u(t).trim()
            },
            stripNewlines: function(t) {
                return u(t).replace(/\n/g, "")
            },
            capitalize: function(t) {
                return (t = u(t)).charAt(0).toUpperCase() + t.slice(1)
            },
            replace: function(t, e, i) {
                return u(t).split(String(e)).join(i)
            },
            replaceFirst: function(t, e, i) {
                return u(t).replace(String(e), i)
            },
            truncate: function(t, e = 50, i = "...") {
                return (t = u(t)).length <= e ? t : t.substr(0, e - i.length) + i
            },
            truncatewords: function(t, e = 15, i = "...") {
                const n = t.split(/\s+/);
                let r = n.slice(0, e).join(" ");
                return n.length >= e && (r += i), r
            }
        });
        class Be {
            constructor() {
                this.impls = {}
            }
            get(t) {
                const e = this.impls[t];
                return Et(e, () => `tag "${t}" not found`), e
            }
            set(t, e) {
                this.impls[t] = e
            }
        }
        class Ne {
            constructor(t, e) {
                this.strictFilters = t, this.liquid = e, this.impls = {}
            }
            get(t) {
                const e = this.impls[t];
                return Et(e || !this.strictFilters, () => `undefined filter: ${t}`), e
            }
            set(t, e) {
                this.impls[t] = e
            }
            create(t, e) {
                return new Ht(t, this.get(t), e, this.liquid)
            }
        }
        class We {
            constructor(t = {}) {
                var e;
                this.options = (e = k(t), Object.assign({}, R, e)), this.parser = new te(this), this.renderer = new Wt, this.filters = new Ne(this.options.strictFilters, this), this.tags = new Be, f(pe, (t, e) => this.registerTag(b(e), t)), f(Ie, (t, e) => this.registerFilter(b(e), t))
            }
            parse(t, e) {
                const i = new Bt(t, this.options.operatorsTrie, e).readTopLevelTokens(this.options);
                return this.parser.parse(i)
            }
            _render(t, e, i, n) {
                const r = Object.assign({}, this.options, k(i)),
                    s = new W(e, r, n),
                    o = new Nt(r.keepOutputType);
                return this.renderer.renderTemplates(t, s, o)
            }
            async render(t, e, i) {
                return Xt(this._render(t, e, i, !1))
            }
            renderSync(t, e, i) {
                return Jt(this._render(t, e, i, !0))
            }
            _parseAndRender(t, e, i, n) {
                const r = this.parse(t);
                return this._render(r, e, i, n)
            }
            async parseAndRender(t, e, i) {
                return Xt(this._parseAndRender(t, e, i, !1))
            }
            parseAndRenderSync(t, e, i) {
                return Jt(this._parseAndRender(t, e, i, !0))
            }* _parseFile(t, e, i) {
                const n = Object.assign({}, this.options, k(e)),
                    r = n.root.map(e => n.fs.resolve(e, t, n.extname));
                if (void 0 !== n.fs.fallback) {
                    const e = n.fs.fallback(t);
                    void 0 !== e && r.push(e)
                }
                for (const t of r) {
                    const {
                        cache: e
                    } = n;
                    if (e) {
                        const i = yield e.read(t);
                        if (i) return i
                    }
                    if (!(i ? n.fs.existsSync(t) : yield n.fs.exists(t))) continue;
                    const r = this.parse(i ? n.fs.readFileSync(t) : yield n.fs.readFile(t), t);
                    return e && e.write(t, r), r
                }
                throw this.lookupError(t, n.root)
            }
            async parseFile(t, e) {
                return Xt(this._parseFile(t, e, !1))
            }
            parseFileSync(t, e) {
                return Jt(this._parseFile(t, e, !0))
            }
            async renderFile(t, e, i) {
                const n = await this.parseFile(t, i);
                return this.render(n, e, i)
            }
            renderFileSync(t, e, i) {
                const n = this.parseFileSync(t, i);
                return this.renderSync(n, e, i)
            }
            _evalValue(t, e) {
                return new zt(t, this).value(e, !1)
            }
            async evalValue(t, e) {
                return Xt(this._evalValue(t, e))
            }
            evalValueSync(t, e) {
                return Jt(this._evalValue(t, e))
            }
            registerFilter(t, e) {
                this.filters.set(t, e)
            }
            registerTag(t, e) {
                this.tags.set(t, e)
            }
            plugin(t) {
                return t.call(this, We)
            }
            express() {
                const t = this;
                return function(e, i, n) {
                    const r = {
                        root: [...S(this.root), ...t.options.root]
                    };
                    t.renderFile(e, i, r).then(t => n(null, t), n)
                }
            }
            lookupError(t, e) {
                const i = new Error("ENOENT");
                return i.message = `ENOENT: Failed to lookup "${t}" in "${e}"`, i.code = "ENOENT", i
            }
            async getTemplate(t, e) {
                return this.parseFile(t, e)
            }
            getTemplateSync(t, e) {
                return this.parseFileSync(t, e)
            }
        }
    },
    727: function(t, e, i) {
        t.exports = i(728)
    },
    728: function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__),
            function(__webpack_provided_window_dot_gPR) {
                var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7),
                    jquery__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__),
                    _owl_carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(729),
                    _owl_carousel__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_owl_carousel__WEBPACK_IMPORTED_MODULE_1__),
                    liquidjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(720),
                    universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44);

                function _defineProperty(t, e, i) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = i, t
                }

                function _typeof(t) {
                    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                        return typeof t
                    } : function(t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    })(t)
                }
                var GLiquid = new liquidjs__WEBPACK_IMPORTED_MODULE_2__.a({
                        cache: !0,
                        jsTruthy: !0,
                        strictVariables: !1
                    }),
                    formatMoney = function(t, e, i, n) {
                        function r(t, e) {
                            return void 0 === t ? e : t
                        }

                        function s(t, e, i, n, s) {
                            if (e = r(e, 2), i = r(i, ","), n = r(n, "."), isNaN(t) || null == t) return 0;
                            if ("undefined" == typeof DoublyGlobalCurrency && !window.isMultiCurrency && "object" == ("undefined" == typeof Shopify ? "undefined" : _typeof(Shopify)) && Shopify.hasOwnProperty("currency") && "object" == _typeof(Shopify.currency) && Shopify.currency.hasOwnProperty("rate") && Shopify.currency.hasOwnProperty("active") && 1 != Shopify.currency.rate) {
                                t /= 100;
                                var o = {
                                    VND: 1e3,
                                    AFN: 100,
                                    ALL: 100,
                                    DZD: 100,
                                    AOA: 100,
                                    ARS: 1,
                                    AMD: 100,
                                    AWG: 1,
                                    AUD: 1,
                                    AZN: 1,
                                    BSD: 1,
                                    BDT: 100,
                                    BBD: 1,
                                    BZD: 1,
                                    BMD: 1,
                                    BOB: 1,
                                    BAM: 1,
                                    BWP: 1,
                                    BRL: 1,
                                    GBP: 1,
                                    BND: 1,
                                    BGN: 1,
                                    BIF: 1e3,
                                    KHR: 1e3,
                                    CAD: 1,
                                    CVE: 100,
                                    KYD: 1,
                                    XAF: 100,
                                    XPF: 100,
                                    CLP: 100,
                                    CNY: 1,
                                    COP: 1e3,
                                    KMF: 100,
                                    CDF: 1e3,
                                    CRC: 100,
                                    HRK: 1,
                                    CZK: 1,
                                    DKK: 1,
                                    DJF: 100,
                                    DOP: 100,
                                    XCD: 1,
                                    EGP: 1,
                                    ETB: 1,
                                    EUR: .95,
                                    FKP: 1,
                                    FJD: 1,
                                    GMD: 1,
                                    GEL: 1,
                                    GIP: 1,
                                    GTQ: 1,
                                    GNF: 1e3,
                                    GYD: 100,
                                    HTG: 100,
                                    HNL: 1,
                                    HKD: 1,
                                    HUF: 100,
                                    ISK: 100,
                                    INR: 100,
                                    IDR: 1e3,
                                    ILS: 1,
                                    JMD: 100,
                                    JPY: 100,
                                    KZT: 100,
                                    KES: 100,
                                    KGS: 100,
                                    LAK: 1e3,
                                    LBP: 1e3,
                                    LSL: 1,
                                    LRD: 100,
                                    MOP: 1,
                                    MKD: 100,
                                    MWK: 100,
                                    MYR: 1,
                                    MVR: 1,
                                    MUR: 1,
                                    MXN: 1,
                                    MDL: 1,
                                    MNT: 1e3,
                                    MAD: 1,
                                    MZN: 100,
                                    MMK: 1e3,
                                    NAD: 1,
                                    NPR: 100,
                                    ANG: 1,
                                    TWD: 1,
                                    NZD: 1,
                                    NIO: 1,
                                    NGN: 100,
                                    NOK: 1,
                                    PKR: 100,
                                    PAB: 1,
                                    PGK: 1,
                                    PYG: 100,
                                    PEN: 1,
                                    PHP: 100,
                                    PLN: 1,
                                    QAR: 1,
                                    RON: 1,
                                    RUB: 100,
                                    RWF: 100,
                                    WST: 1,
                                    STD: 1e3,
                                    SAR: 1,
                                    RSD: 100,
                                    SCR: 1,
                                    SLL: 100,
                                    SGD: 1,
                                    SBD: 1,
                                    ZAR: 1,
                                    KRW: 1e3,
                                    LKR: 100,
                                    SHP: 1,
                                    SRD: 1,
                                    SZL: 1,
                                    SEK: 1,
                                    CHF: 1,
                                    TJS: 1,
                                    TZS: 1e3,
                                    THB: 1,
                                    TOP: 1,
                                    TTD: 1,
                                    TRY: 1,
                                    UGX: 1e3,
                                    UAH: 1,
                                    AED: 1,
                                    UYU: 1,
                                    USD: 1,
                                    UZS: 1e3,
                                    VUV: 100,
                                    XOF: 100,
                                    YER: 100,
                                    ZMW: 1
                                } [Shopify.currency.active];
                                o >= 1 ? t = Math.ceil(t / o) * o : o < 1 && (t = parseInt(t) + (t - parseInt(t) > 0 ? o : 0))
                            } else t /= 100;
                            var a = parseFloat(t).toFixed(e).split(".");
                            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] && (s || parseInt(a[1]) > 0) ? n + a[1] : "")
                        }
                        "string" == typeof t && (t = t.replace(".", ""));
                        var o = "",
                            a = /\{\{\s*(\w+)\s*\}\}/,
                            l = e;
                        switch (l.match(a)[1]) {
                            case "amount":
                            case "amount_with_decimals":
                                o = s(t, 2, ",", ".", n);
                                break;
                            case "amount_no_decimals":
                            case "amount_no_decimal":
                                o = s(t, 0, ",", ".", n);
                                break;
                            case "amount_with_comma_separator":
                                o = s(t, 2, ".", ",", n);
                                break;
                            case "amount_with_space_separator":
                                o = s(t, 2, " ", ",", n);
                                break;
                            case "amount_with_period_and_space_separator":
                                o = s(t, 2, " ", ".", n);
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                o = s(t, 0, ".", ",", n);
                                break;
                            case "amount_no_decimals_with_space_separator":
                                o = s(t, 0, " ", "", n);
                                break;
                            case "amount_with_space_separator":
                                o = s(t, 2, " ", ",", n);
                                break;
                            case "amount_with_apostrophe_separator":
                                o = s(t, 2, "'", ".", n)
                        }
                        return i ? l.replace(a, o) : o
                    },
                    format = window.GloboMoneyFormat || window.moneyFormat;
                GLiquid.registerFilter("money", function(t) {
                    return formatMoney(t, format, !0, !0)
                }), GLiquid.registerFilter("money_with_currency", function(t) {
                    return formatMoney(t, format, !0, !0)
                }), GLiquid.registerFilter("money_without_trailing_zeros", function(t) {
                    return formatMoney(t, format, !0, !1)
                }), GLiquid.registerFilter("money_without_currency", function(t) {
                    return formatMoney(t, format, !1, !1)
                }), GLiquid.registerFilter("asset_url", function(t) {
                    return window.assetsUrl + t
                }), GLiquid.registerFilter("img_url", function(t, e, i) {
                    if (i = i || !1, !t) return "";
                    "object" === _typeof(t) && t.hasOwnProperty("src") && (t = t.src);
                    var n = t.split(".").pop(),
                        r = t.lastIndexOf(n) - 1;
                    return t.slice(0, r) + "_" + e + t.slice(r)
                }), GLiquid.registerFilter("product_img_url", function(t, e, i) {
                    if (i = i || !1, !t) return "";
                    "object" === _typeof(t) && t.hasOwnProperty("src") && (t = t.src);
                    var n = t.split(".").pop(),
                        r = t.lastIndexOf(n) - 1;
                    return t.slice(0, r) + "_" + e + t.slice(r)
                }), GLiquid.registerFilter("img_ladyload_url", function(t, e) {
                    if (e = e || !1, !t) return "";
                    "object" === _typeof(t) && t.hasOwnProperty("src") && (t = t.src);
                    var i = t.split(".").pop(),
                        n = t.lastIndexOf(i) - 1;
                    return t.slice(0, n) + "_{width}x" + t.slice(n)
                }), GLiquid.registerFilter("img_lazyload_url", function(t, e) {
                    if (e = e || !1, !t) return "";
                    "object" === _typeof(t) && t.hasOwnProperty("src") && (t = t.src);
                    var i = t.split(".").pop(),
                        n = t.lastIndexOf(i) - 1;
                    return t.slice(0, n) + "_{width}x" + t.slice(n)
                }), GLiquid.registerFilter("asset_img_url", function(t, e) {
                    if (!t) return "";
                    var i = t.split(".").pop(),
                        n = t.lastIndexOf(i) - 1;
                    return t = t.slice(0, n) + "_" + e + t.slice(n), window.assetsUrl + t
                }), GLiquid.registerFilter("crop", function(t, e) {
                    if (!t) return "";
                    var i = t.split(".").pop(),
                        n = t.lastIndexOf(i) - 1;
                    return t.slice(0, n) + "_crop_" + e + t.slice(n)
                }), GLiquid.registerFilter("file_img_url", function(t, e, i) {
                    if (i = i || !1, !t) return "";
                    i = t.split(".").pop();
                    var n = t.lastIndexOf(i) - 1;
                    return t = t.slice(0, n) + "_" + e + t.slice(n), window.filesUrl + t
                }), GLiquid.registerFilter("parseJson", function(t) {
                    return JSON.parse(t)
                }), GLiquid.registerFilter("custom_sort", function(t) {
                    return t.sort(function(t, e) {
                        return parseInt(t) - parseInt(e)
                    })
                }), GLiquid.registerFilter("pluralize", function(t, e, i) {
                    return t > 1 ? i : e
                });
                var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__.a,
                    cookieExpires = new Date;
                cookieExpires.setTime(cookieExpires.getTime() + 6048e5), __webpack_provided_window_dot_gPR = jquery__WEBPACK_IMPORTED_MODULE_0___default.a;
                var globoPersonalizedRecommendations = function(t) {
                    this.apiUrl = t.apiUrl, this.alternateApiUrl = t.alternateApiUrl, this.shop = t.shop, this.shopNumber = t.shopNumber, this.domain = t.domain, this.urls = t.urls, this.page = t.page, this.customer = t.customer, this.basis_collection_handle = t.basis_collection_handle, this.translation = t.translation, this.settings = t.settings, this.productBoughtTogether = t.productBoughtTogether, this.productRelated = t.productRelated, this.cart = t.cart, this.discounted_ids = t.discounted_ids, this.discount_min_amount = parseFloat(t.discount_min_amount), this.data = t.data, this.collection = t.collection || null, this.widgets = t.widgets, this.manualRecommendations = t.manualRecommendations, this.manualVendors = t.manualVendors ? t.manualVendors : [], this.manualTags = t.manualTags ? t.manualTags : [], this.manualProductTypes = t.manualProductTypes ? t.manualProductTypes : [], this.manualCollections = t.manualCollections ? t.manualCollections : [], this.boughtTogetherIds = t.boughtTogetherIds, this.trendingProducts = t.trendingProducts, this.recentlyViewedProducts = [], this.view_name = t.view_name, this.cart_properties_name = t.cart_properties_name, this.exclude_tags = [], this.exclude_types = window.exclude_types || ["mw_hide"], this.hidden_tags = [], this.visible_tags = [], this.moneyFormat = t.moneyFormat, this.limit = Math.max(this.cart.limit, this.productRelated.limit, this.productBoughtTogether.limit), this.product = t.product || null, this.no_image_url = t.no_image_url, this.relatedProducts = {}
                };
                globoPersonalizedRecommendations.prototype.init = function() {
                    (new Date).getTime();
                    var t = this,
                        e = !1;
                    if (t.settings.exclude_tags && (t.exclude_tags = t.settings.exclude_tags.split(/\r?\n/)), t.settings.hidden_tags && (t.hidden_tags = t.settings.hidden_tags.split(/\r?\n/)), t.settings.visible_tags && (t.visible_tags = t.settings.visible_tags.split(/\r?\n/)), jquery__WEBPACK_IMPORTED_MODULE_0___default()("script").each(function() {
                            -1 != jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text().indexOf("globo.alsobought.init.js?") && -1 != jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text().indexOf("asyncLoad") && -1 == jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text().indexOf("initSchema") && (e = !0)
                        }), console.log("installed:" + e), e) {
                        if (t.parseRecentlyViewedProducts(), t.data.collections && t.data.collections.length && (t.data.collections = t.data.collections.filter(function(t, e, i) {
                                return i.indexOf(t) == e
                            })), t.data.tags && t.data.tags.length && (t.data.tags = t.data.tags.filter(function(t, e, i) {
                                return i.indexOf(t) == e
                            })), "product" == t.page) {
                            var i = !0;
                            t.visible_tags.length > 0 && 0 == t.visible_tags.filter(function(e) {
                                return t.data.tags.indexOf(e) > -1
                            }).length && (i = !1), t.hidden_tags.length > 0 && t.hidden_tags.filter(function(e) {
                                return t.data.tags.indexOf(e) > -1
                            }).length > 0 && (i = !1), t.productBoughtTogether.enable && i && setTimeout(function() {
                                t.productBoughtTogether.relatedProducts = [], t.productBoughtTogether.id = "ga-product_bought_together";
                                var e = t.getDeferredStuff(t.productBoughtTogether, t.data);
                                jquery__WEBPACK_IMPORTED_MODULE_0___default.a.when.apply(null, e).done(function() {
                                    var e = t.getBoxProducts(t.productBoughtTogether, t.data);
                                    e.length && (t.productBoughtTogether.template.this_item && 1 != t.productBoughtTogether.template.id && t.product.available && e.unshift(t.product), t.buildBoxHTML(t.productBoughtTogether, e, function(e) {
                                        jquery__WEBPACK_IMPORTED_MODULE_0___default()("#productBoughtTogether, .productBoughtTogether").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#productBoughtTogether, .productBoughtTogether").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsForm, .globoRecommendationsForm").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsForm, .globoRecommendationsForm").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]:visible:first, form[action*="/checkout"]:visible:first').length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div id="productBoughtTogether">' + e + "</div>").insertAfter('form[action*="/cart/add"]:visible:first, form[action*="/checkout"]:visible:first') : jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").append('<div id="globoRecommendationsForm">' + e + "</div>"), 1 == parseInt(t.productBoughtTogether.template.id) && setTimeout(function() {
                                            t.initOwlCarousel("#ga-product_bought_together")
                                        }, 0)
                                    }))
                                })
                            }, 0), t.productRelated.enable && i && setTimeout(function() {
                                t.productRelated.relatedProducts = [], t.productRelated.id = "ga-product_related";
                                var e = t.getDeferredStuff(t.productRelated, t.data);
                                jquery__WEBPACK_IMPORTED_MODULE_0___default.a.when.apply(null, e).done(function() {
                                    var e = t.getBoxProducts(t.productRelated, t.data);
                                    e.length && (t.productRelated.template.this_item && 1 != t.productRelated.template.id && t.product.available && e.unshift(t.product), t.buildBoxHTML(t.productRelated, e, function(e) {
                                        jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRelatedProductsCustom, .globoRelatedProductsCustom").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRelatedProductsCustom, .globoRelatedProductsCustom").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsFooterCustom, .globoRecommendationsFooterCustom").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsFooterCustom, .globoRecommendationsFooterCustom").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsFooter").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsFooter").append('<div id="globoRecommendationsFooter">' + e + "</div>") : jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").append('<div id="globoRecommendationsFooter">' + e + "</div>"), 1 == parseInt(t.productRelated.template.id) && setTimeout(function() {
                                            t.initOwlCarousel("#ga-product_related")
                                        }, 0)
                                    }))
                                })
                            }, 0)
                        } else "cart" == t.page && t.cart.enable && setTimeout(function() {
                            t.cart.id = "ga-cart", t.cart.relatedProducts = [];
                            var e = t.getDeferredStuff(t.cart, t.data);
                            jquery__WEBPACK_IMPORTED_MODULE_0___default.a.when.apply(null, e).done(function() {
                                var e = t.getBoxProducts(t.cart, t.data);
                                e.length && t.buildBoxHTML(t.cart, e, function(e) {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoCart").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoCart").html(e) : t.cart.hasOwnProperty("position") && "top" == t.cart.position ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsTopCustom, .globoRecommendationsTopCustom").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsTopCustom, .globoRecommendationsTopCustom").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsTop").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsTop").append('<div id="globoRecommendationsTop">' + e + "</div>") : jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").append('<div id="globoRecommendationsFooter">' + e + "</div>") : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsFooterCustom, .globoRecommendationsFooterCustom").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsFooterCustom, .globoRecommendationsFooterCustom").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRecommendationsFooter").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsFooter").append('<div id="globoRecommendationsFooter">' + e + "</div>") : jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").append('<div id="globoRecommendationsFooter">' + e + "</div>"), 1 == parseInt(t.cart.template.id) && setTimeout(function() {
                                        t.initOwlCarousel("#ga-cart")
                                    }, 0)
                                })
                            })
                        }, 0);
                        setTimeout(function() {
                            t.renderWidgets()
                        }, 0), setTimeout(function() {
                            t.putStatistical()
                        }, 0), t.initEvents(), "product" == t.page && setTimeout(function() {
                            t.addProductToRecentlyViewedProducts(t.product)
                        }, 0)
                    }
                }, globoPersonalizedRecommendations.prototype.parseRecentlyViewedProducts = function() {
                    var t = localStorage.getItem("globoRecentlyViewedProducts" + (null != this.customer ? this.customer : "")),
                        e = t ? JSON.parse(t) : [];
                    if (null != this.customer) {
                        var i = localStorage.getItem("globoRecentlyViewedProducts"),
                            n = i ? JSON.parse(i) : [];
                        e = e.concat(n), localStorage.removeItem("globoRecentlyViewedProducts"), localStorage.setItem("globoRecentlyViewedProducts" + this.customer, JSON.stringify(e))
                    }
                    this.recentlyViewedProducts = e
                }, globoPersonalizedRecommendations.prototype.addProductToRecentlyViewedProducts = function(t) {
                    var e = this;
                    0 == t.tags.filter(function(t) {
                        return -1 != e.exclude_tags.indexOf(t)
                    }).length && (e.recentlyViewedProducts = e.recentlyViewedProducts.filter(function(e, i) {
                        return i < 100 && e.handle != t.handle
                    }), e.recentlyViewedProducts.unshift(t), localStorage.setItem("globoRecentlyViewedProducts" + (null != e.customer ? e.customer : ""), JSON.stringify(e.recentlyViewedProducts)))
                }, globoPersonalizedRecommendations.prototype.deleteRecentlyViewedProducts = function() {
                    localStorage.removeItem("globoRecentlyViewedProducts" + (null != app.customer ? app.customer : ""))
                }, globoPersonalizedRecommendations.prototype.localSaveStatistical = function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "clicked",
                        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        i = this;
                    if (("clicked" == t || "added" == t) && e > 0 && "" != i.shopNumber) {
                        var n = t + "_" + i.shopNumber,
                            r = localStorage.getItem(n);
                        r = null == r ? 0 : parseInt(r), r += parseInt(e), localStorage.setItem(n, r)
                    }
                }, globoPersonalizedRecommendations.prototype.putStatistical = function() {
                    var t = this.alternateApiUrl.replace(/\/\s*$/, "");
                    if ("" != this.shopNumber) {
                        var e = localStorage.getItem("clicked_" + this.shopNumber);
                        null != e && (e = parseInt(e)) > 0 && (localStorage.setItem("clicked_" + this.shopNumber, 0), jquery__WEBPACK_IMPORTED_MODULE_0___default.a.post(t + "/statistical/clicked/" + e, {
                            shop: this.shopNumber
                        }));
                        var i = localStorage.getItem("added_" + this.shopNumber);
                        null != i && (i = parseInt(i)) > 0 && (localStorage.setItem("added_" + this.shopNumber, 0), jquery__WEBPACK_IMPORTED_MODULE_0___default.a.post(t + "/statistical/added/" + i, {
                            shop: this.shopNumber
                        }))
                    }
                }, globoPersonalizedRecommendations.prototype.renderWidgets = function() {
                    var t = this,
                        e = t.exclude_tags.length ? t.exclude_tags.map(function(t) {
                            return ' AND -tag:"' + t + '"'
                        }).join("") : "",
                        i = t.exclude_types.length ? t.exclude_types.map(function(t) {
                            return ' AND -product_type:"' + t + '"'
                        }).join("") : "";
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(t.widgets, function(n, r) {
                        r.idNumber = r.id, r.id = "wigget_" + r.id;
                        var s = "index" == t.page && r.positions.indexOf("index_top") > -1 || "collection" == t.page && r.positions.indexOf("collection_top") > -1 || "product" == t.page && r.positions.indexOf("product_top") > -1 || "cart" == t.page && r.positions.indexOf("cart_top") > -1 || "search" == t.page && r.positions.indexOf("search_top") > -1,
                            o = "index" == t.page && r.positions.indexOf("index_bottom") > -1 || "collection" == t.page && r.positions.indexOf("collection_bottom") > -1 || "product" == t.page && r.positions.indexOf("product_bottom") > -1 || "cart" == t.page && r.positions.indexOf("cart_bottom") > -1 || "search" == t.page && r.positions.indexOf("search_bottom") > -1;
                        if (s || o || jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).length)
                            if (o && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsBottom").first().append('<div class="globo_widget globo_widget_' + r.idNumber + '"></div>'), s && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globoRecommendationsTop").first().append('<div class="globo_widget globo_widget_' + r.idNumber + '"></div>'), "best_selling" == r.conditions.type) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                url: window.location.origin + t.urls.collection + "/" + t.basis_collection_handle + "?sort_by=best-selling&view=" + t.view_name,
                                method: "GET",
                                dataType: "html",
                                success: function(e) {
                                    if (e.length) {
                                        var i = JSON.parse(e);
                                        r.random && (i = i.sort(function() {
                                            return .5 - Math.random()
                                        })), i = i.filter(function(e) {
                                            return 0 == e.tags.filter(function(e) {
                                                return -1 != t.exclude_tags.indexOf(e)
                                            }).length
                                        }), t.buildBoxHTML(r, i.slice(0, r.limit), function(e) {
                                            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(e), 1 == parseInt(r.template.id) && setTimeout(function() {
                                                t.initOwlCarousel("#" + r.id)
                                            }, 0)
                                        })
                                    }
                                }
                            });
                            else if ("newest" == r.conditions.type) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: window.location.origin + t.urls.collection + "/" + t.basis_collection_handle + "?sort_by=created-descending&view=" + t.view_name,
                            method: "GET",
                            dataType: "html",
                            success: function(e) {
                                var i = JSON.parse(e);
                                r.random && (i = i.sort(function() {
                                    return .5 - Math.random()
                                })), (i = i.filter(function(e) {
                                    return 0 == e.tags.filter(function(e) {
                                        return -1 != t.exclude_tags.indexOf(e)
                                    }).length
                                })).length && t.buildBoxHTML(r, i.slice(0, r.limit), function(e) {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(e), 1 == parseInt(r.template.id) && setTimeout(function() {
                                        t.initOwlCarousel("#" + r.id)
                                    }, 0)
                                })
                            }
                        });
                        else if ("trending" == r.conditions.type) {
                            if (t.trendingProducts && Array.isArray(t.trendingProducts) && t.trendingProducts.length > 0) {
                                var a = t.trendingProducts.map(function(t) {
                                    return 'id:"' + t + '"'
                                }).join(" OR ");
                                jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                    url: window.location.origin + t.urls.search,
                                    method: "POST",
                                    dataType: "json",
                                    data: {
                                        q: a + e + i,
                                        view: t.view_name,
                                        type: "product",
                                        options: {
                                            unavailable_products: t.settings.sold_out ? "show" : "hide"
                                        }
                                    },
                                    success: function(e) {
                                        e.length && (r.random && (e = e.sort(function() {
                                            return .5 - Math.random()
                                        })), t.buildBoxHTML(r, e.slice(0, r.limit), function(e) {
                                            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(e), 1 == parseInt(r.template.id) && setTimeout(function() {
                                                t.initOwlCarousel("#" + r.id)
                                            }, 0)
                                        }))
                                    }
                                })
                            }
                        } else if ("collection" == r.conditions.type && r.conditions.condition) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: window.location.origin + t.urls.collection + "/" + r.conditions.condition.handle + "?view=" + t.view_name,
                            method: "GET",
                            dataType: "html",
                            success: function(e) {
                                var i = JSON.parse(e);
                                r.random && (i = i.sort(function() {
                                    return .5 - Math.random()
                                })), (i = i.filter(function(e) {
                                    return 0 == e.tags.filter(function(e) {
                                        return -1 != t.exclude_tags.indexOf(e)
                                    }).length
                                })).length && t.buildBoxHTML(r, i.slice(0, r.limit), function(e) {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(e), 1 == parseInt(r.template.id) && setTimeout(function() {
                                        t.initOwlCarousel("#" + r.id)
                                    }, 0)
                                })
                            }
                        });
                        else if ("vendor" == r.conditions.type && r.conditions.condition) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: window.location.origin + t.urls.search,
                            method: "POST",
                            dataType: "json",
                            data: {
                                q: 'vendor:"' + r.conditions.condition + '"' + e + i,
                                view: t.view_name,
                                type: "product",
                                options: {
                                    unavailable_products: t.settings.sold_out ? "show" : "hide"
                                }
                            },
                            success: function(e) {
                                if (e.length) {
                                    r.random && (e = e.sort(function() {
                                        return .5 - Math.random()
                                    }));
                                    var i = t.buildBoxHTML(r, e.slice(0, r.limit), function() {
                                        jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(i), 1 == parseInt(r.template.id) && setTimeout(function() {
                                            t.initOwlCarousel("#" + r.id)
                                        }, 0)
                                    })
                                }
                            }
                        });
                        else if ("type" == r.conditions.type && r.conditions.condition) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: window.location.origin + t.urls.search,
                            method: "POST",
                            dataType: "json",
                            data: {
                                q: 'product_type:"' + r.conditions.condition + '"' + e + i,
                                view: t.view_name,
                                type: "product",
                                options: {
                                    unavailable_products: t.settings.sold_out ? "show" : "hide"
                                }
                            },
                            success: function(e) {
                                e.length && (r.random && (e = e.sort(function() {
                                    return .5 - Math.random()
                                })), t.buildBoxHTML(r, e.slice(0, r.limit), function() {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(boxHTML), 1 == parseInt(r.template.id) && setTimeout(function() {
                                        t.initOwlCarousel("#" + r.id)
                                    }, 0)
                                }))
                            }
                        });
                        else if ("tag" == r.conditions.type && r.conditions.condition) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: window.location.origin + t.urls.search,
                            method: "POST",
                            dataType: "json",
                            data: {
                                q: 'tag:"' + r.conditions.condition + '"' + e + i,
                                view: t.view_name,
                                type: "product",
                                options: {
                                    unavailable_products: t.settings.sold_out ? "show" : "hide"
                                }
                            },
                            success: function(e) {
                                e.length && (r.random && (e = e.sort(function() {
                                    return .5 - Math.random()
                                })), t.buildBoxHTML(r, e.slice(0, r.limit), function(e) {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(e), 1 == parseInt(r.template.id) && setTimeout(function() {
                                        t.initOwlCarousel("#" + r.id)
                                    }, 0)
                                }))
                            }
                        });
                        else if ("recently" == r.conditions.type && t.recentlyViewedProducts.length) {
                            var l = t.recentlyViewedProducts;
                            "product" == t.page && t.product && (l = l.filter(function(e, i) {
                                return e.handle != t.product.handle
                            })), l = l.slice(0, r.limit), t.buildBoxHTML(r, l, function(e) {
                                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo_widget_" + r.idNumber).html(e), 1 == parseInt(r.template.id) && setTimeout(function() {
                                    t.initOwlCarousel("#" + r.id)
                                }, 0)
                            })
                        }
                    })
                }, globoPersonalizedRecommendations.prototype.buildBoxHTML = function(t, e, i) {
                    return GLiquid.parseAndRender(jquery__WEBPACK_IMPORTED_MODULE_0___default()("#globoRelatedProductsTemplate").html(), {
                        box: t,
                        products: e,
                        translation: this.translation,
                        settings: this.settings,
                        cur_product_id: this.product ? this.product.id : null,
                        no_image_url: this.no_image_url
                    }).then(i)
                }, globoPersonalizedRecommendations.prototype.getParameterByName = function(t, e) {
                    e = e || window.location.href, t = t.replace(/[\[\]]/g, "\\$&");
                    var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
                    return i ? i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "" : null
                }, globoPersonalizedRecommendations.prototype.addCartCallback = function(t, e) {
                    console.log(this.settings.redirect, e), this.settings.redirect ? window.location.replace(e ? window.location.origin + "/discount/" + e + "?redirect=/cart" : window.location.origin + "/cart") : e ? jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                        url: "/discount/" + e,
                        complete: function() {
                            jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                url: "/cart.js",
                                type: "get",
                                dataType: "json",
                                success: function(e) {
                                    window.dispatchEvent(new CustomEvent("globoRelatedProductsUpdateCart", {
                                        detail: {
                                            cart: e,
                                            ids: t
                                        }
                                    }))
                                }
                            })
                        }
                    }) : jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                        url: "/cart.js",
                        type: "get",
                        dataType: "json",
                        success: function(e) {
                            window.dispatchEvent(new CustomEvent("globoRelatedProductsUpdateCart", {
                                detail: {
                                    cart: e,
                                    ids: t
                                }
                            }))
                        }
                    })
                }, globoPersonalizedRecommendations.prototype.createDiscountCode = function(t) {
                    var e = this,
                        i = cookies.get("discountCode"),
                        n = Math.round((new Date).getTime() / 1e3),
                        r = e.discounted_ids.reduce(function(t, e) {
                            return Number(t) + Number(e)
                        }, 0);
                    r = Number(r) + Number(n);
                    var s = {
                        ids: e.discounted_ids,
                        shop: e.shop,
                        signature: r,
                        timestamp: n
                    };
                    i && (s.code = i), jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                        url: e.apiUrl + "/createDiscountCode",
                        method: "GET",
                        dataType: "jsonp",
                        data: s,
                        success: function(n) {
                            n.success ? (i && n.code == i || cookies.set("discountCode", n.code, {
                                path: "/",
                                expires: cookieExpires
                            }), e.addCartCallback(t, n.code)) : e.addCartCallback(t, !1)
                        }
                    })
                }, globoPersonalizedRecommendations.prototype.globoOwlCarouselFix = function() {
                    var t = this,
                        e = window.pageYOffset,
                        i = e + jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).innerHeight();
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ga-carousel").each(function() {
                        var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
                        if (t.settings.carousel_autoplay) {
                            var r = n.offset().top,
                                s = n.offset().top + n.outerHeight();
                            i > r && e < s ? n.trigger("play.gowl.autoplay") : n.trigger("stop.gowl.autoplay")
                        }
                        var o = 0,
                            a = 0;
                        n.find(".ga-product_title, .ga-product_price-container").css({
                            height: "auto",
                            "min-height": "0"
                        }), n.find(".ga-product_title").each(function() {
                            o = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() > o ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() : o
                        }), n.find(".ga-product_title").css("min-height", o + "px"), n.find(".ga-product_price-container").each(function() {
                            a = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() > a ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).height() : a
                        }), n.find(".ga-product_price-container").css("min-height", a + "px"), n.find(".ga-product_variant_select:not(.ga-hide)").length > 0 && n.find(".ga-product_variant_select.ga-hide").addClass("ga-hidden")
                    })
                }, globoPersonalizedRecommendations.prototype.calcBoxTotal = function(t) {
                    t.find(".selectedItem").each(function() {
                        var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
                        e.is(":checked") ? (e.closest("li").removeClass("ga-deactive").find(".ga-product_variant_select").prop("disabled", !1), t.find("#ga-product_" + e.val()).removeClass("ga-deactive")) : (e.closest("li").addClass("ga-deactive").find(".ga-product_variant_select").prop("disabled", !0), t.find("#ga-product_" + e.val()).addClass("ga-deactive"))
                    }), 0 == t.find(".selectedItem:checked").length ? t.find(".ga-product-form").addClass("ga-hide") : t.find(".ga-product-form").removeClass("ga-hide");
                    var e = 0;
                    t.find(".ga-product_variant_select:enabled").each(function() {
                        e += jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is("input") ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data("price") : parseFloat(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find("option:selected").data("price"))
                    });
                    var i = GLiquid.parseAndRenderSync("{{ total_price | money }}", {
                        total_price: e
                    });
                    t.find(".ga-product_totalprice").html(i)
                }, globoPersonalizedRecommendations.prototype.initOwlCarousel = function(t) {
                    var e = this;
                    if (0 == t) jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ga-carousel").each(function() {
                        var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                            i = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data("products-count") || 10;
                        t.globoOwlCarousel({
                            items: e.settings.carousel_items,
                            responsive: {
                                0: {
                                    items: Math.min(e.settings.carousel_items || 6, 1),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 1)
                                },
                                350: {
                                    items: Math.min(e.settings.carousel_items || 6, 2),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 2)
                                },
                                600: {
                                    items: Math.min(e.settings.carousel_items || 6, 3),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 3)
                                },
                                768: {
                                    items: Math.min(e.settings.carousel_items || 6, 4),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 4)
                                },
                                992: {
                                    items: Math.min(e.settings.carousel_items || 6, 5),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 5)
                                },
                                1200: {
                                    items: Math.min(e.settings.carousel_items || 6, 6),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 6)
                                }
                            },
                            responsiveBaseElement: t.closest(".ga-products-box"),
                            nav: !0,
                            dots: !1,
                            loop: e.settings.carousel_loop,
                            autoplay: e.settings.carousel_autoplay,
                            navText: ['<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16" fill-rule="evenodd"></path></svg>', '<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16" fill-rule="evenodd"></path></svg>'],
                            autoplayTimeout: 3e3,
                            autoplaySpeed: 1e3,
                            autoplayHoverPause: !0,
                            onInitialized: e.globoOwlCarouselFix(),
                            onResized: e.globoOwlCarouselFix()
                        })
                    });
                    else {
                        var i = jquery__WEBPACK_IMPORTED_MODULE_0___default()(t + " .ga-carousel").data("products-count") || 10;
                        jquery__WEBPACK_IMPORTED_MODULE_0___default()(t + " .ga-carousel").globoOwlCarousel({
                            items: e.settings.carousel_items,
                            responsive: {
                                0: {
                                    items: Math.min(e.settings.carousel_items || 6, 1),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 1)
                                },
                                350: {
                                    items: Math.min(e.settings.carousel_items || 6, 2),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 2)
                                },
                                600: {
                                    items: Math.min(e.settings.carousel_items || 6, 3),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 3)
                                },
                                768: {
                                    items: Math.min(e.settings.carousel_items || 6, 4),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 4)
                                },
                                992: {
                                    items: Math.min(e.settings.carousel_items || 6, 5),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 5)
                                },
                                1200: {
                                    items: Math.min(e.settings.carousel_items || 6, 6),
                                    loop: e.settings.carousel_loop && i > Math.min(e.settings.carousel_items || 6, 6)
                                }
                            },
                            responsiveBaseElement: jquery__WEBPACK_IMPORTED_MODULE_0___default()(t).closest(".ga-products-box"),
                            nav: !0,
                            dots: !1,
                            loop: e.settings.carousel_loop,
                            autoplay: e.settings.carousel_autoplay,
                            navText: ['<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16" fill-rule="evenodd"></path></svg>', '<svg class="Polaris-Icon__Svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16" fill-rule="evenodd"></path></svg>'],
                            autoplayTimeout: 3e3,
                            autoplaySpeed: 1e3,
                            autoplayHoverPause: !0,
                            onInitialized: e.globoOwlCarouselFix(),
                            onResized: e.globoOwlCarouselFix()
                        })
                    }
                }, globoPersonalizedRecommendations.prototype.initEvents = function() {
                    var app = this;
                    setTimeout(function() {
                        app.initOwlCarousel(!1)
                    }, 0), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", ".selectedItem", function(t) {
                        var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(t.target).closest(".ga-products-box");
                        app.calcBoxTotal(e)
                    }), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", ".ga-product_variant_select", function(t) {
                        var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(t.target),
                            i = parseFloat(e.find("option:selected").attr("data-price")),
                            n = parseFloat(e.find("option:selected").attr("data-compare_at_price")),
                            r = e.closest(".ga-products-box"),
                            s = e.closest("li"),
                            o = s.data("product-id"),
                            a = e.find("option:selected").data("image");
                        if (r.find("img.ga-product_image_" + o).attr("src", a), r.find("div.ga-product_image_" + o).css("background-image", "url(" + a + ")"), s.find(".ga-product_price").html(GLiquid.parseAndRenderSync("{{ price | money }}", {
                                price: i
                            })), n > 0 && n > i) {
                            var l = GLiquid.parseAndRenderSync("{{ compare_at_price | money }}", {
                                compare_at_price: n
                            });
                            s.find(".ga-product_oldprice").length > 0 ? s.find(".ga-product_oldprice").html(l) : s.find(".ga-product_price-container").append('<s class="ga-product_oldprice">' + l + "</s>")
                        } else s.find(".ga-product_oldprice").remove();
                        var u = 0;
                        r.find(".ga-product_variant_select:enabled").each(function() {
                            u += jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is("input") ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data("price") : parseFloat(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find("option:selected").data("price"))
                        });
                        l = GLiquid.parseAndRenderSync("{{ total_price | money }}", {
                            total_price: u
                        });
                        r.find(".ga-product_totalprice").html(l)
                    }), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".ga-product", function(t) {
                        app.localSaveStatistical("clicked", 1)
                    }), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".ga-addalltocart", function(event) {
                        var button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target),
                            ids = [],
                            items = [],
                            wiggetTitle = button.closest(".ga-products-box").find(".ga-title").text() || "Untitled",
                            wiggetId = button.closest(".ga-products-box").attr("id");
                        "ga-product_bought_together" == wiggetId ? wiggetTitle = "Frequently Bought Together" : "ga-product_related" == wiggetId ? wiggetTitle = "Related products" : "ga-cart" == wiggetId && (wiggetTitle = "Cart Upsell & Cross Sell"), button.closest(".ga-products-box").find(".ga-product_variant_select:enabled").each(function() {
                            var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val().toString();
                            ids.push(t), items.push({
                                id: t,
                                properties: _defineProperty({}, app.cart_properties_name, wiggetTitle)
                            })
                        }), app.localSaveStatistical("added", ids.length), jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: "/cart/add.js",
                            type: "post",
                            dataType: "json",
                            data: {
                                items: items
                            },
                            beforeSend: function(t, e) {
                                button.prop("disabled", !0)
                            },
                            success: function(t) {
                                t.items.forEach(function(t) {
                                    -1 == app.discounted_ids.indexOf(t.product_id.toString()) && (app.discounted_ids.push(t.product_id.toString()), app.discount_min_amount += parseFloat(t.final_line_price))
                                }), button.text(button.data("added")), setTimeout(function() {
                                    button.text(button.data("add")).prop("disabled", !1)
                                }, 3e3), app.settings.discount.enable ? app.createDiscountCode(ids) : app.addCartCallback(ids, !1), window.dispatchEvent(new Event("globoRelatedProductsAddedProductsToCart"))
                            },
                            error: function error(XMLHttpRequest, textStatus) {
                                var data = eval("(" + XMLHttpRequest.responseText + ")");
                                data.message && (alert(data.message + ": " + data.description), button.prop("disabled", !1))
                            },
                            complete: function() {
                                button.prop("disabled", !1)
                            }
                        })
                    }), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".ga-product_addtocart", function(event) {
                        var button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target),
                            wiggetTitle = button.closest(".ga-products-box").find(".ga-title").text() || "Untitled",
                            wiggetId = button.closest(".ga-products-box").attr("id");
                        "ga-product_bought_together" == wiggetId ? wiggetTitle = "Frequently Bought Together" : "ga-product_related" == wiggetId ? wiggetTitle = "Related products" : "ga-cart" == wiggetId && (wiggetTitle = "Cart Upsell & Cross Sell");
                        var id = button.closest(".ga-product").find(".ga-product_variant_select").val();
                        app.localSaveStatistical("added", 1), jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: "/cart/add.js",
                            type: "post",
                            dataType: "json",
                            data: {
                                items: [{
                                    id: id,
                                    properties: _defineProperty({}, app.cart_properties_name, wiggetTitle)
                                }]
                            },
                            beforeSend: function(t, e) {
                                button.prop("disabled", !0)
                            },
                            success: function(t) {
                                -1 == app.discounted_ids.indexOf(t.items[0].product_id.toString()) && (app.discounted_ids.push(t.items[0].product_id.toString()), app.discount_min_amount += parseFloat(t.items[0].final_line_price)), button.text(button.data("added")), setTimeout(function() {
                                    button.text(button.data("add")).prop("disabled", !1)
                                }, 3e3), app.settings.discount.enable ? app.createDiscountCode([id]) : app.addCartCallback([id], !1), window.dispatchEvent(new Event("globoRelatedProductsAddedProductsToCart"))
                            },
                            error: function error(XMLHttpRequest, textStatus) {
                                var data = eval("(" + XMLHttpRequest.responseText + ")");
                                data.message && alert(data.message + ": " + data.description), button.prop("disabled", !1)
                            },
                            complete: function() {
                                button.prop("disabled", !1)
                            }
                        })
                    });
                    var variantIdSelector = jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]:visible:first [name="id"], form[action*="/checkout"]:visible:first [name="id"]');
                    "product" == app.page && variantIdSelector.length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-product-id="' + app.product.id + '"]').length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ga-products-box [data-product-id="' + app.product.id + '"] .ga-product_variant_select').val(variantIdSelector.val()).change(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", 'form[action*="/cart/add"]:visible:first input, form[action*="/checkout"]:visible:first input, form[action*="/cart/add"]:visible:first select:not(.ga-product_variant_select), form[action*="/checkout"]:visible:first select:not(.ga-product_variant_select)', function() {
                        jquery__WEBPACK_IMPORTED_MODULE_0___default()('.ga-products-box [data-product-id="' + app.product.id + '"] .ga-product_variant_select').val(variantIdSelector.val()).change()
                    })), jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scroll(function() {
                        app.globoOwlCarouselFix(!0, !1)
                    })
                }, globoPersonalizedRecommendations.prototype.getBoxProducts = function(t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        i = this,
                        n = [],
                        r = [],
                        s = t.conditions;
                    return jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(s, function(s, o) {
                        if (o.status)
                            if ("manual" == o.id) jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(i.data.ids, function(s, a) {
                                i.manualRecommendations[a] && jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(i.manualRecommendations[a], function(s, a) {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(i.relatedProducts[o.id], function(i, s) {
                                        if (!t.random && r.length >= t.limit || t.random && r.length >= 4 * t.limit) return !1;
                                        a.toString() == s.id.toString() && -1 == r.indexOf(s.id.toString()) && -1 == e.ids.indexOf(s.id.toString()) && (r.push(s.id.toString()), n.push(s))
                                    })
                                })
                            });
                            else {
                                var a = []; - 1 != ["bought_together", "global", "random"].indexOf(o.id) && i.relatedProducts[o.id] ? a = i.relatedProducts[o.id] : "product_bought_together" == t.type && i.productBoughtTogether.relatedProducts[o.id] ? a = i.productBoughtTogether.relatedProducts[o.id] : "product_related" == t.type && i.productRelated.relatedProducts[o.id] ? a = i.productRelated.relatedProducts[o.id] : "cart" == t.type && i.cart.relatedProducts[o.id] && (a = i.cart.relatedProducts[o.id]), a.length && jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(a, function(i, s) {
                                    if (!t.random && r.length >= t.limit || t.random && r.length >= 4 * t.limit) return !1; - 1 == r.indexOf(s.id.toString()) && -1 == e.ids.indexOf(s.id.toString()) && (r.push(s.id.toString()), n.push(s))
                                })
                            }
                    }), n = n.filter(function(t) {
                        return 0 == t.tags.filter(function(t) {
                            return -1 != i.exclude_tags.indexOf(t)
                        }).length
                    }), n = t.random ? i.shuffle(n).slice(0, t.limit) : n.slice(0, t.limit)
                }, globoPersonalizedRecommendations.prototype.getDeferredStuff = function(t, e) {
                    var i = this,
                        n = [],
                        r = i.exclude_tags.length ? i.exclude_tags.map(function(t) {
                            return ' AND -tag:"' + t + '"'
                        }).join("") : "",
                        s = i.exclude_types.length ? i.exclude_types.map(function(t) {
                            return ' AND -product_type:"' + t + '"'
                        }).join("") : "",
                        o = t.conditions.filter(function(t) {
                            return t.status
                        });
                    return jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(o, function(o, a) {
                        if ("bought_together" == a.id) {
                            var l = [],
                                u = [];
                            if ("cart" == i.page ? Object.keys(i.boughtTogetherIds).forEach(function(t) {
                                    !1 !== i.boughtTogetherIds[t] ? l = l.concat(i.boughtTogetherIds[t]) : u.push(t)
                                }) : "product" == i.page && (!1 !== i.boughtTogetherIds[i.product.id] ? l = l.concat(i.boughtTogetherIds[i.product.id]) : u.push(i.product.id)), l.length) {
                                l = l.map(function(t) {
                                    return 'id:"' + t + '"'
                                });
                                n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                    url: window.location.origin + i.urls.search,
                                    method: "POST",
                                    dataType: "json",
                                    data: {
                                        q: l.join(" OR ") + r + s,
                                        view: i.view_name,
                                        type: "product",
                                        options: {
                                            unavailable_products: i.settings.sold_out ? "show" : "hide"
                                        }
                                    },
                                    success: function(t) {
                                        i.relatedProducts.hasOwnProperty(a.id) ? i.relatedProducts[a.id] = i.relatedProducts[a.id].concat(t) : i.relatedProducts[a.id] = t
                                    }
                                }))
                            }
                            u.length && n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                url: i.apiUrl + "/getBoughtTogetherProducts",
                                method: "GET",
                                dataType: "json",
                                data: {
                                    shop: i.shop,
                                    product_ids: u,
                                    view: i.view_name,
                                    limit: 4 * i.limit
                                },
                                success: function(t) {
                                    i.relatedProducts.hasOwnProperty(a.id) ? i.relatedProducts[a.id] = i.relatedProducts[a.id].concat(t.data) : i.relatedProducts[a.id] = t.data
                                }
                            }))
                        } else if ("manual" == a.id && e.ids.length) {
                            var c = [];
                            if (jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(e.ids, function(t, e) {
                                    var n = i.manualRecommendations[e] || [];
                                    c = c.concat(n)
                                }), c.length) {
                                c = c.map(function(t) {
                                    return 'id:"' + t + '"'
                                });

								c = c.slice(0, i.limit);

                                n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                    url: window.location.origin + i.urls.search,
                                    method: "POST",
                                    dataType: "json",
                                    data: {
                                        q: c.join(" OR ") + r + s,
                                        view: i.view_name,
                                        type: "product",
                                        options: {
                                            unavailable_products: i.settings.sold_out ? "show" : "hide"
                                        }
                                    },
                                    success: function(t) {
                                        i.relatedProducts[a.id] = t
                                    }
                                }))
                            }
                        } else if ("vendor" == a.id && e.vendors.length) {
                            var d = [];
                            if ("same" == a.type) d = e.vendors;
                            else if ("related" == a.type && a.rules && a.rules.length) {
                                for (var h = 0; h < a.rules.length; h++)
                                    if (-1 != e.vendors.indexOf(a.rules[h].vendor) && a.rules[h].related.length) {
                                        d = a.rules[h].related;
                                        break
                                    }
                            } else "manual" == a.type && void 0 !== i.manualVendors && jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(e.vendors, function(t, e) {
                                var n = i.manualVendors[e] || [];
                                n && (d = d.concat(n))
                            });
                            d.length && n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                url: window.location.origin + i.urls.search,
                                method: "POST",
                                dataType: "json",
                                data: {
                                    q: d.map(function(t) {
                                        return 'vendor:"' + t + '"'
                                    }).join(" OR ") + r + s,
                                    view: i.view_name,
                                    type: "product",
                                    options: {
                                        unavailable_products: i.settings.sold_out ? "show" : "hide"
                                    }
                                },
                                success: function(e) {
                                    "product_bought_together" == t.type ? i.productBoughtTogether.relatedProducts[a.id] = e : "product_related" == t.type ? i.productRelated.relatedProducts[a.id] = e : "cart" == t.type && (i.cart.relatedProducts[a.id] = e)
                                }
                            }))
                        } else if ("type" == a.id && e.types.length) {
                            var p = [];
                            if ("same" == a.type) p = e.types;
                            else "related" == a.type && a.rules && a.rules.length ? a.rules.map(function(t) {
                                -1 != e.types.indexOf(t.type) && t.related.length && (p = p.concat(t.related))
                            }) : "manual" == a.type && void 0 !== i.manualProductTypes && jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(e.types, function(t, e) {
                                var n = i.manualProductTypes[e] || [];
                                n && (p = p.concat(n))
                            });
                            p.length && n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                url: window.location.origin + i.urls.search,
                                method: "POST",
                                dataType: "json",
                                data: {
                                    q: p.map(function(t) {
                                        return 'product_type:"' + t + '"'
                                    }).join(" OR ") + r + s,
                                    view: i.view_name,
                                    type: "product",
                                    options: {
                                        unavailable_products: i.settings.sold_out ? "show" : "hide"
                                    }
                                },
                                success: function(e) {
                                    "product_bought_together" == t.type ? i.productBoughtTogether.relatedProducts[a.id] = e : "product_related" == t.type ? i.productRelated.relatedProducts[a.id] = e : "cart" == t.type && (i.cart.relatedProducts[a.id] = e)
                                }
                            }))
                        } else if ("collection" == a.id && e.collections.length) {
                            var f = e.collections,
                                g = "";
                            if ("same" == a.type) {
                                if (i.collection) g = i.collection;
                                else if (a.rules && a.rules.length) {
                                    a.rules.reverse();
                                    for (h = 0; h < a.rules.length; h++)
                                        if (-1 != f.indexOf(a.rules[h].handle)) {
                                            g = a.rules[h].handle;
                                            break
                                        }
                                }
                                "" == g && (g = f[0])
                            } else if ("related" == a.type && a.rules && a.rules.length) {
                                if (i.collection)
                                    for (h = 0; h < a.rules.length; h++) a.rules[h].collection && a.rules[h].collection.handle == i.collection && (g = a.rules[h].related.handle);
                                if ("" == g)
                                    for (h = 0; h < a.rules.length; h++)
                                        if (-1 != f.indexOf(a.rules[h].collection.handle)) {
                                            g = a.rules[h].related.handle;
                                            break
                                        }
                            } else if ("manual" == a.type && void 0 !== i.manualCollections) {
                                if (i.collection && "globo_basis_collection" != i.collection) {
                                    var m = i.manualCollections[i.collection] || [];
                                    if (m)
                                        for (h = 0; h < m.length; h++) {
                                            g = m[h];
                                            break
                                        }
                                }
                                "" == g && jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(e.collections, function(t, e) {
                                    if ("globo_basis_collection" != e) {
                                        var n = i.manualCollections[e] || [];
                                        if (n)
                                            for (var r = 0; r < n.length; r++) {
                                                g = n[r];
                                                break
                                            }
                                        if ("" != g) return !1
                                    }
                                })
                            }
                            "" != g && n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                url: window.location.origin + i.urls.collection + "/" + g + "?view=" + i.view_name,
                                method: "GET",
                                dataType: "html",
                                success: function(e) {
                                    "product_bought_together" == t.type ? i.productBoughtTogether.relatedProducts[a.id] = JSON.parse(e) : "product_related" == t.type ? i.productRelated.relatedProducts[a.id] = JSON.parse(e) : "cart" == t.type && (i.cart.relatedProducts[a.id] = JSON.parse(e))
                                }
                            }))
                        } else if ("tags" == a.id) {
                            if (e.tags.length) {
                                var _ = [];
                                if ("same" == a.type) {
                                    if (a.rules && a.rules.length) {
                                        a.rules.reverse();
                                        for (h = 0; h < a.rules.length; h++)
                                            if (-1 != e.tags.indexOf(a.rules[h])) {
                                                _ = [a.rules[h]];
                                                break
                                            }
                                    }
                                    0 == _.length && (_ = e.tags)
                                } else if ("related" == a.type && a.rules && a.rules.length) {
                                    for (h = 0; h < a.rules.length; h++)
                                        if (-1 != e.tags.indexOf(a.rules[h].tag)) {
                                            _ = _.concat(a.rules[h].related);
                                            break
                                        }
                                } else "manual" == a.type && void 0 !== i.manualTags && jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(e.tags, function(t, e) {
                                    var n = i.manualTags[e] || [];
                                    n && (_ = _.concat(n))
                                });
                                if (_.length) {
                                    if ((_ = _.map(function(t) {
                                            return 'tag:"' + t + '"'
                                        })).length < 6)(_ = i.combine(_, 1)).reverse(), _ = _.map(function(t) {
                                        return t.length > 1 ? "(" + t.join(" AND ") + ")" : t.join(" AND ")
                                    });
                                    n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                                        url: window.location.origin + i.urls.search,
                                        method: "POST",
                                        dataType: "json",
                                        data: {
                                            q: _.join(" OR ") + r + s,
                                            view: i.view_name,
                                            type: "product",
                                            options: {
                                                unavailable_products: i.settings.sold_out ? "show" : "hide"
                                            }
                                        },
                                        success: function(e) {
                                            "product_bought_together" == t.type ? i.productBoughtTogether.relatedProducts[a.id] = e : "product_related" == t.type ? i.productRelated.relatedProducts[a.id] = e : "cart" == t.type && (i.cart.relatedProducts[a.id] = e)
                                        }
                                    }))
                                }
                            }
                        } else "global" == a.id ? n.push(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: window.location.origin + i.urls.search,
                            method: "POST",
                            dataType: "json",
                            data: {
                                q: 'tag:"Recommendation" OR tag:"recommendation"' + r + s,
                                view: i.view_name,
                                type: "product",
                                options: {
                                    unavailable_products: i.settings.sold_out ? "show" : "hide"
                                }
                            },
                            success: function(t) {
                                i.relatedProducts[a.id] = t
                            }
                        })) : "random" == a.id && n.push(gPR.ajax({
                            url: window.location.origin + "/collections/all?sort_by=created-descending&view=" + i.view_name,
                            method: "GET",
                            dataType: "html",
                            success: function(t) {
                                i.relatedProducts[a.id] = i.shuffle(JSON.parse(t))
                            }
                        }))
                    }), n
                }, globoPersonalizedRecommendations.prototype.combine = function(t, e) {
                    for (var i = function t(e, i, n, r) {
                            if (0 != e)
                                for (var s = 0; s < i.length; s++) t(e - 1, i.slice(s + 1), n.concat([i[s]]), r);
                            else n.length > 0 && (r[r.length] = n)
                        }, n = [], r = e; r < t.length; r++) i(r, t, [], n);
                    return n.push(t), n
                }, globoPersonalizedRecommendations.prototype.shuffle = function(t) {
                    var e, i, n;
                    for (n = t.length - 1; n > 0; n--) e = Math.floor(Math.random() * (n + 1)), i = t[n], t[n] = t[e], t[e] = i;
                    return t
                }, window.globoRelatedProducts = new globoPersonalizedRecommendations(window.globoRelatedProductsConfig), setTimeout(function() {
                    globoRelatedProducts.init()
                }, 0)
            }.call(this, __webpack_require__(7))
    },
    729: function(t, e, i) {
        (function(t, e) {
            function i(t) {
                return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }
            var n, r;
            ! function(t, n, r, s) {
                function o(e, i) {
                    this.settings = null, this.options = t.extend({}, o.Defaults, i), this.$element = t(e), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
                        time: null,
                        target: null,
                        pointer: null,
                        stage: {
                            start: null,
                            current: null
                        },
                        direction: null
                    }, this._states = {
                        current: {},
                        tags: {
                            initializing: ["busy"],
                            animating: ["busy"],
                            dragging: ["interacting"]
                        }
                    }, t.each(["onResize", "onThrottledResize"], t.proxy(function(e, i) {
                        this._handlers[i] = t.proxy(this[i], this)
                    }, this)), t.each(o.Plugins, t.proxy(function(t, e) {
                        this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
                    }, this)), t.each(o.Workers, t.proxy(function(e, i) {
                        this._pipe.push({
                            filter: i.filter,
                            run: t.proxy(i.run, this)
                        })
                    }, this)), this.setup(), this.initialize()
                }
                o.Defaults = {
                    items: 3,
                    loop: !1,
                    center: !1,
                    rewind: !1,
                    checkVisibility: !0,
                    mouseDrag: !0,
                    touchDrag: !0,
                    pullDrag: !0,
                    freeDrag: !1,
                    margin: 0,
                    stagePadding: 0,
                    merge: !1,
                    mergeFit: !0,
                    autoWidth: !1,
                    startPosition: 0,
                    rtl: !1,
                    smartSpeed: 250,
                    fluidSpeed: !1,
                    dragEndSpeed: !1,
                    responsive: {},
                    responsiveRefreshRate: 200,
                    responsiveBaseElement: n,
                    fallbackEasing: "swing",
                    slideTransition: "",
                    info: !1,
                    nestedItemSelector: !1,
                    itemElement: "div",
                    stageElement: "div",
                    refreshClass: "gowl-refresh",
                    loadedClass: "gowl-loaded",
                    loadingClass: "gowl-loading",
                    rtlClass: "gowl-rtl",
                    responsiveClass: "gowl-responsive",
                    dragClass: "gowl-drag",
                    itemClass: "gowl-item",
                    stageClass: "gowl-stage",
                    stageOuterClass: "gowl-stage-outer",
                    grabClass: "gowl-grab"
                }, o.Width = {
                    Default: "default",
                    Inner: "inner",
                    Outer: "outer"
                }, o.Type = {
                    Event: "event",
                    State: "state"
                }, o.Plugins = {}, o.Workers = [{
                    filter: ["width", "settings"],
                    run: function() {
                        this._width = this.$element.width()
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function(t) {
                        t.current = this._items && this._items[this.relative(this._current)]
                    }
                }, {
                    filter: ["items", "settings"],
                    run: function() {
                        this.$stage.children(".cloned").remove()
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function(t) {
                        var e = this.settings.margin || "",
                            i = !this.settings.autoWidth,
                            n = this.settings.rtl,
                            r = {
                                width: "auto",
                                "margin-left": n ? e : "",
                                "margin-right": n ? "" : e
                            };
                        !i && this.$stage.children().css(r), t.css = r
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function(t) {
                        var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                            i = null,
                            n = this._items.length,
                            r = !this.settings.autoWidth,
                            s = [];
                        for (t.items = {
                                merge: !1,
                                width: e
                            }; n--;) i = this._mergers[n], i = this.settings.mergeFit && Math.min(i, this.settings.items) || i, t.items.merge = i > 1 || t.items.merge, s[n] = r ? e * i : this._items[n].width();
                        this._widths = s
                    }
                }, {
                    filter: ["items", "settings"],
                    run: function() {
                        var e = [],
                            i = this._items,
                            n = this.settings,
                            r = Math.max(2 * n.items, 4),
                            s = 2 * Math.ceil(i.length / 2),
                            o = n.loop && i.length ? n.rewind ? r : Math.max(r, s) : 0,
                            a = "",
                            l = "";
                        for (o /= 2; o > 0;) e.push(this.normalize(e.length / 2, !0)), a += i[e[e.length - 1]][0].outerHTML, e.push(this.normalize(i.length - 1 - (e.length - 1) / 2, !0)), l = i[e[e.length - 1]][0].outerHTML + l, o -= 1;
                        this._clones = e, t(a).addClass("cloned").appendTo(this.$stage), t(l).addClass("cloned").prependTo(this.$stage)
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function() {
                        for (var t = this.settings.rtl ? 1 : -1, e = this._clones.length + this._items.length, i = -1, n = 0, r = 0, s = []; ++i < e;) n = s[i - 1] || 0, r = this._widths[this.relative(i)] + this.settings.margin, s.push(n + r * t);
                        this._coordinates = s
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function() {
                        var t = this.settings.stagePadding,
                            e = this._coordinates,
                            i = {
                                width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                                "padding-left": t || "",
                                "padding-right": t || ""
                            };
                        this.$stage.css(i)
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function(t) {
                        var e = this._coordinates.length,
                            i = !this.settings.autoWidth,
                            n = this.$stage.children();
                        if (i && t.items.merge)
                            for (; e--;) t.css.width = this._widths[this.relative(e)], n.eq(e).css(t.css);
                        else i && (t.css.width = t.items.width, n.css(t.css))
                    }
                }, {
                    filter: ["items"],
                    run: function() {
                        this._coordinates.length < 1 && this.$stage.removeAttr("style")
                    }
                }, {
                    filter: ["width", "items", "settings"],
                    run: function(t) {
                        t.current = t.current ? this.$stage.children().index(t.current) : 0, t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)), this.reset(t.current)
                    }
                }, {
                    filter: ["position"],
                    run: function() {
                        this.animate(this.coordinates(this._current))
                    }
                }, {
                    filter: ["width", "position", "items", "settings"],
                    run: function() {
                        var t, e, i, n, r = this.settings.rtl ? 1 : -1,
                            s = 2 * this.settings.stagePadding,
                            o = this.coordinates(this.current()) + s,
                            a = o + this.width() * r,
                            l = [];
                        for (i = 0, n = this._coordinates.length; i < n; i++) t = this._coordinates[i - 1] || 0, e = Math.abs(this._coordinates[i]) + s * r, (this.op(t, "<=", o) && this.op(t, ">", a) || this.op(e, "<", o) && this.op(e, ">", a)) && l.push(i);
                        this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
                    }
                }], o.prototype.initializeStage = function() {
                    this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = t("<" + this.settings.stageElement + ">", {
                        class: this.settings.stageClass
                    }).wrap(t("<div/>", {
                        class: this.settings.stageOuterClass
                    })), this.$element.append(this.$stage.parent()))
                }, o.prototype.initializeItems = function() {
                    var e = this.$element.find(".gowl-item");
                    if (e.length) return this._items = e.get().map(function(e) {
                        return t(e)
                    }), this._mergers = this._items.map(function() {
                        return 1
                    }), void this.refresh();
                    this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
                }, o.prototype.initialize = function() {
                    var t, e, i;
                    (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) && (t = this.$element.find("img"), e = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : void 0, i = this.$element.children(e).width(), t.length && i <= 0 && this.preloadAutoWidthImages(t));
                    this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
                }, o.prototype.isVisible = function() {
                    return !this.settings.checkVisibility || this.$element.is(":visible")
                }, o.prototype.setup = function() {
                    var e = this.viewport(),
                        i = this.options.responsive,
                        n = -1,
                        r = null;
                    i ? (t.each(i, function(t) {
                        t <= e && t > n && (n = Number(t))
                    }), "function" == typeof(r = t.extend({}, this.options, i[n])).stagePadding && (r.stagePadding = r.stagePadding()), delete r.responsive, r.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + n))) : r = t.extend({}, this.options), this.trigger("change", {
                        property: {
                            name: "settings",
                            value: r
                        }
                    }), this._breakpoint = n, this.settings = r, this.invalidate("settings"), this.trigger("changed", {
                        property: {
                            name: "settings",
                            value: this.settings
                        }
                    })
                }, o.prototype.optionsLogic = function() {
                    this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
                }, o.prototype.prepare = function(e) {
                    var i = this.trigger("prepare", {
                        content: e
                    });
                    return i.data || (i.data = t("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(e)), this.trigger("prepared", {
                        content: i.data
                    }), i.data
                }, o.prototype.update = function() {
                    for (var e = 0, i = this._pipe.length, n = t.proxy(function(t) {
                            return this[t]
                        }, this._invalidated), r = {}; e < i;)(this._invalidated.all || t.grep(this._pipe[e].filter, n).length > 0) && this._pipe[e].run(r), e++;
                    this._invalidated = {}, !this.is("valid") && this.enter("valid")
                }, o.prototype.width = function(t) {
                    switch (t = t || o.Width.Default) {
                        case o.Width.Inner:
                        case o.Width.Outer:
                            return this._width;
                        default:
                            return this._width - 2 * this.settings.stagePadding + this.settings.margin
                    }
                }, o.prototype.refresh = function() {
                    this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
                }, o.prototype.onThrottledResize = function() {
                    n.clearTimeout(this.resizeTimer), this.resizeTimer = n.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
                }, o.prototype.onResize = function() {
                    return !!this._items.length && (this._width !== this.$element.width() && (!!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))))
                }, o.prototype.registerEventHandlers = function() {
                    t.support.transition && this.$stage.on(t.support.transition.end + ".gowl.core", t.proxy(this.onTransitionEnd, this)), !1 !== this.settings.responsive && this.on(n, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.gowl.core", t.proxy(this.onDragStart, this)), this.$stage.on("dragstart.gowl.core selectstart.gowl.core", function() {
                        return !1
                    })), this.settings.touchDrag && (this.$stage.on("touchstart.gowl.core", t.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.gowl.core", t.proxy(this.onDragEnd, this)))
                }, o.prototype.onDragStart = function(e) {
                    var i = null;
                    3 !== e.which && (t.support.transform ? i = {
                        x: (i = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === i.length ? 12 : 4],
                        y: i[16 === i.length ? 13 : 5]
                    } : (i = this.$stage.position(), i = {
                        x: this.settings.rtl ? i.left + this.$stage.width() - this.width() + this.settings.margin : i.left,
                        y: i.top
                    }), this.is("animating") && (t.support.transform ? this.animate(i.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === e.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = t(e.target), this._drag.stage.start = i, this._drag.stage.current = i, this._drag.pointer = this.pointer(e), t(r).on("mouseup.gowl.core touchend.gowl.core", t.proxy(this.onDragEnd, this)), t(r).one("mousemove.gowl.core touchmove.gowl.core", t.proxy(function(e) {
                        var i = this.difference(this._drag.pointer, this.pointer(e));
                        t(r).on("mousemove.gowl.core touchmove.gowl.core", t.proxy(this.onDragMove, this)), Math.abs(i.x) < Math.abs(i.y) && this.is("valid") || (e.preventDefault(), this.enter("dragging"), this.trigger("drag"))
                    }, this)))
                }, o.prototype.onDragMove = function(t) {
                    var e = null,
                        i = null,
                        n = null,
                        r = this.difference(this._drag.pointer, this.pointer(t)),
                        s = this.difference(this._drag.stage.start, r);
                    this.is("dragging") && (t.preventDefault(), this.settings.loop ? (e = this.coordinates(this.minimum()), i = this.coordinates(this.maximum() + 1) - e, s.x = ((s.x - e) % i + i) % i + e) : (e = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), n = this.settings.pullDrag ? -1 * r.x / 5 : 0, s.x = Math.max(Math.min(s.x, e + n), i + n)), this._drag.stage.current = s, this.animate(s.x))
                }, o.prototype.onDragEnd = function(e) {
                    var i = this.difference(this._drag.pointer, this.pointer(e)),
                        n = this._drag.stage.current,
                        s = i.x > 0 ^ this.settings.rtl ? "left" : "right";
                    t(r).off(".gowl.core"), this.$element.removeClass(this.options.grabClass), (0 !== i.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(n.x, 0 !== i.x ? s : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = s, (Math.abs(i.x) > 3 || (new Date).getTime() - this._drag.time > 300) && this._drag.target.one("click.gowl.core", function() {
                        return !1
                    })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
                }, o.prototype.closest = function(e, i) {
                    var n = -1,
                        r = this.width(),
                        s = this.coordinates();
                    return this.settings.freeDrag || t.each(s, t.proxy(function(t, o) {
                        return "left" === i && e > o - 30 && e < o + 30 ? n = t : "right" === i && e > o - r - 30 && e < o - r + 30 ? n = t + 1 : this.op(e, "<", o) && this.op(e, ">", void 0 !== s[t + 1] ? s[t + 1] : o - r) && (n = "left" === i ? t + 1 : t), -1 === n
                    }, this)), this.settings.loop || (this.op(e, ">", s[this.minimum()]) ? n = e = this.minimum() : this.op(e, "<", s[this.maximum()]) && (n = e = this.maximum())), n
                }, o.prototype.animate = function(e) {
                    var i = this.speed() > 0;
                    this.is("animating") && this.onTransitionEnd(), i && (this.enter("animating"), this.trigger("translate")), t.support.transform3d && t.support.transition ? this.$stage.css({
                        transform: "translate3d(" + e + "px,0px,0px)",
                        transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
                    }) : i ? this.$stage.animate({
                        left: e + "px"
                    }, this.speed(), this.settings.fallbackEasing, t.proxy(this.onTransitionEnd, this)) : this.$stage.css({
                        left: e + "px"
                    })
                }, o.prototype.is = function(t) {
                    return this._states.current[t] && this._states.current[t] > 0
                }, o.prototype.current = function(t) {
                    if (void 0 === t) return this._current;
                    if (0 !== this._items.length) {
                        if (t = this.normalize(t), this._current !== t) {
                            var e = this.trigger("change", {
                                property: {
                                    name: "position",
                                    value: t
                                }
                            });
                            void 0 !== e.data && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {
                                property: {
                                    name: "position",
                                    value: this._current
                                }
                            })
                        }
                        return this._current
                    }
                }, o.prototype.invalidate = function(e) {
                    return "string" === t.type(e) && (this._invalidated[e] = !0, this.is("valid") && this.leave("valid")), t.map(this._invalidated, function(t, e) {
                        return e
                    })
                }, o.prototype.reset = function(t) {
                    void 0 !== (t = this.normalize(t)) && (this._speed = 0, this._current = t, this.suppress(["translate", "translated"]), this.animate(this.coordinates(t)), this.release(["translate", "translated"]))
                }, o.prototype.normalize = function(t, e) {
                    var i = this._items.length,
                        n = e ? 0 : this._clones.length;
                    return !this.isNumeric(t) || i < 1 ? t = void 0 : (t < 0 || t >= i + n) && (t = ((t - n / 2) % i + i) % i + n / 2), t
                }, o.prototype.relative = function(t) {
                    return t -= this._clones.length / 2, this.normalize(t, !0)
                }, o.prototype.maximum = function(t) {
                    var e, i, n, r = this.settings,
                        s = this._coordinates.length;
                    if (r.loop) s = this._clones.length / 2 + this._items.length - 1;
                    else if (r.autoWidth || r.merge) {
                        if (e = this._items.length)
                            for (i = this._items[--e].width(), n = this.$element.width(); e-- && !((i += this._items[e].width() + this.settings.margin) > n););
                        s = e + 1
                    } else s = r.center ? this._items.length - 1 : this._items.length - r.items;
                    return t && (s -= this._clones.length / 2), Math.max(s, 0)
                }, o.prototype.minimum = function(t) {
                    return t ? 0 : this._clones.length / 2
                }, o.prototype.items = function(t) {
                    return void 0 === t ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
                }, o.prototype.mergers = function(t) {
                    return void 0 === t ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
                }, o.prototype.clones = function(e) {
                    var i = this._clones.length / 2,
                        n = i + this._items.length,
                        r = function(t) {
                            return t % 2 == 0 ? n + t / 2 : i - (t + 1) / 2
                        };
                    return void 0 === e ? t.map(this._clones, function(t, e) {
                        return r(e)
                    }) : t.map(this._clones, function(t, i) {
                        return t === e ? r(i) : null
                    })
                }, o.prototype.speed = function(t) {
                    return void 0 !== t && (this._speed = t), this._speed
                }, o.prototype.coordinates = function(e) {
                    var i, n = 1,
                        r = e - 1;
                    return void 0 === e ? t.map(this._coordinates, t.proxy(function(t, e) {
                        return this.coordinates(e)
                    }, this)) : (this.settings.center ? (this.settings.rtl && (n = -1, r = e + 1), i = this._coordinates[e], i += (this.width() - i + (this._coordinates[r] || 0)) / 2 * n) : i = this._coordinates[r] || 0, i = Math.ceil(i))
                }, o.prototype.duration = function(t, e, i) {
                    return 0 === i ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(i || this.settings.smartSpeed)
                }, o.prototype.to = function(t, e) {
                    var i = this.current(),
                        n = null,
                        r = t - this.relative(i),
                        s = (r > 0) - (r < 0),
                        o = this._items.length,
                        a = this.minimum(),
                        l = this.maximum();
                    this.settings.loop ? (!this.settings.rewind && Math.abs(r) > o / 2 && (r += -1 * s * o), (n = (((t = i + r) - a) % o + o) % o + a) !== t && n - r <= l && n - r > 0 && (i = n - r, t = n, this.reset(i))) : t = this.settings.rewind ? (t % (l += 1) + l) % l : Math.max(a, Math.min(l, t)), this.speed(this.duration(i, t, e)), this.current(t), this.isVisible() && this.update()
                }, o.prototype.next = function(t) {
                    t = t || !1, this.to(this.relative(this.current()) + 1, t)
                }, o.prototype.prev = function(t) {
                    t = t || !1, this.to(this.relative(this.current()) - 1, t)
                }, o.prototype.onTransitionEnd = function(t) {
                    if (void 0 !== t && (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0))) return !1;
                    this.leave("animating"), this.trigger("translated")
                }, o.prototype.viewport = function() {
                    var e;
                    return this.options.responsiveBaseElement !== n ? e = t(this.options.responsiveBaseElement).width() : n.innerWidth ? e = n.innerWidth : r.documentElement && r.documentElement.clientWidth ? e = r.documentElement.clientWidth : console.warn("Can not detect viewport width."), e
                }, o.prototype.replace = function(i) {
                    this.$stage.empty(), this._items = [], i && (i = i instanceof e ? i : t(i)), this.settings.nestedItemSelector && (i = i.find("." + this.settings.nestedItemSelector)), i.filter(function() {
                        return 1 === this.nodeType
                    }).each(t.proxy(function(t, e) {
                        e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
                    }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
                }, o.prototype.add = function(i, n) {
                    var r = this.relative(this._current);
                    n = void 0 === n ? this._items.length : this.normalize(n, !0), i = i instanceof e ? i : t(i), this.trigger("add", {
                        content: i,
                        position: n
                    }), i = this.prepare(i), 0 === this._items.length || n === this._items.length ? (0 === this._items.length && this.$stage.append(i), 0 !== this._items.length && this._items[n - 1].after(i), this._items.push(i), this._mergers.push(1 * i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[n].before(i), this._items.splice(n, 0, i), this._mergers.splice(n, 0, 1 * i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[r] && this.reset(this._items[r].index()), this.invalidate("items"), this.trigger("added", {
                        content: i,
                        position: n
                    })
                }, o.prototype.remove = function(t) {
                    void 0 !== (t = this.normalize(t, !0)) && (this.trigger("remove", {
                        content: this._items[t],
                        position: t
                    }), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {
                        content: null,
                        position: t
                    }))
                }, o.prototype.preloadAutoWidthImages = function(e) {
                    e.each(t.proxy(function(e, i) {
                        this.enter("pre-loading"), i = t(i), t(new Image).one("load", t.proxy(function(t) {
                            i.attr("src", t.target.src), i.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh()
                        }, this)).attr("src", i.attr("src") || i.attr("data-src") || i.attr("data-src-retina"))
                    }, this))
                }, o.prototype.destroy = function() {
                    for (var e in this.$element.off(".gowl.core"), this.$stage.off(".gowl.core"), t(r).off(".gowl.core"), !1 !== this.settings.responsive && (n.clearTimeout(this.resizeTimer), this.off(n, "resize", this._handlers.onThrottledResize)), this._plugins) this._plugins[e].destroy();
                    this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("gowl.carousel")
                }, o.prototype.op = function(t, e, i) {
                    var n = this.settings.rtl;
                    switch (e) {
                        case "<":
                            return n ? t > i : t < i;
                        case ">":
                            return n ? t < i : t > i;
                        case ">=":
                            return n ? t <= i : t >= i;
                        case "<=":
                            return n ? t >= i : t <= i
                    }
                }, o.prototype.on = function(t, e, i, n) {
                    t.addEventListener ? t.addEventListener(e, i, n) : t.attachEvent && t.attachEvent("on" + e, i)
                }, o.prototype.off = function(t, e, i, n) {
                    t.removeEventListener ? t.removeEventListener(e, i, n) : t.detachEvent && t.detachEvent("on" + e, i)
                }, o.prototype.trigger = function(e, i, n, r, s) {
                    var a = {
                            item: {
                                count: this._items.length,
                                index: this.current()
                            }
                        },
                        l = t.camelCase(t.grep(["on", e, n], function(t) {
                            return t
                        }).join("-").toLowerCase()),
                        u = t.Event([e, "gowl", n || "carousel"].join(".").toLowerCase(), t.extend({
                            relatedTarget: this
                        }, a, i));
                    return this._supress[e] || (t.each(this._plugins, function(t, e) {
                        e.onTrigger && e.onTrigger(u)
                    }), this.register({
                        type: o.Type.Event,
                        name: e
                    }), this.$element.trigger(u), this.settings && "function" == typeof this.settings[l] && this.settings[l].call(this, u)), u
                }, o.prototype.enter = function(e) {
                    t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
                        void 0 === this._states.current[e] && (this._states.current[e] = 0), this._states.current[e]++
                    }, this))
                }, o.prototype.leave = function(e) {
                    t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
                        this._states.current[e]--
                    }, this))
                }, o.prototype.register = function(e) {
                    if (e.type === o.Type.Event) {
                        if (t.event.special[e.name] || (t.event.special[e.name] = {}), !t.event.special[e.name].gowl) {
                            var i = t.event.special[e.name]._default;
                            t.event.special[e.name]._default = function(t) {
                                return !i || !i.apply || t.namespace && -1 !== t.namespace.indexOf("gowl") ? t.namespace && t.namespace.indexOf("gowl") > -1 : i.apply(this, arguments)
                            }, t.event.special[e.name].gowl = !0
                        }
                    } else e.type === o.Type.State && (this._states.tags[e.name] ? this._states.tags[e.name] = this._states.tags[e.name].concat(e.tags) : this._states.tags[e.name] = e.tags, this._states.tags[e.name] = t.grep(this._states.tags[e.name], t.proxy(function(i, n) {
                        return t.inArray(i, this._states.tags[e.name]) === n
                    }, this)))
                }, o.prototype.suppress = function(e) {
                    t.each(e, t.proxy(function(t, e) {
                        this._supress[e] = !0
                    }, this))
                }, o.prototype.release = function(e) {
                    t.each(e, t.proxy(function(t, e) {
                        delete this._supress[e]
                    }, this))
                }, o.prototype.pointer = function(t) {
                    var e = {
                        x: null,
                        y: null
                    };
                    return (t = (t = t.originalEvent || t || n.event).touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t).pageX ? (e.x = t.pageX, e.y = t.pageY) : (e.x = t.clientX, e.y = t.clientY), e
                }, o.prototype.isNumeric = function(t) {
                    return !isNaN(parseFloat(t))
                }, o.prototype.difference = function(t, e) {
                    return {
                        x: t.x - e.x,
                        y: t.y - e.y
                    }
                }, t.fn.globoOwlCarousel = function(e) {
                    var n = Array.prototype.slice.call(arguments, 1);
                    return this.each(function() {
                        var r = t(this),
                            s = r.data("gowl.carousel");
                        s || (s = new o(this, "object" == i(e) && e), r.data("gowl.carousel", s), t.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(e, i) {
                            s.register({
                                type: o.Type.Event,
                                name: i
                            }), s.$element.on(i + ".gowl.carousel.core", t.proxy(function(t) {
                                t.namespace && t.relatedTarget !== this && (this.suppress([i]), s[i].apply(this, [].slice.call(arguments, 1)), this.release([i]))
                            }, s))
                        })), "string" == typeof e && "_" !== e.charAt(0) && s[e].apply(s, n)
                    })
                }, t.fn.globoOwlCarousel.Constructor = o
            }(window.Zepto || t, window, document),
            function(t, e, i, n) {
                var r = function e(i) {
                    this._core = i, this._interval = null, this._visible = null, this._handlers = {
                        "initialized.gowl.carousel": t.proxy(function(t) {
                            t.namespace && this._core.settings.autoRefresh && this.watch()
                        }, this)
                    }, this._core.options = t.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers)
                };
                r.Defaults = {
                    autoRefresh: !0,
                    autoRefreshInterval: 500
                }, r.prototype.watch = function() {
                    this._interval || (this._visible = this._core.isVisible(), this._interval = e.setInterval(t.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
                }, r.prototype.refresh = function() {
                    this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("gowl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
                }, r.prototype.destroy = function() {
                    var t, i;
                    for (t in e.clearInterval(this._interval), this._handlers) this._core.$element.off(t, this._handlers[t]);
                    for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
                }, t.fn.globoOwlCarousel.Constructor.Plugins.AutoRefresh = r
            }(window.Zepto || t, window, document),
            function(t, e, i, n) {
                var r = function e(i) {
                    this._core = i, this._loaded = [], this._handlers = {
                        "initialized.gowl.carousel change.gowl.carousel resized.gowl.carousel": t.proxy(function(e) {
                            if (e.namespace && this._core.settings && this._core.settings.lazyLoad && (e.property && "position" == e.property.name || "initialized" == e.type)) {
                                var i = this._core.settings,
                                    n = i.center && Math.ceil(i.items / 2) || i.items,
                                    r = i.center && -1 * n || 0,
                                    s = (e.property && void 0 !== e.property.value ? e.property.value : this._core.current()) + r,
                                    o = this._core.clones().length,
                                    a = t.proxy(function(t, e) {
                                        this.load(e)
                                    }, this);
                                for (i.lazyLoadEager > 0 && (n += i.lazyLoadEager, i.loop && (s -= i.lazyLoadEager, n++)); r++ < n;) this.load(o / 2 + this._core.relative(s)), o && t.each(this._core.clones(this._core.relative(s)), a), s++
                            }
                        }, this)
                    }, this._core.options = t.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers)
                };
                r.Defaults = {
                    lazyLoad: !1,
                    lazyLoadEager: 0
                }, r.prototype.load = function(i) {
                    var n = this._core.$stage.children().eq(i),
                        r = n && n.find(".gowl-lazy");
                    !r || t.inArray(n.get(0), this._loaded) > -1 || (r.each(t.proxy(function(i, n) {
                        var r, s = t(n),
                            o = e.devicePixelRatio > 1 && s.attr("data-src-retina") || s.attr("data-src") || s.attr("data-srcset");
                        this._core.trigger("load", {
                            element: s,
                            url: o
                        }, "lazy"), s.is("img") ? s.one("load.gowl.lazy", t.proxy(function() {
                            s.css("opacity", 1), this._core.trigger("loaded", {
                                element: s,
                                url: o
                            }, "lazy")
                        }, this)).attr("src", o) : s.is("source") ? s.one("load.gowl.lazy", t.proxy(function() {
                            this._core.trigger("loaded", {
                                element: s,
                                url: o
                            }, "lazy")
                        }, this)).attr("srcset", o) : ((r = new Image).onload = t.proxy(function() {
                            s.css({
                                "background-image": 'url("' + o + '")',
                                opacity: "1"
                            }), this._core.trigger("loaded", {
                                element: s,
                                url: o
                            }, "lazy")
                        }, this), r.src = o)
                    }, this)), this._loaded.push(n.get(0)))
                }, r.prototype.destroy = function() {
                    var t, e;
                    for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
                    for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
                }, t.fn.globoOwlCarousel.Constructor.Plugins.Lazy = r
            }(window.Zepto || t, window, document),
            function(t, e, i, n) {
                var r = function i(n) {
                    this._core = n, this._previousHeight = null, this._handlers = {
                        "initialized.gowl.carousel refreshed.gowl.carousel": t.proxy(function(t) {
                            t.namespace && this._core.settings.autoHeight && this.update()
                        }, this),
                        "changed.gowl.carousel": t.proxy(function(t) {
                            t.namespace && this._core.settings.autoHeight && "position" === t.property.name && this.update()
                        }, this),
                        "loaded.gowl.lazy": t.proxy(function(t) {
                            t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
                        }, this)
                    }, this._core.options = t.extend({}, i.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null;
                    var r = this;
                    t(e).on("load", function() {
                        r._core.settings.autoHeight && r.update()
                    }), t(e).resize(function() {
                        r._core.settings.autoHeight && (null != r._intervalId && clearTimeout(r._intervalId), r._intervalId = setTimeout(function() {
                            r.update()
                        }, 250))
                    })
                };
                r.Defaults = {
                    autoHeight: !1,
                    autoHeightClass: "gowl-height"
                }, r.prototype.update = function() {
                    var e = this._core._current,
                        i = e + this._core.settings.items,
                        n = this._core.settings.lazyLoad,
                        r = this._core.$stage.children().toArray().slice(e, i),
                        s = [],
                        o = 0;
                    t.each(r, function(e, i) {
                        s.push(t(i).height())
                    }), (o = Math.max.apply(null, s)) <= 1 && n && this._previousHeight && (o = this._previousHeight), this._previousHeight = o, this._core.$stage.parent().height(o).addClass(this._core.settings.autoHeightClass)
                }, r.prototype.destroy = function() {
                    var t, e;
                    for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
                    for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
                }, t.fn.globoOwlCarousel.Constructor.Plugins.AutoHeight = r
            }(window.Zepto || t, window, document),
            function(t, e, i, n) {
                var r = function e(i) {
                    this._core = i, this._videos = {}, this._playing = null, this._handlers = {
                        "initialized.gowl.carousel": t.proxy(function(t) {
                            t.namespace && this._core.register({
                                type: "state",
                                name: "playing",
                                tags: ["interacting"]
                            })
                        }, this),
                        "resize.gowl.carousel": t.proxy(function(t) {
                            t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
                        }, this),
                        "refreshed.gowl.carousel": t.proxy(function(t) {
                            t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .gowl-video-frame").remove()
                        }, this),
                        "changed.gowl.carousel": t.proxy(function(t) {
                            t.namespace && "position" === t.property.name && this._playing && this.stop()
                        }, this),
                        "prepared.gowl.carousel": t.proxy(function(e) {
                            if (e.namespace) {
                                var i = t(e.content).find(".gowl-video");
                                i.length && (i.css("display", "none"), this.fetch(i, t(e.content)))
                            }
                        }, this)
                    }, this._core.options = t.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.gowl.video", ".gowl-video-play-icon", t.proxy(function(t) {
                        this.play(t)
                    }, this))
                };
                r.Defaults = {
                    video: !1,
                    videoHeight: !1,
                    videoWidth: !1
                }, r.prototype.fetch = function(t, e) {
                    var i = t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube",
                        n = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id"),
                        r = t.attr("data-width") || this._core.settings.videoWidth,
                        s = t.attr("data-height") || this._core.settings.videoHeight,
                        o = t.attr("href");
                    if (!o) throw new Error("Missing video URL.");
                    if ((n = o.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu") > -1) i = "youtube";
                    else if (n[3].indexOf("vimeo") > -1) i = "vimeo";
                    else {
                        if (!(n[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
                        i = "vzaar"
                    }
                    n = n[6], this._videos[o] = {
                        type: i,
                        id: n,
                        width: r,
                        height: s
                    }, e.attr("data-video", o), this.thumbnail(t, this._videos[o])
                }, r.prototype.thumbnail = function(e, i) {
                    var n, r, s = i.width && i.height ? "width:" + i.width + "px;height:" + i.height + "px;" : "",
                        o = e.find("img"),
                        a = "src",
                        l = "",
                        u = this._core.settings,
                        c = function(i) {
                            '<div class="gowl-video-play-icon"></div>',
                            n = u.lazyLoad ? t("<div/>", {
                                class: "gowl-video-tn " + l,
                                srcType: i
                            }) : t("<div/>", {
                                class: "gowl-video-tn",
                                style: "opacity:1;background-image:url(" + i + ")"
                            }),
                            e.after(n),
                            e.after('<div class="gowl-video-play-icon"></div>')
                        };
                    if (e.wrap(t("<div/>", {
                            class: "gowl-video-wrapper",
                            style: s
                        })), this._core.settings.lazyLoad && (a = "data-src", l = "gowl-lazy"), o.length) return c(o.attr(a)), o.remove(), !1;
                    "youtube" === i.type ? (r = "//img.youtube.com/vi/" + i.id + "/hqdefault.jpg", c(r)) : "vimeo" === i.type ? t.ajax({
                        type: "GET",
                        url: "//vimeo.com/api/v2/video/" + i.id + ".json",
                        jsonp: "callback",
                        dataType: "jsonp",
                        success: function(t) {
                            r = t[0].thumbnail_large, c(r)
                        }
                    }) : "vzaar" === i.type && t.ajax({
                        type: "GET",
                        url: "//vzaar.com/api/videos/" + i.id + ".json",
                        jsonp: "callback",
                        dataType: "jsonp",
                        success: function(t) {
                            r = t.framegrab_url, c(r)
                        }
                    })
                }, r.prototype.stop = function() {
                    this._core.trigger("stop", null, "video"), this._playing.find(".gowl-video-frame").remove(), this._playing.removeClass("gowl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
                }, r.prototype.play = function(e) {
                    var i, n = t(e.target).closest("." + this._core.settings.itemClass),
                        r = this._videos[n.attr("data-video")],
                        s = r.width || "100%",
                        o = r.height || this._core.$stage.height();
                    this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), n = this._core.items(this._core.relative(n.index())), this._core.reset(n.index()), (i = t('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", o), i.attr("width", s), "youtube" === r.type ? i.attr("src", "//www.youtube.com/embed/" + r.id + "?autoplay=1&rel=0&v=" + r.id) : "vimeo" === r.type ? i.attr("src", "//player.vimeo.com/video/" + r.id + "?autoplay=1") : "vzaar" === r.type && i.attr("src", "//view.vzaar.com/" + r.id + "/player?autoplay=true"), t(i).wrap('<div class="gowl-video-frame" />').insertAfter(n.find(".gowl-video")), this._playing = n.addClass("gowl-video-playing"))
                }, r.prototype.isInFullScreen = function() {
                    var e = i.fullscreenElement || i.mozFullScreenElement || i.webkitFullscreenElement;
                    return e && t(e).parent().hasClass("gowl-video-frame")
                }, r.prototype.destroy = function() {
                    var t, e;
                    for (t in this._core.$element.off("click.gowl.video"), this._handlers) this._core.$element.off(t, this._handlers[t]);
                    for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
                }, t.fn.globoOwlCarousel.Constructor.Plugins.Video = r
            }(window.Zepto || t, window, document), n = window.Zepto || t, window, document, (r = function t(e) {
                    this.core = e, this.core.options = n.extend({}, t.Defaults, this.core.options), this.swapping = !0, this.previous = void 0, this.next = void 0, this.handlers = {
                        "change.gowl.carousel": n.proxy(function(t) {
                            t.namespace && "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
                        }, this),
                        "drag.gowl.carousel dragged.gowl.carousel translated.gowl.carousel": n.proxy(function(t) {
                            t.namespace && (this.swapping = "translated" == t.type)
                        }, this),
                        "translate.gowl.carousel": n.proxy(function(t) {
                            t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
                        }, this)
                    }, this.core.$element.on(this.handlers)
                }).Defaults = {
                    animateOut: !1,
                    animateIn: !1
                }, r.prototype.swap = function() {
                    if (1 === this.core.settings.items && n.support.animation && n.support.transition) {
                        this.core.speed(0);
                        var t, e = n.proxy(this.clear, this),
                            i = this.core.$stage.children().eq(this.previous),
                            r = this.core.$stage.children().eq(this.next),
                            s = this.core.settings.animateIn,
                            o = this.core.settings.animateOut;
                        this.core.current() !== this.previous && (o && (t = this.core.coordinates(this.previous) - this.core.coordinates(this.next), i.one(n.support.animation.end, e).css({
                            left: t + "px"
                        }).addClass("animated gowl-animated-out").addClass(o)), s && r.one(n.support.animation.end, e).addClass("animated gowl-animated-in").addClass(s))
                    }
                }, r.prototype.clear = function(t) {
                    n(t.target).css({
                        left: ""
                    }).removeClass("animated gowl-animated-out gowl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
                }, r.prototype.destroy = function() {
                    var t, e;
                    for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
                    for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
                }, n.fn.globoOwlCarousel.Constructor.Plugins.Animate = r,
                function(t, e, i, n) {
                    var r = function e(i) {
                        this._core = i, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, this._handlers = {
                            "changed.gowl.carousel": t.proxy(function(t) {
                                t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._paused && (this._time = 0)
                            }, this),
                            "initialized.gowl.carousel": t.proxy(function(t) {
                                t.namespace && this._core.settings.autoplay && this.play()
                            }, this),
                            "play.gowl.autoplay": t.proxy(function(t, e, i) {
                                t.namespace && this.play(e, i)
                            }, this),
                            "stop.gowl.autoplay": t.proxy(function(t) {
                                t.namespace && this.stop()
                            }, this),
                            "mouseover.gowl.autoplay": t.proxy(function() {
                                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
                            }, this),
                            "mouseleave.gowl.autoplay": t.proxy(function() {
                                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
                            }, this),
                            "touchstart.gowl.core": t.proxy(function() {
                                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
                            }, this),
                            "touchend.gowl.core": t.proxy(function() {
                                this._core.settings.autoplayHoverPause && this.play()
                            }, this)
                        }, this._core.$element.on(this._handlers), this._core.options = t.extend({}, e.Defaults, this._core.options)
                    };
                    r.Defaults = {
                        autoplay: !1,
                        autoplayTimeout: 5e3,
                        autoplayHoverPause: !1,
                        autoplaySpeed: !1
                    }, r.prototype._next = function(n) {
                        this._call = e.setTimeout(t.proxy(this._next, this, n), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || i.hidden || this._core.next(n || this._core.settings.autoplaySpeed)
                    }, r.prototype.read = function() {
                        return (new Date).getTime() - this._time
                    }, r.prototype.play = function(i, n) {
                        var r;
                        this._core.is("rotating") || this._core.enter("rotating"), i = i || this._core.settings.autoplayTimeout, r = Math.min(this._time % (this._timeout || i), i), this._paused ? (this._time = this.read(), this._paused = !1) : e.clearTimeout(this._call), this._time += this.read() % i - r, this._timeout = i, this._call = e.setTimeout(t.proxy(this._next, this, n), i - r)
                    }, r.prototype.stop = function() {
                        this._core.is("rotating") && (this._time = 0, this._paused = !0, e.clearTimeout(this._call), this._core.leave("rotating"))
                    }, r.prototype.pause = function() {
                        this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, e.clearTimeout(this._call))
                    }, r.prototype.destroy = function() {
                        var t, e;
                        for (t in this.stop(), this._handlers) this._core.$element.off(t, this._handlers[t]);
                        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
                    }, t.fn.globoOwlCarousel.Constructor.Plugins.autoplay = r
                }(window.Zepto || t, window, document),
                function(t, e, i, n) {
                    "use strict";
                    var r = function e(i) {
                        this._core = i, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
                            next: this._core.next,
                            prev: this._core.prev,
                            to: this._core.to
                        }, this._handlers = {
                            "prepared.gowl.carousel": t.proxy(function(e) {
                                e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + t(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
                            }, this),
                            "added.gowl.carousel": t.proxy(function(t) {
                                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
                            }, this),
                            "remove.gowl.carousel": t.proxy(function(t) {
                                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
                            }, this),
                            "changed.gowl.carousel": t.proxy(function(t) {
                                t.namespace && "position" == t.property.name && this.draw()
                            }, this),
                            "initialized.gowl.carousel": t.proxy(function(t) {
                                t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
                            }, this),
                            "refreshed.gowl.carousel": t.proxy(function(t) {
                                t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
                            }, this)
                        }, this._core.options = t.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers)
                    };
                    r.Defaults = {
// BANANALAB removed the nav button (changed nav: !1 and commented the other nav parameters)
                        nav: 0,
//                         navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
//                         navSpeed: !1,
//                         navElement: 'button type="button" role="presentation"',
//                         navContainer: !1,
//                         navContainerClass: "gowl-nav",
//                         navClass: ["gowl-prev", "gowl-next"],
                        slideBy: 1,
                        dotClass: "gowl-dot",
                        dotsClass: "gowl-dots",
                        dots: !1,
                        dotsEach: !1,
                        dotsData: !1,
                        dotsSpeed: !1,
                        dotsContainer: !1
                    }, r.prototype.initialize = function() {
                        var e, i = this._core.settings;
                        for (e in this._controls.$relative = (i.navContainer ? t(i.navContainer) : t("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = t("<" + i.navElement + ">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click", t.proxy(function(t) {
                                this.prev(i.navSpeed)
                            }, this)), this._controls.$next = t("<" + i.navElement + ">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click", t.proxy(function(t) {
                                this.next(i.navSpeed)
                            }, this)), i.dotsData || (this._templates = [t('<button role="button">').addClass(i.dotClass).append(t("<span>")).prop("outerHTML")]), this._controls.$absolute = (i.dotsContainer ? t(i.dotsContainer) : t("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", t.proxy(function(e) {
                                var n = t(e.target).parent().is(this._controls.$absolute) ? t(e.target).index() : t(e.target).parent().index();
                                e.preventDefault(), this.to(n, i.dotsSpeed)
                            }, this)), this._overrides) this._core[e] = t.proxy(this[e], this)
                    }, r.prototype.destroy = function() {
                        var t, e, i, n, r;
                        for (t in r = this._core.settings, this._handlers) this.$element.off(t, this._handlers[t]);
                        for (e in this._controls) "$relative" === e && r.navContainer ? this._controls[e].html("") : this._controls[e].remove();
                        for (n in this.overides) this._core[n] = this._overrides[n];
                        for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
                    }, r.prototype.update = function() {
                        var t, e, i = this._core.clones().length / 2,
                            n = i + this._core.items().length,
                            r = this._core.maximum(!0),
                            s = this._core.settings,
                            o = s.center || s.autoWidth || s.dotsData ? 1 : s.dotsEach || s.items;
                        if ("page" !== s.slideBy && (s.slideBy = Math.min(s.slideBy, s.items)), s.dots || "page" == s.slideBy)
                            for (this._pages = [], t = i, e = 0, 0; t < n; t++) {
                                if (e >= o || 0 === e) {
                                    if (this._pages.push({
                                            start: Math.min(r, t - i),
                                            end: t - i + o - 1
                                        }), Math.min(r, t - i) === r) break;
                                    e = 0, 0
                                }
                                e += this._core.mergers(this._core.relative(t))
                            }
                    }, r.prototype.draw = function() {
                        var e, i = this._core.settings,
                            n = this._core.items().length <= i.items,
                            r = this._core.relative(this._core.current()),
                            s = i.loop || i.rewind;
                        this._controls.$relative.toggleClass("disabled", !i.nav || n), i.nav && (this._controls.$previous.toggleClass("disabled", !s && r <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !s && r >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !i.dots || n), i.dots && (e = this._pages.length - this._controls.$absolute.children().length, i.dotsData && 0 !== e ? this._controls.$absolute.html(this._templates.join("")) : e > 0 ? this._controls.$absolute.append(new Array(e + 1).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(t.inArray(this.current(), this._pages)).addClass("active"))
                    }, r.prototype.onTrigger = function(e) {
                        var i = this._core.settings;
                        e.page = {
                            index: t.inArray(this.current(), this._pages),
                            count: this._pages.length,
                            size: i && (i.center || i.autoWidth || i.dotsData ? 1 : i.dotsEach || i.items)
                        }
                    }, r.prototype.current = function() {
                        var e = this._core.relative(this._core.current());
                        return t.grep(this._pages, t.proxy(function(t, i) {
                            return t.start <= e && t.end >= e
                        }, this)).pop()
                    }, r.prototype.getPosition = function(e) {
                        var i, n, r = this._core.settings;
                        return "page" == r.slideBy ? (i = t.inArray(this.current(), this._pages), n = this._pages.length, e ? ++i : --i, i = this._pages[(i % n + n) % n].start) : (i = this._core.relative(this._core.current()), n = this._core.items().length, e ? i += r.slideBy : i -= r.slideBy), i
                    }, r.prototype.next = function(e) {
                        t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
                    }, r.prototype.prev = function(e) {
                        t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
                    }, r.prototype.to = function(e, i, n) {
                        var r;
                        !n && this._pages.length ? (r = this._pages.length, t.proxy(this._overrides.to, this._core)(this._pages[(e % r + r) % r].start, i)) : t.proxy(this._overrides.to, this._core)(e, i)
                    }, t.fn.globoOwlCarousel.Constructor.Plugins.Navigation = r
                }(window.Zepto || t, window, document),
                function(t, e, i, n) {
                    "use strict";
                    var r = function i(n) {
                        this._core = n, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
                            "initialized.gowl.carousel": t.proxy(function(i) {
                                i.namespace && "URLHash" === this._core.settings.startPosition && t(e).trigger("hashchange.gowl.navigation")
                            }, this),
                            "prepared.gowl.carousel": t.proxy(function(e) {
                                if (e.namespace) {
                                    var i = t(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                                    if (!i) return;
                                    this._hashes[i] = e.content
                                }
                            }, this),
                            "changed.gowl.carousel": t.proxy(function(i) {
                                if (i.namespace && "position" === i.property.name) {
                                    var n = this._core.items(this._core.relative(this._core.current())),
                                        r = t.map(this._hashes, function(t, e) {
                                            return t === n ? e : null
                                        }).join();
                                    if (!r || e.location.hash.slice(1) === r) return;
                                    e.location.hash = r
                                }
                            }, this)
                        }, this._core.options = t.extend({}, i.Defaults, this._core.options), this.$element.on(this._handlers), t(e).on("hashchange.gowl.navigation", t.proxy(function(t) {
                            var i = e.location.hash.substring(1),
                                n = this._core.$stage.children(),
                                r = this._hashes[i] && n.index(this._hashes[i]);
                            void 0 !== r && r !== this._core.current() && this._core.to(this._core.relative(r), !1, !0)
                        }, this))
                    };
                    r.Defaults = {
                        URLhashListener: !1
                    }, r.prototype.destroy = function() {
                        var i, n;
                        for (i in t(e).off("hashchange.gowl.navigation"), this._handlers) this._core.$element.off(i, this._handlers[i]);
                        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
                    }, t.fn.globoOwlCarousel.Constructor.Plugins.Hash = r
                }(window.Zepto || t, window, document),
                function(t, e, i, n) {
                    var r = t("<support>").get(0).style,
                        s = "Webkit Moz O ms".split(" "),
                        o = {
                            transition: {
                                end: {
                                    WebkitTransition: "webkitTransitionEnd",
                                    MozTransition: "transitionend",
                                    OTransition: "oTransitionEnd",
                                    transition: "transitionend"
                                }
                            },
                            animation: {
                                end: {
                                    WebkitAnimation: "webkitAnimationEnd",
                                    MozAnimation: "animationend",
                                    OAnimation: "oAnimationEnd",
                                    animation: "animationend"
                                }
                            }
                        },
                        a = function() {
                            return !!c("transform")
                        },
                        l = function() {
                            return !!c("perspective")
                        },
                        u = function() {
                            return !!c("animation")
                        };

                    function c(e, i) {
                        var o = !1,
                            a = e.charAt(0).toUpperCase() + e.slice(1);
                        return t.each((e + " " + s.join(a + " ") + a).split(" "), function(t, e) {
                            if (r[e] !== n) return o = !i || e, !1
                        }), o
                    }

                    function d(t) {
                        return c(t, !0)
                    }(function() {
                        return !!c("transition")
                    })() && (t.support.transition = new String(d("transition")), t.support.transition.end = o.transition.end[t.support.transition]), u() && (t.support.animation = new String(d("animation")), t.support.animation.end = o.animation.end[t.support.animation]), a() && (t.support.transform = new String(d("transform")), t.support.transform3d = l())
                }(window.Zepto || t, window, document)
        }).call(this, i(7), i(7))
    }
});